/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module
	 */
	__webpack_require__(1);
	
	/**
	 * Constants
	 */
	__webpack_require__(2);
	
	/**
	 * Directives
	 */
	__webpack_require__(3);
	__webpack_require__(4);
	__webpack_require__(5);
	__webpack_require__(6);
	__webpack_require__(7);
	__webpack_require__(8);
	__webpack_require__(9);
	__webpack_require__(10);
	__webpack_require__(11);
	__webpack_require__(12);
	
	/**
	 * Components
	 */
	__webpack_require__(13);
	__webpack_require__(14);
	__webpack_require__(15);
	
	__webpack_require__(16);
	
	__webpack_require__(17);
	
	__webpack_require__(18);
	__webpack_require__(19);
	__webpack_require__(20);
	
	__webpack_require__(21);
	__webpack_require__(22);
	__webpack_require__(23);
	
	__webpack_require__(24);
	
	__webpack_require__(25);
	
	__webpack_require__(26);
	__webpack_require__(27);
	__webpack_require__(28);
	__webpack_require__(29);
	__webpack_require__(30);
	
	/**
	 * Services
	 */
	__webpack_require__(31);
	__webpack_require__(32);
	__webpack_require__(33);
	__webpack_require__(34);
	__webpack_require__(35);
	__webpack_require__(36);
	__webpack_require__(37);
	__webpack_require__(38);
	
	__webpack_require__(39);
	__webpack_require__(40);
	
	/**
	 * Run
	 */
	__webpack_require__(41);
	
	/**
	 * Config
	 */
	__webpack_require__(42);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc overview
	 * @name cbl.insuranceloanpmi.mf
	 * @description Modulo funzionale dell'applicazione Credito Assicurativo PMI
	 */
	(function() {
		"use strict";
		angular.module("cbl.insuranceloanpmi.mf", [ 'ui.grid', 'ui.grid.autoResize', 'ui.grid.cellNav', 'ui.grid.edit', 'ui.grid.exporter', 'ui.grid.grouping',
				'ui.grid.pagination', 'ui.grid.resizeColumns', 'ui.grid.rowEdit', 'ui.grid.selection', 'ui.grid.treeView', 'ui.router', 'ui.bootstrap',
				'cbl.insuranceloanpmi.mf.directives', 'cbl.common' ]);
	}())

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	(function (window, undefined) {
	  'use strict';
	  var scripts = document.getElementsByTagName('script');
	  var baseRoot = 'CBL-INSURANCELOANPMI-MF';
	  for (var el in scripts) {
	    if (scripts[el].src && scripts[el].src.indexOf('INSURANCELOANPMI') > -1) {
	      baseRoot = scripts[el].src.split('/')[3];
	    }
	  }
	  angular.module('cbl.insuranceloanpmi.mf').constant('CONSTANTS', {
	    BASE_ROOT: '/' + baseRoot + '/app/',
	    REST_ROOT: '/' + baseRoot + '/services/api-',
	    REST_CLIENTI_ROOT: '/MSF-PROSPECTMANAGER-MF/api/',
	    COMPONENTS_PATH: 'components/',
	
	    FUNA: {},
	
	    REST: {
	      GENERAL: {
	        LABEL: 'generale/label',
	        FUNA: 'generale/funa',
	        TAB: 'generale/tab',
	        USER: 'generale/utente',
	        LOG: 'generale/log',
	        DOMAIN: 'generale/dominio',
	        FIELDCONFIGURATOR: 'generale/fieldConfigurator',
	      },
	      CLIENTI: {
	        DETTAGLIO: 'cliente/cliente/',
	        DETTAGLIO_CERCA: 'cliente/cliente/dettaglio',
	        DETTAGLIO_INTEGRAZIONE: 'cliente/cliente/integrazione',
	        RICERCA: {
	          BANCA: 'cliente/cliente/ricerca/banca',
	          CERVED: 'cliente/cliente/ricerca/cerved',
	        },
	        INTEGRAZIONE: {
	          CLIENTE: 'cliente/cliente/integrazione',
	          FIRMATARI: 'cliente/cliente/firmatari/integrazione',
	        },
	        CREA_DA_CERVED: 'cliente/cliente/ricerca/creaDaCerved',
	      },
	      PRATICHE: {
	        RICERCA: 'pratica/cerca',
	        DETTAGLIO: 'pratica/pratiche/',
	      },
	      AFFIDAMENTI: {
	        FIDO: 'fido/fidi/',
	        FIDOPERNDG: 'fido/fidi/ndg/',
	      },
	      DETTAGLIO_CONTO: 'fido/dettaglioConto',
	      FASCEAFFIDAMENTO: 'fascia-affidamento/fasce',
	      CONVENZIONI: 'convenzione/convenzioni',
	      TITOLI: 'finanziamenti/titoli',
	      FINANZIAMENTI: 'finanziamenti/finanziamenti',
	      PERSONAFISICA: {
	        ACCETTA: 'NaturalPerson/Accept',
	        ACCETTASENZAWCL: 'NaturalPerson/AcceptWithoutWcl',
	      },
	      PERSONAGIURIDICA: {
	        ACCETTA: 'LegalPerson/Accept',
	        ACCETTASENZAWCL: 'LegalPerson/AcceptWithoutWcl',
	      },
	    },
	
	    STATI_PRATICA: [
	      'BOZZA',
	      'INCORSO',
	      'VALUTAZIONE',
	      'DEFINITA',
	      'CONSOLIDATA',
	      'GESTIONEPOLIZZE',
	      'INTEGRAZIONE',
	    ],
	  });
	})(window);


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/**
	 * 
	 */
	;
	(function(){
		"use strict";
		angular.module("cbl.insuranceloanpmi.mf.directives", ["cbl.common"]);
		
	}());

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	(function() {
		"use strict";
		angular.module("cbl.insuranceloanpmi.mf.directives").directive("creasSpinnerDrct", [ 'CONSTANTS', function( CONSTANTS) {
			var link = function (scope, elem, attrs, model) {};
			
			var controller = function($scope) {
				
				this.getSpinnerUrl = function() {
		            var url = null;
		            var currentScope = $scope;
		            do {
		                url = currentScope.srcSpinner;
		                currentScope = currentScope.$parent;
		            } while((url === undefined) && (currentScope !== null));
		            return url;
				};
	
			};
			
			controller.$inject = ['$scope'];
			return {
				restrict : "E",
				scope : { },
				templateUrl : CONSTANTS.BASE_ROOT + "widgets/creasSpinner/creasSpinner.html",
				controller : controller,
				controllerAs : 'spinner',
				link : link
			};
		}]);
	}());

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	/**
	 * 
	 */
	(function() {
		"use strict";
		angular.module("cbl.insuranceloanpmi.mf").directive(
				"creasFuna",
				[
						'CreasFunaSrvc',
						'LabelSrvc',
						'LoggerSrvc',
						'CONSTANTS',
						function(funaSrvc, labelSrvc, loggerSrvc, CONSTANTS) {
							var link = function(scope, elem, attrs, ctrl) {
	
							};
	
							var controller = function($scope) {
								$scope.funa = funaSrvc;
								$scope.msg = labelSrvc;
								$scope.getKey = function(funa) {
									return "funa.label." + funa.codice;
								};
							};
	
							controller.$inject = [ "$scope" ];
	
							return {
								restrict : "E",
								scope : {
									rightAlign : "=",
									finDisabled : "=?"
								},
								link : link,
								transclude : true,
								controller : controller,
								templateUrl : CONSTANTS.BASE_ROOT + "widgets/creasFuna/creasFuna.html"
							};
						} ]);
	}());

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/**
	 * 
	 */
	;
	(function(window, undefined) {
		"use strict";
		angular.module("cbl.insuranceloanpmi.mf").service("CreasFunaSrvc",
				[ '$http', '$q', 'CreasMessaggiFctr', 'LabelSrvc', 'LoggerSrvc', 'CONSTANTS', function($http, $q, messaggiFctr, labelSrvc, loggerSrvc, CONSTANTS) {
					// Esempio Driver
					this.driverFuna = {
						codForm : null,
						codAttivita : null,
						codAttributo : null,
						codStato : null,
						accessoFunzione : null,
						flRichiamato : null
					};
	
					this.openConfirm = false;
					this.confirmText = "";
					this.angForm = {};
					this.sottomesso = false;
					this.inEsecuzione = false;
	
					this.funaList = [];
					this.funaMap = {};
	
					this.executePreRelease = function(funa, params) {
					};
					this.executePostRelease = function(funa, fromPre) {
					};
					this.messagesConfirm = function(funa) {
					};
	
					this.setUpFuna = function(angForm, form, accesso, executePreRelease, executePostRelease, messagesConfirm, task, level) {
	
						this.reset(level);
	
						var defer = $q.defer();
						var driverFuna = {
							codForm : form,
							codAttivita : task ? task.codAttivita : null,
							flRichiamato : (task && task.richiamato !== null) ? task.richiamato === '1' : null,
							codStato : task ? task.stato : null,
							codAttributo : task ? task.attributo : null,
							accessoFunzione : accesso
						}
	
						var funaTask = {
							codAttivita : task.codAttivita,
							codProcesso : task.codProcesso,
							idAttivita : task.idAttivita,
							idTecnico : task.id
						};
						this.angForm = angForm;
						this.openConfirm = false;
						this.funaList[level] = [];
						executePreRelease = executePreRelease && typeof executePreRelease === "function" ? executePreRelease : this.executePreRelease;
						executePostRelease = executePostRelease && typeof executePostRelease === "function" ? executePostRelease : this.executePostRelease;
						messagesConfirm = messagesConfirm && typeof messagesConfirm === "function" ? messagesConfirm : this.messagesConfirm;
	
						var self = this;
						$http({
							method : "POST",
							url : CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.FUNA,
							data : driverFuna
						}).then(function(response) {
							if (messaggiFctr.processaResponse(response)) {
								return;
							}
							self.funaList[level] = response.data.result;
							for ( var i in self.funaList[level]) {
								self.funaList[level][i].task = funaTask;
								if (self.hasFunction(self.funaList[level][i].codice)) {
									// ERRORE!!!
									messaggiFctr.addMessage({
										type : "E",
										message : "Funzione duplicata! (" + self.funaList[level][i].codice + ")"
									});
									defer.reject(false);
									return;
								}
								self.funaList[level][i]["bean"] = {
									angForm : angForm,
									executePreRelease : executePreRelease,
									executePostRelease : executePostRelease,
									messagesConfirm : messagesConfirm
								}
								self.funaMap[self.funaList[level][i].codice] = self.funaList[level][i];
							}
							defer.resolve(true);
						}, function(reason) {
							messaggiFctr.processaResponse(reason);
							defer.resolve(false);
						});
						return defer.promise;
					};
	
					this.executeFuna = function(funa) {
						this.annullaFuna();
						this.sottomesso = true;
						messaggiFctr.resetMessages();
						if (!funa.noCheck && !messaggiFctr.processaForm(funa.bean.angForm)) {
							return;
						}
	
						if (funa.noCheck && !messaggiFctr.validaForm(funa.bean.angForm)) {
							return;
						}
	
						var params = {
							causale : "",
							pagamenti : [],
							params : []
						};
						var funaSelf = this;
						try {
							funaSelf.inEsecuzione = true;
							var fromPre = funa.bean.executePreRelease(funa, params);
							if (!fromPre) {
								fromPre = $q.when("");
							}
							fromPre.then(function(response) {
								var deferred = $q.defer();
								if (funa.outcome && funa.outcome.cod && funa.outcome.cod !== '') {
									funa.task.esito = funa.outcome.cod;
									funa.task.causale = params.causale;
									funa.task.pagamenti = params.pagamenti;
									$http({
										method : "POST",
										url : CONSTANTS.REST_ROOT + CONSTANTS.REST.WORKFLOW.TASK_EXECUTE,
										data : funa.task
									}).then(function(response) {
										if (messaggiFctr.processaResponse(response)) {
											deferred.reject("Errore registrato nel rilascio task");
											return;
										}
										funa.task.id = response.data.result;
										deferred.resolve(true);
									}, function(reason) {
										messaggiFctr.processaResponse(reason);
										deferred.reject("Errore (non registrato) nel rilascio task. Status chiamata: " + JSON.stringify(reason));
									});
								} else {
									deferred.resolve(true);
								}
								deferred.promise.then(function(funaResponse) {
									var fromPost = funa.bean.executePostRelease(funa, response);
									if (!fromPost) {
										fromPost = $q.when("");
									}
									fromPost.then(function(postResponse) {
										// END funa
										funaSelf.inEsecuzione = false;
									}, function(reason) {
										var e = {
											message : funa.codice + ": funzione post rilascio fallita! Errore: " + reason
										};
										loggerSrvc.log("CreasFunaSrvc", loggerSrvc.SEVERE, e.message);
										funaSelf.inEsecuzione = false;
										throw e;
									})
								}, function(reason) {
									var e = {
										message : funa.codice + ": rilascio task con esito [" + funa.outcome.cod + "] fallito! Errore: " + reason
									};
									loggerSrvc.log("CreasFunaSrvc", loggerSrvc.SEVERE, e.message);
									funaSelf.inEsecuzione = false;
									throw e;
								})
							}, function(reason) {
								var e = {
									message : funa.codice + ": funzione pre rilascio fallita! Errore: " + reason
								};
								loggerSrvc.log("CreasFunaSrvc", loggerSrvc.SEVERE, e.message);
								funaSelf.inEsecuzione = false;
								throw e;
							})
	
						} catch (e) {
							loggerSrvc.log("CreasFunaSrvc", loggerSrvc.SEVERE, e.message);
							funaSelf.inEsecuzione = false;
						}
					};
	
					this.openConfirmFuna = function(funa) {
						this.openConfirm = funa;
						this.sottomesso = true;
						messaggiFctr.resetMessages();
						if (funa.noCheck && messaggiFctr.processaForm(funa.bean.angForm)) {
							return;
						}
						if (!funa.noCheck && messaggiFctr.validaForm(funa.bean.angForm)) {
							return;
						}
						this.confirmText = funa.bean.messagesConfirm(funa);
						if (!this.confirmText) {
							this.confirmText = labelSrvc.getLabel("funa.confirm.default");
						}
						angular.element("#funaModal").modal("show");
					};
	
					this.hasFunction = function(codice) {
						return this.funaMap.hasOwnProperty(codice); // this.funaMap[codice] != null && this.funaMap[codice] != undefined;
					};
	
					this.executeButtonFuna = function(codice) {
						return this.executeFuna(this.funaMap[codice]);
					};
	
					this.annullaFuna = function() {
						this.openConfirm = false;
						angular.element("#funaModal").modal("hide");
					};
	
					this.getFunzioni = function() {
						var funcArray = [];
						for ( var i in this.funaList) {
							funcArray = funcArray.concat(this.funaList[i]);
						}
						return funcArray;
					};
	
					this.reset = function(level) {
						this.sottomesso = false;
						if (!level) {
							level = 0;
						}
						if (!this.funaList) {
							// Service non ancora inizializzato
							this.funaList = [];
							return;
						}
						if (this.funaList.length < level) {
							// Il livello non è presente
							return;
						}
						this.funaList.splice((level), (this.funaList.length - level));
						// Reset della mappa sulle liste rimaste
						this.funaMap = {};
						for ( var i in this.funaList) {
							var funaList = this.funaList[i];
							for ( var j in funaList) {
								this.funaMap[funaList[j].codice] = funaList[j];
							}
						}
					}
	
				} ]);
	}(window));

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	/**
	 *
	 */
	(function(window, undefined) {
		"use strict";
	
		angular.module("cbl.insuranceloanpmi.mf.directives").directive("creasNessunRisultatoDrct", ['CONSTANTS', function(CONSTANTS) {
			var link = function (scope, elem, attrs, model) {
	
			};
	
			var controller = function($scope, labelSrvc) {
				$scope.msg = labelSrvc.getLabel;
			};
	
			controller.$inject = ['$scope', 'LabelSrvc'];
	
			return {
				restrict: "E",
				scope: {
					msgCustom: '@',
					topMargin: '@'
				},
				controller: controller,
				controllerAs: "creasNessunRisultatoCtrl",
				templateUrl: CONSTANTS.BASE_ROOT + "widgets/creasNessunRisultato/creasNessunRisultato.html",
				link: link
			};
		}]);
	}(window));

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	/**
	 *@ngdoc directive
	 *@name cbl.insuranceloanpmi.mf.directive:creasTable
	 *@restrict E
	 *@scope
	 *@description Direttiva utilizzata per contenere lo ui-grid
	 *@param {Object} data - Oggetto contenente i dati dell tabella
	 *@param {Object} label - Oggetto contenente i parametri di configurazione della tabella
	 *@param {String} [messaggioCustom] - Messaggio personalizzato da far visualizzare al posto di quello standard
	 *@param {Boolean} [clickAbilitato] - Abilita o disabilita il click sugli elementi della tabella
	 *@param {Function} [apriPagina] - Funzione di callback scatenata sul click di una riga della tabella
	 */
	(function() {
		"use strict";
		angular.module("cbl.insuranceloanpmi.mf.directives").directive("creasTable", ['CONSTANTS', function(CONSTANTS) {
			var link = function (scope, elem, attrs, model) {
			};
	
			var controller = function($scope, $state, $stateParams, labelSrvc, uiGridConstants) {
				$scope.msg = labelSrvc.getLabel;
				this.$state = $state;
				this.$stateParams = $stateParams;
				this.uiGridConstants = uiGridConstants;
				var self = this;
				
				this.gridOptions = {
					enableSorting: true,
		            enableColumnMenus: false,
		            enableGrouping: false,
		            enableFiltering: true,
		            treeRowHeaderAlwaysVisible: false,
		            useExternalPagination: $scope.paginazioneEsterna ? $scope.paginazioneEsterna : false,
		            paginationPageSizes: [10, 25, 50],
		            paginationPageSize: 10,
		            paginationCurrentPage: 1,
		            enableRowSelection: true,
		            noUnselect: true,
		            multiSelect: false,
		            enableRowHeaderSelection: false,
		            showGridFooter: false,
		            enableVerticalScrollbar: this.uiGridConstants.scrollbars.NEVER,
		            enableColumnResizing: true,
		            columnDefs: $scope.label,
		            data: $scope.data,
		            onRegisterApi: function (gridApi) {
		            	self.gridApi = gridApi;
	            		self.gridApi.selection.on.rowSelectionChanged($scope, function(row) {
	        				$scope.apriPagina({row: row.entity});
	            		});
		            }
				};
				
				this.getTableHeight = function() {
			       var rowHeight = 30;
			       var headerHeight = 65;
			       var footerHeight = 35;
			       var totalItems = self.gridOptions.data && self.gridOptions.data.length ? self.gridOptions.data.length : 0;
			       
			       if (self.gridOptions.paginationPageSize !== totalItems) {
			    	   totalItems = self.gridOptions.paginationPageSize;
			       }
			       
			       return {
			          height: (totalItems * rowHeight + headerHeight + footerHeight) + "px"
			       };
			    };
			};
	
			controller.$inject = ['$scope', '$state', '$stateParams', 'LabelSrvc', 'uiGridConstants'];
	
			return {
				restrict: "E",
				scope: {
					data: '=',
					label: '=',
					messaggioCustom: '@?',
					clickAbilitato: '=?',
					apriPagina: '&?',
					paginazioneEsterna: '=?'
				},
				controller: controller,
				controllerAs: "creasTableCtrl",
				templateUrl: CONSTANTS.BASE_ROOT + "widgets/creasTable/creasTable.html",
				link: link
			};
		}]);
	}());

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.insuranceloanpmi.mf.directive:creasLuogoDataDoc
	 * @restrict E
	 * @description Widget che permette la scelta di un luogo e una data per la generazione dei documenti
	 * @param {function} formAccepted - Funzione eseguita quando si preme il pulsante "Completa" e i dati inseriti sono validi. I parametri disponibili sono "luogo" e "data"
	 */
	(function() {
		"use strict";
		angular.module("cbl.insuranceloanpmi.mf.directives").directive("creasLuogoDataDoc", [ 'CONSTANTS', function(CONSTANTS) {
			
			var controller = function($scope, labelSrvc) {
				$scope.msg = labelSrvc.getLabel;
				
				this.luogodoc = null;
				this.datadoc = null;
				
				this.dateOptions = {
	                formatDay: 'dd',
	                formatMonth: 'MM',
	                formatYear: 'yyyy',
	                startingDay: 1
	            };
				
				this.status = {
						opened: false
				};
	
				var self = this;
	
				/**
				 * @ngdoc method
				 * @name openCalendar
				 * @methodOf cbl.insuranceloanpmi.mf.directive:creasLuogoDataDoc
				 * @description Apre il selettore calendario per la scelta della data
				 */
	            this.openCalendar = function ($event) {
	                this.status.opened = true;
	            };
	            
	            /**
				 * @ngdoc method
				 * @name confirmData
				 * @methodOf cbl.insuranceloanpmi.mf.directive:creasLuogoDataDoc
				 * @description Esegue la verifica sui dati inseriti e lancia l'evento in output, passando tali valori se validi
				 */
	            this.confirmData = function () {
	            	
	            	if (!self.luogodoc) {
	            		return;
	            	}
	            	
	            	if (self.luogodoc.trim() === '') {
	            		return;
	            	}
	            	
	            	if (!self.datadoc) {
	            		return;
	            	}
	            	
	            	if (typeof $scope.formAccepted === 'function') {
	            		$scope.formAccepted({ luogo: self.luogodoc, data: self.datadoc });
	            	}
	            };
			};
	
			controller.$inject = ['$scope', 'LabelSrvc'];
			
			return {
				restrict : "E",
				scope : {
					formAccepted: '&'
				},
				templateUrl : CONSTANTS.BASE_ROOT + "widgets/creasLuogoDataDoc/creasLuogoDataDoc.html",
				controller: controller,
				controllerAs: "creasLuogoDataDocCtrl",
			};
		}]);
	}());

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.insuranceloanpmi.mf.directive:creasDettaglioAffidamento
	 * @restrict E
	 * @description Widget che visualizza i dati e lo stato dell'affidamento specificato, e permette l'esecuzione delle oeprazioni di blocco e sblocco
	 * @param {number} id-affidamento - Identificativo univoco dell'affidamento
	 */
	(function() {
		"use strict";
		angular.module("cbl.insuranceloanpmi.mf.directives").directive("creasDettaglioAffidamento", [ 'CONSTANTS', function(CONSTANTS) {
			
			var controller = function($scope, labelSrvc, $q, $http, $uibModal, CreasMessaggiFctr) {
				this.$uibModal = $uibModal;
				$scope.msg = labelSrvc.getLabel;
				
				this.pratica = null;
				this.spinner = {
					widget: false,
					operazione: false
				};
				
				var self = this;
				
				/**
				 * @ngdoc method
				 * @name promiseBloccoAffidamento
				 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioAffidamento
				 * @description Effettua una chiamata http per eseguire il blocco dell'affidamento specificato
				 * @return {Promise} - Ritorna una promise contenente l'esito del blocco
				 */
				this.promiseBloccoAffidamento = function() {    		
	    			return $http({
	    				method: 'GET',
	    				url: CONSTANTS.REST_ROOT + CONSTANTS.REST.AFFIDAMENTI.FIDO + self.pratica.fidoNonOperativo.idFidoNonOperativoPMI + '/blocca'
	    			});
	    		}
				
				/**
				 * @ngdoc method
				 * @name promiseSbloccoAffidamento
				 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioAffidamento
				 * @description Effettua una chiamata http per eseguire lo sblocco dell'affidamento specificato
				 * @return {Promise} - Ritorna una promise contenente l'esito dello sblocco
				 */
				this.promiseSbloccoAffidamento = function() {    		
	    			return $http({
	    				method: 'GET',
	    				url: CONSTANTS.REST_ROOT + CONSTANTS.REST.AFFIDAMENTI.FIDO + self.pratica.fidoNonOperativo.idFidoNonOperativoPMI + '/sblocca'
	    			});
	    		}
				
				/**
				 * @ngdoc method
				 * @name promiseAffidamento
				 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioAffidamento
				 * @description Effettua una chiamata http per recuperare i dati dell'affidamento specificato
				 * @return {Promise} - Ritorna una promise contenente i dati dell'affidamento specificato
				 */
				this.promiseAffidamento = function() {    		
	    			return $http({
	    				method: 'GET',
	    				url: CONSTANTS.REST_ROOT + CONSTANTS.REST.AFFIDAMENTI.FIDOPERNDG + $scope.ndg
	    			});
	    		}
	        	
				/**
				 * @ngdoc method
				 * @name caricaAffidamento
				 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioAffidamento
				 * @description Recupera i dati dell'affidamento specificato
				 */
				this.caricaAffidamento = function() {
					self.spinner.widget = true;
					
					if (!$scope.ndg) {
						self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.dettaglioaffidamento.nondg') });
						return;
					}
					
					$q.all({
						affidamento: self.promiseAffidamento(),
					}).then(function(response) {
						if (CreasMessaggiFctr.processaResponse(response.affidamento)) {
							self.pratica = null;
							return;
						}
						
						self.pratica  = response.affidamento.data.result;
					}, function(reason) {
						CreasMessaggiFctr.processaResponse(reason.affidamento);
						self.pratica = null;
					}).finally(function() {
						self.spinner.widget = false;
					});
				}
				
				/**
				 * @ngdoc method
				 * @name bloccaAffidamento
				 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioAffidamento
				 * @description Richiede conferma e, in caso affermativo, esegue il blocco dell'affidamento specificato
				 */
				this.bloccaAffidamento = function() {
					
					var modalController = function($scope, LabelSrvc, $modalInstance) {
	                	
	                	$scope.headerText = LabelSrvc.getLabel('label.dettaglioaffidamento.confirm.header');
	                	$scope.bodyText = LabelSrvc.getLabel('label.dettaglioaffidamento.confirm.blocco');
	                	$scope.cancelText = LabelSrvc.getLabel('button.dettaglioaffidamento.confirm.cancel');
	                	$scope.confirmText = LabelSrvc.getLabel('button.dettaglioaffidamento.confirm.confirm');
	                	
	                	$scope.optionSelected = function(result) {
	                		$modalInstance.close(result);
	                	}
	                	
	                };
	                
	                modalController.$inject = ['$scope', 'LabelSrvc', '$modalInstance'];
					
					var modalInstance = this.$uibModal.open({
		                animation: true,
		                template: '<creas-confirm-modal header-text="headerText" body-text="bodyText" cancel-text="cancelText" confirm-text="confirmText" option-selected="optionSelected(result)"></creas-confirm-modal>',
		                backdrop: 'static',
		                size: 'lg',
		                controller: modalController
		            });
					
					modalInstance.result.then(function (confirmResult) {
						
						if (confirmResult !== true) {
							return;
						}
						
						// Eseguo il blocco
						self.spinner.operazione = true;
						
						$q.all({
							affidamento: self.promiseBloccoAffidamento(),
						}).then(function(response) {
							if (CreasMessaggiFctr.processaResponse(response.affidamento)) {
								return;
							}
							
							if (response.affidamento.data && response.affidamento.data.result) {
								self.pratica  = response.affidamento.data.result;
							}
						}, function(reason) {
							CreasMessaggiFctr.processaResponse(reason.affidamento);
							self.caricaAffidamento();
						}).finally(function() {
							self.spinner.operazione = false;
						});
						
					});
					
				}
				
				/**
				 * @ngdoc method
				 * @name sbloccaAffidamento
				 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioAffidamento
				 * @description Richiede conferma e, in caso affermativo, esegue lo sblocco dell'affidamento specificato
				 */
				this.sbloccaAffidamento = function() {
					
					var modalController = function($scope, LabelSrvc, $modalInstance) {
	                	
	                	$scope.headerText = LabelSrvc.getLabel('label.dettaglioaffidamento.confirm.header');
	                	$scope.bodyText = LabelSrvc.getLabel('label.dettaglioaffidamento.confirm.sblocco');
	                	$scope.cancelText = LabelSrvc.getLabel('button.dettaglioaffidamento.confirm.cancel');
	                	$scope.confirmText = LabelSrvc.getLabel('button.dettaglioaffidamento.confirm.confirm');
	                	
	                	$scope.optionSelected = function(result) {
	                		$modalInstance.close(result);
	                	}
	                	
	                };
					
					modalController.$inject = ['$scope', 'LabelSrvc', '$modalInstance'];
					
					var modalInstance = this.$uibModal.open({
		                animation: true,
		                template: '<creas-confirm-modal header-text="headerText" body-text="bodyText" cancel-text="cancelText" confirm-text="confirmText" option-selected="optionSelected(result)"></creas-confirm-modal>',
		                backdrop: 'static',
		                size: 'lg',
		                controller: modalController
		            });
					
					modalInstance.result.then(function (confirmResult) {
						
						if (confirmResult !== true) {
							return;
						}
						
						// Eseguo lo sblocco
						self.spinner.operazione = true;
						
						$q.all({
							affidamento: self.promiseSbloccoAffidamento(),
						}).then(function(response) {
							if (CreasMessaggiFctr.processaResponse(response.affidamento)) {
								return;
							}
							
							if (response.affidamento.data && response.affidamento.data.result) {
								self.pratica  = response.affidamento.data.result;
							}
						}, function(reason) {
							CreasMessaggiFctr.processaResponse(reason.affidamento);
							self.caricaAffidamento();
						}).finally(function() {
							self.spinner.operazione = false;
						});
						
					});
					
				}
				
				self.caricaAffidamento();
				
			};
	
			controller.$inject = ['$scope', 'LabelSrvc', '$q', '$http', '$uibModal', 'CreasMessaggiFctr'];
			
			return {
				restrict : "E",
				scope : {
					ndg: '<'
				},
				templateUrl : CONSTANTS.BASE_ROOT + "widgets/creasDettaglioAffidamento/creasDettaglioAffidamento.html",
				controller: controller,
				controllerAs: "creasDettaglioAffidamentoCtrl",
			};
		}]);
	}());

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.insuranceloanpmi.mf.directive:creasConfirmModal
	 * @restrict E
	 * @description Widget che visualizza una finestra di conferma con pulsanti annulla / conferma. Opzionalmente è possibile specificare testi alternativi
	 * @param {string} headerText - Testo da visualizzare nell'intestazione al posto del testo standard
	 * @param {string} bodyText - Testo da visualizzare nel corpo della finestra al posto del testo standard
	 * @param {string} cancelText - Testo da visualizzare nel pulsante "Annulla" al posto del testo standard
	 * @param {string} confirmText - Testo da visualizzare nel pulsante "Conferma" al posto del testo standard
	 * @param {function} optionSelected - Funzione eseguita alla selezione di una delle opzioni tra "Annulla" o "Conferma"
	 */
	(function() {
		"use strict";
		angular.module("cbl.insuranceloanpmi.mf.directives").directive("creasConfirmModal", [ 'CONSTANTS', function(CONSTANTS) {
			
			var controller = function($scope, labelSrvc) {
				$scope.msg = labelSrvc.getLabel;
	
				if (!$scope.headerText) {
					$scope.headerText = $scope.msg('label.confirmmodal.header');
				}
				
				if (!$scope.bodyText) {
					$scope.bodyText = $scope.msg('label.confirmmodal.body');
				}
				
				if (!$scope.cancelText) {
					$scope.cancelText = $scope.msg('button.confirmmodal.cancel');
				}
				
				if (!$scope.confirmText) {
					$scope.confirmText = $scope.msg('button.confirmmodal.confirm');
				}
				
				var self = this;
	
	            /**
				 * @ngdoc method
				 * @name selectOption
				 * @methodOf cbl.insuranceloanpmi.mf.directive:creasConfirmModal
				 * @description Chiude la finestra di conferma, passando il valore selezionato alla callback "optionSelected" impostata
				 */
	            this.selectOption = function (optionValue) {            	
	            	if (typeof $scope.optionSelected === 'function') {
	            		$scope.optionSelected({ result: optionValue });
	            	}
	            };
			};
	
			controller.$inject = ['$scope', 'LabelSrvc'];
			
			return {
				restrict : "E",
				scope : {
					headerText: '<',
					bodyText: '<',
					cancelText: '<',
					confirmText: '<',
					optionSelected: '&'
				},
				templateUrl : CONSTANTS.BASE_ROOT + "widgets/creasConfirmModal/creasConfirmModal.html",
				controller: controller,
				controllerAs: "creasConfirmModalCtrl",
			};
		}]);
	}());

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	/**
	 *
	 */
	(function() {
		"use strict";
	
		angular.module("cbl.insuranceloanpmi.mf.directives").directive("creasIbanFormatter", ['CONSTANTS', function(CONSTANTS) {
			function linkFunc(scope, el, attr, ngModel) {
			    // For DOM -> model remove space
			    ngModel.$parsers.unshift(function (value) {
			      if (!value || value === '') {
			        return value;
			      }
			      value = String(value).replace(/ /g, '');
			      return value.slice(0, 27);
			    });
			 
			    // For model -> DOM convert decimal to comma
			    ngModel.$formatters.unshift(function (value) {
			      if (!value || value === '') {
			        return value;
			      }
			      // 2-2-1-5-5-12
			      // 2 - NAZIONE
			      if (value.length > 2 && value.charAt(2) !== ' ') {
			        value = value.substring(0, 2) + ' ' + value.substring(2);
			      }
			      // 2 - Controllo
			      if (value.length > 5 && value.charAt(5) !== ' ') {
			        value = value.substring(0, 5) + ' ' + value.substring(5);
			      }
			      // 1 - CIN
			      if (value.length > 7 && value.charAt(7) !== ' ') {
			        value = value.substring(0, 7) + ' ' + value.substring(7);
			      }
			      // 5 - ABI
			      if (value.length > 13 && value.charAt(13) !== ' ') {
			        value = value.substring(0, 13) + ' ' + value.substring(13);
			      }
			      // 5 - CAB
			      if (value.length > 19 && value.charAt(19) !== ' ') {
			        value = value.substring(0, 19) + ' ' + value.substring(19);
			      }
			      // 12 - Numero di conto corrente
			      if (value.length > 32) {
			        value = value.substring(0, 32);
			      }
			      return value;
			    });
			 
			    // Keyup or paste, don't use => need function defined for not isolated
				// "this"
			    el.bind('keyup paste', function change() {
			      if (!this.value || this.value === '') {
			        return;
			      }
			      // 2 - NAZIONE
			      if (this.value.length > 2 && this.value.charAt(2) !== ' ') {
			        this.value = this.value.substring(0, 2) + ' ' + this.value.substring(2);
			      }
			      // 2 - Controllo
			      if (this.value.length > 5 && this.value.charAt(5) !== ' ') {
			        this.value = this.value.substring(0, 5) + ' ' + this.value.substring(5);
			      }
			      // 1 - CIN
			      if (this.value.length > 7 && this.value.charAt(7) !== ' ') {
			        this.value = this.value.substring(0, 7) + ' ' + this.value.substring(7);
			      }
			      // 5 - ABI
			      if (this.value.length > 13 && this.value.charAt(13) !== ' ') {
			        this.value = this.value.substring(0, 13) + ' ' + this.value.substring(13);
			      }
			      // 5 - CAB
			      if (this.value.length > 19 && this.value.charAt(19) !== ' ') {
			        this.value = this.value.substring(0, 19) + ' ' + this.value.substring(19);
			      }
			      // 12 - Numero di conto corrente
			      if (this.value.length > 32) {
			        this.value = this.value.substring(0, 32);
			      }
			      this.value = this.value.trim();
			    });
			  }
	
			return {
				restrict: "A",
				require: '^ngModel',
			    link: linkFunc
			};
		}]);
	}(window));

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
	 * @restrict E
	 * @description Componente per la ricerca dei clienti su DB Banca e Cerved per
	 *              l'apertura di pratiche di Credito Assicurativo
	 */
	(function() {
	  'use strict';
	  var CreasRicercaClienteCtrl = function(
	    $http,
	    $scope,
	    $state,
	    $stateParams,
	    $window,
	    $q,
	    $httpParamSerializer,
	    $uibModal,
	    CONSTANTS,
	    labelSrvc,
	    messaggiFctr,
	    userSrvc,
	    dettPraticaSrvc,
	    ricercaClienteSrvc
	  ) {
	    // Setup vars
	    var ROTTA_CLIENTE = 'creas-nuova-pratica'; // 'schedaCliente' per
	    // landing su brio
	    var ROTTA_CLIENTE_CERVED = 'creas-nuova-pratica';
	    var COD_PRODOTTO_CERVED = 'CAPMI';
	    
	    var FORME_COSTITUTIVE_AMMESSE = ['SAA', 'SPA', 'COO', 'ENT', 'SRL', 'SAS', 'SS', 'SDF', 'SNC', 'IND'];
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.$uibModal = $uibModal;
	    this.messaggiFctr = messaggiFctr;
	    this.userSrvc = userSrvc;
	    this.dettPraticaSrvc = dettPraticaSrvc;
	    this.ricercaClienteSrvc = ricercaClienteSrvc;
	    $scope.msg = labelSrvc.getLabel;
	
	    /* Spinner */
	    this.spinner = {
	      listaClientiBanca: false,
	      listaClientiCerved: false
	    };
	
	    /* Tabella Clienti Banca */
	    this.clientiBancaTableLabel = null;
	    /* Tabella Clienti Cerved */
	    this.clientiCervedTableLabel = null;
	
	    var self = this;
	    labelSrvc.labelsPronte.then(
	      function(value) {
	        self.clientiBancaTableLabel = [
	          {
	            name: $scope.msg(
	              'label.ricercacliente.risultatibanca.intestazione'
	            ),
	            field: 'intestazione',
	            minWidth: 200,
	            enableFiltering: true
	          },
	          {
	            name: $scope.msg('label.ricercacliente.risultatibanca.ndg'),
	            field: 'ndg',
	            minWidth: 100,
	            enableFiltering: true
	          },
	          {
	            name: $scope.msg('label.ricercacliente.risultatibanca.datanascita'),
	            field: 'dataNascita',
	            minWidth: 130,
	            enableFiltering: true,
	            cellTemplate:
	              '<div class="ui-grid-cell-contents">{{row.entity.dataNascita | date: \'dd/MM/yyyy\'}}</div>'
	          },
	          {
	            name: $scope.msg(
	              'label.ricercacliente.risultatibanca.naturagiuridica'
	            ),
	            field: 'naturaGiuridica',
	            minWidth: 100,
	            enableFiltering: true
	          },
	          {
	            name: $scope.msg(
	              'label.ricercacliente.risultatibanca.clienteprospect'
	            ),
	            field: 'prospetto',
	            minWidth: 130,
	            enableFiltering: true,
	            cellTemplate:
	              '<div class="ui-grid-cell-contents">{{row.entity.prospetto === true ? \'Prospetto\' : \'Cliente\'}}</div>'
	          },
	          {
	            name: $scope.msg(
	              'label.ricercacliente.risultatibanca.codicefiscale'
	            ),
	            field: 'codiceFiscale',
	            minWidth: 130,
	            enableFiltering: true
	          },
	          {
	            name: $scope.msg('label.ricercacliente.risultatibanca.partitaiva'),
	            field: 'partitaIva',
	            minWidth: 130,
	            enableFiltering: true
	          },
	          {
	            name: $scope.msg('label.ricercacliente.risultatibanca.promotore'),
	            field: 'nominativoPromotore',
	            minWidth: 130,
	            enableFiltering: true
	          }
	        ];
	
	        self.clientiCervedTableLabel = [
				{
					name: $scope.msg('label.ricercacliente.risultaticerved.intestazione'),
					field: 'intestazione',
					minWidth: 200,
					enableFiltering: true
				},
				{
					name: $scope.msg('label.ricercacliente.risultaticerved.indirizzosede'),
					field: 'indirizzoPrincipale',
					minWidth: 130,
					enableFiltering: true,
					cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.indirizzoPrincipale ? row.entity.indirizzoPrincipale.via : "" }}</div>'
				},
				{
					name: $scope.msg('label.ricercacliente.risultaticerved.comune'),
					field: 'indirizzoPrincipale',
					minWidth: 130,
					enableFiltering: true,
					cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.indirizzoPrincipale && row.entity.indirizzoPrincipale.comune ? row.entity.indirizzoPrincipale.comune.codice : "" }}</div>'
				},
				{
					name: $scope.msg('label.ricercacliente.risultaticerved.codicefiscale'),
					field: 'codiceFiscale',
					minWidth: 130,
					enableFiltering: true
	            },
	            {
					name: $scope.msg('label.ricercacliente.risultaticerved.partitaiva'),
					field: 'partitaIva',
					minWidth: 130,
					enableFiltering: true
	            },
				{
					name: $scope.msg('label.ricercacliente.risultaticerved.numerocciaa'),
					field: 'numeroCciaaRea',
					minWidth: 130,
					enableFiltering: true
				},
				{
					name: $scope.msg('label.ricercacliente.risultaticerved.naturagiuridica'),
					field: 'formaCostitutiva',
					minWidth: 100,
					enableFiltering: true
				},
				{
					name: $scope.msg('label.ricercacliente.risultaticerved.attivitaeconomica'),
					field: 'settoreAttivitaEconomica',
					minWidth: 100,
					enableFiltering: true
				},
				{
					name: $scope.msg('label.ricercacliente.risultaticerved.ateco'),
					field: 'ateco',
					minWidth: 100,
					enableFiltering: true
				},
				{
					name: $scope.msg('label.ricercacliente.risultaticerved.datanascita'),
					field: 'dataCostituzione',
					minWidth: 130,
					enableFiltering: true,
					cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.dataNascita | date: \'dd/MM/yyyy\'}}</div>'
				}
	        ];
	      },
	      function(reason) {
	        self.clientiBancaTableLabel = [
	          {
	            name: 'intestazione',
	            field: 'intestazione',
	            minWidth: 200,
	            enableFiltering: true
	          },
	          {name: 'ndg', field: 'ndg', minWidth: 100, enableFiltering: true},
	          {
	            name: 'datanascita',
	            field: 'dataNascita',
	            minWidth: 130,
	            enableFiltering: true,
	            cellTemplate:
	              '<div class="ui-grid-cell-contents">{{row.entity.dataNascita | date: \'dd/MM/yyyy\'}}</div>'
	          },
	          {
	            name: 'naturagiuridica',
	            field: 'naturaGiuridica',
	            minWidth: 100,
	            enableFiltering: true
	          },
	          {
	            name: 'clienteprospect',
	            field: 'prospetto',
	            minWidth: 130,
	            enableFiltering: true,
	            cellTemplate:
	              '<div class="ui-grid-cell-contents">{{row.entity.prospetto === true ? \'Prospetto\' : \'Cliente\'}}</div>'
	          },
	          {
	            name: 'codicefiscale',
	            field: 'codiceFiscale',
	            minWidth: 130,
	            enableFiltering: true
	          },
	          {
	            name: 'partitaiva',
	            field: 'partitaIva',
	            minWidth: 130,
	            enableFiltering: true
	          },
	          {
	            name: 'promotore',
	            field: 'nominativoPromotore',
	            minWidth: 130,
	            enableFiltering: true
	          }
	        ];
	
	        self.clientiCervedTableLabel = [
				{
					name: $scope.msg('label.ricercacliente.risultaticerved.intestazione'),
					field: 'intestazione',
					minWidth: 200,
					enableFiltering: true
				},
				{
					name: $scope.msg('label.ricercacliente.risultaticerved.indirizzosede'),
					field: 'indirizzoPrincipale',
					minWidth: 130,
					enableFiltering: true,
					cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.indirizzoPrincipale ? row.entity.indirizzoPrincipale.via : "" }}</div>'
				},
				{
					name: $scope.msg('label.ricercacliente.risultaticerved.comune'),
					field: 'indirizzoPrincipale',
					minWidth: 130,
					enableFiltering: true,
					cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.indirizzoPrincipale && row.entity.indirizzoPrincipale.comune ? row.entity.indirizzoPrincipale.comune.codice : "" }}</div>'
				},
				{
					name: $scope.msg('label.ricercacliente.risultaticerved.codicefiscale'),
					field: 'codiceFiscale',
					minWidth: 130,
					enableFiltering: true
	            },
	            {
					name: $scope.msg('label.ricercacliente.risultaticerved.partitaiva'),
					field: 'partitaIva',
					minWidth: 130,
					enableFiltering: true
	            },
				{
					name: $scope.msg('label.ricercacliente.risultaticerved.numerocciaa'),
					field: 'numeroCciaaRea',
					minWidth: 130,
					enableFiltering: true
				},
				{
					name: $scope.msg('label.ricercacliente.risultaticerved.naturagiuridica'),
					field: 'formaCostitutiva',
					minWidth: 100,
					enableFiltering: true
				},
				{
					name: $scope.msg('label.ricercacliente.risultaticerved.attivitaeconomica'),
					field: 'settoreAttivitaEconomica',
					minWidth: 100,
					enableFiltering: true
				},
				{
					name: $scope.msg('label.ricercacliente.risultaticerved.ateco'),
					field: 'ateco',
					minWidth: 100,
					enableFiltering: true
				},
				{
					name: $scope.msg('label.ricercacliente.risultaticerved.datanascita'),
					field: 'dataCostituzione',
					minWidth: 130,
					enableFiltering: true,
					cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.dataNascita | date: \'dd/MM/yyyy\'}}</div>'
				}
	        ];
	      }
	    );
	
	    /**
			 * @ngdoc method
			 * @name resetSearch
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
			 * @description Permette di ripetere la ricerca del cliente sul DB banca
			 */
	    this.resetSearch = function() {
	      self.ricercaClienteSrvc.noResultsFlag = false;
	      self.ricercaClienteSrvc.ricercaCerved = false;
	      self.ricercaClienteSrvc.pivacfisc = null;
	      self.ricercaClienteSrvc.clientiBancaTableData = null;
	      self.ricercaClienteSrvc.clientiCervedTableData = null;
	    };
	
	    /**
			 * @ngdoc method
			 * @name searchParamChanged
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
			 * @description Se il valore del campo di ricerca viene modificato dopo
			 *              la ricerca sul DB Banca, esegue il reset per ripetere la
			 *              ricerca
			 */
	    this.searchParamChanged = function() {
	      if (self.ricercaClienteSrvc.ricercaCerved === true) {
	        self.resetSearch();
	      }
	    };
	
	    /**
			 * @ngdoc method
			 * @name isSearchDisabled
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
			 * @description Verifica se è possibile eseguire la ricerca in base ai
			 *              filtri inseriti
			 * @return {boolean} - 'false' se la ricerca è avviabile, 'true' se è
			 *         necessario modificare o inserire dati
			 */
	    this.isSearchDisabled = function() {
	      if (
	    		  self.ricercaClienteSrvc.pivacfisc && self.ricercaClienteSrvc.pivacfisc.trim() !== '' &&
	    		  (
	    				  (self.ricercaClienteSrvc.pivacfisc.trim().length === 11 && /^\d+$/.test(self.ricercaClienteSrvc.pivacfisc.trim())) || self.ricercaClienteSrvc.pivacfisc.trim().length === 16
	    		  )
	      ) {
	        return false;
	      }
	
	      return true;
	    };
	
	    /**
			 * @ngdoc method
			 * @name isRicercaBancaEnabled
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
			 * @description Verifica se è il pulsante Ricerca Banca è o meno
			 *              visibile
			 * @return {boolean} - 'false' se il pulsante non deve essere
			 *         visualizzato, 'true' se deve essere visualizzato
			 */
	    this.isRicercaBancaEnabled = function() {
	      return (
	        self.ricercaClienteSrvc.ricercaCerved !== true &&
	        !(
	          self.ricercaClienteSrvc.clientiBancaTableData &&
	          self.ricercaClienteSrvc.clientiBancaTableData.length &&
	          self.ricercaClienteSrvc.clientiBancaTableData.length > 0
	        )
	      );
	    };
	
	    /**
			 * @ngdoc method
			 * @name isRicercaCervedEnabled
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
			 * @description Verifica se è il pulsante Ricerca Cerved è o meno
			 *              visibile
			 * @return {boolean} - 'false' se il pulsante non deve essere
			 *         visualizzato, 'true' se deve essere visualizzato
			 */
	    this.isRicercaCervedEnabled = function() {
	      return (
	        self.ricercaClienteSrvc.ricercaCerved === true &&
	        !(
	          self.ricercaClienteSrvc.clientiCervedTableData &&
	          self.ricercaClienteSrvc.clientiCervedTableData.length &&
	          self.ricercaClienteSrvc.clientiCervedTableData.length > 0
	        )
	      );
	    };
	    
	    /**
		 * @ngdoc method
		 * @name isRicercaCodiceFiscale
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
		 * @description Verifica in base al termine di ricerca se si sta eseguendo una ricerca di Codice Fiscale
		 * @return {Boolean} - Restituisce true se la ricerca è su un Codice Fiscale, false se è su una Partita IVA
		 */
	    this.isRicercaCodiceFiscale = function() {
	    	return self.ricercaClienteSrvc.pivacfisc.length > 13;
	    }
	
	    /**
			 * @ngdoc method
			 * @name promiseRicercaClientiBanca
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
			 * @description Esegue la chiamata per ottenere i risultati della
			 *              ricerca clienti sul DB Banca
			 * @return {Promise} - Restituisce una promise contenente la ricerca dei
			 *         clienti sul db banca
			 */
	    this.promiseRicercaClientiBanca = function(forceDittaInd) {
	      var queryParamsObj = {};
	      var endpoint = '';
	
	      
	      // Verifico se sto eseguendo una ricerca per partita iva o codice fiscale
	      if (self.isRicercaCodiceFiscale()) {
	    	  endpoint = 'Search/SearchClient';
	    	  queryParamsObj = {
		        codiceFiscale: self.ricercaClienteSrvc.pivacfisc,
		        partitaIva: ''
		      };
	      } else {
	    	  endpoint = 'Search/SearchClient';
	    	  queryParamsObj = {
		        codiceFiscale: '',
		        partitaIva: self.ricercaClienteSrvc.pivacfisc
		      };
	      }
	      
	      return this.$http({
	        method: 'GET',
	        url: CONSTANTS.REST_CLIENTI_ROOT + endpoint,
	        params: queryParamsObj
	      });
	    };
	
	    /**
			 * @ngdoc method
			 * @name promiseRicercaClientiCerved
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
			 * @description Esegue la chiamata per ottenere i risultati della
			 *              ricerca clienti su CERVED
			 * @return {Promise} - Restituisce una promise contenente la ricerca dei
			 *         clienti su CERVED
			 */
	    this.promiseRicercaClientiCerved = function() {
	      var queryParamsObj = {
	        codFiscPiva: self.ricercaClienteSrvc.pivacfisc
	      };
	
	      var queryParams = $httpParamSerializer(queryParamsObj);
	
	      return this.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.CLIENTI.RICERCA.CERVED +
	          '?' +
	          queryParams
	      });
	    };
	
	    /**
			 * @ngdoc method
			 * @name startSearch
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
			 * @description Avvia la ricerca, verificando se deve essere eseguita
			 *              sul DB Banca o su Cerved
			 */
	    this.startSearch = function() {
	      if (self.ricercaClienteSrvc.ricercaCerved === true) {
	        if (self.isRicercaCervedEnabled() === false) {
	          return;
	        }
	
	        self.searchClientiCerved();
	      } else {
	        if (self.isRicercaBancaEnabled() === false) {
	          return;
	        }
	
	        self.searchClientiBanca();
	      }
	    };
	
	    /**
			 * @ngdoc method
			 * @name searchClientiBanca
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
			 * @description Avvia la ricerca dei clienti banca in base ai filtri
			 *              inseriti e popola la tabella
			 */
	    this.searchClientiBanca = function(forceDittaInd) {
	      if (self.isSearchDisabled() !== false) {
	        return;
	      }
	
	      self.ricercaClienteSrvc.noResultsFlag = false;
	      self.spinner.listaClientiBanca = true;
	
	      $q
	        .all({
	          ricercaClientiBanca: self.promiseRicercaClientiBanca(forceDittaInd)
	        })
	        .then(
	          function(response) {
	        	if (
	              self.messaggiFctr.processaResponse(response.ricercaClientiBanca)
	            ) {
	              self.ricercaClienteSrvc.noResultsFlag = false;
	              self.ricercaClienteSrvc.clientiBancaTableData = null;
	              self.spinner.listaClientiBanca = false;
	              return;
	            }
	            
	            if (response.ricercaClientiBanca.data.length === 0) {
	            	if(!self.isRicercaCodiceFiscale() && !forceDittaInd){
	            		self.searchClientiBanca(true);
	            		return;
	            	}else{
		                self.ricercaClienteSrvc.clientiBancaTableData = null;
		                self.ricercaClienteSrvc.noResultsFlag = true;
		                self.ricercaClienteSrvc.ricercaCerved = true;
		                self.spinner.listaClientiBanca = false;
		                return;
	            	}
	            }
	            self.spinner.listaClientiBanca = false;
	            self.ricercaClienteSrvc.noResultsFlag = false;
	            self.ricercaClienteSrvc.clientiBancaTableData =
	              response.ricercaClientiBanca.data;
	            
	          },
	          function(reason) {
	            self.messaggiFctr.processaResponse(reason.ricercaClientiBanca);
	            self.ricercaClienteSrvc.clientiBancaTableData = null;
	            self.spinner.listaClientiBanca = false;
	          }
	        );
	    };
	
	    /**
			 * @ngdoc method
			 * @name searchClientiCerved
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
			 * @description Avvia la ricerca su cerved in base ai filtri inseriti e
			 *              popola la tabella
			 */
	    this.searchClientiCerved = function() {
	      if (self.isSearchDisabled() !== false) {
	        return;
	      }
	      
	      // Richiedo conferma prima di proseguire con la ricerca
	      var modalController = function($scope, LabelSrvc, $modalInstance) {
		      $scope.headerText = LabelSrvc.getLabel(
		        'label.ricercacliente.confermacerved.header'
		      );
		      $scope.bodyText = LabelSrvc.getLabel(
		        'label.ricercacliente.confermacerved.content'
		      ) + ' ' + self.ricercaClienteSrvc.pivacfisc;
		      $scope.cancelText = LabelSrvc.getLabel(
		        'label.ricercacliente.confermacerved.cancel'
		      );
		      $scope.confirmText = LabelSrvc.getLabel(
		        'label.ricercacliente.confermacerved.confirm'
		      );
		
		      $scope.optionSelected = function(result) {
		        $modalInstance.close(result);
		      };
		    };
		
		    modalController.$inject = ['$scope', 'LabelSrvc', '$modalInstance'];
		
		    var modalInstance = this.$uibModal.open({
		      animation: true,
		      template:
		        '<creas-confirm-modal header-text="headerText" body-text="bodyText" cancel-text="cancelText" confirm-text="confirmText" option-selected="optionSelected(result)"></creas-confirm-modal>',
		      backdrop: 'static',
		      size: 'lg',
		      controller: modalController
		    });
		
		    modalInstance.result.then(function(confirmResult) {
		      if (confirmResult !== true) {
		        return;
		      }
		
		      // Eseguo la ricerca su Cerved
		      self.ricercaClienteSrvc.noResultsFlag = false;
		      self.spinner.listaClientiCerved = true;
	
		      $q
		        .all({
		          ricercaClientiCerved: self.promiseRicercaClientiCerved()
		        })
		        .then(
		          function(response) {
		            // Verifico se tra gli errori ho quello che indica che il
		            // cliente non è stato trovato
		            var hasErroreNoCliente = false;
		            
		            if (response.ricercaClientiCerved.data.messageList) {
		            	angular.forEach(
		                    response.ricercaClientiCerved.data.messageList.errMessages,
		                    function(value) {
		                      if (hasErroreNoCliente === true) {
		                        return;
		                      }
	
		                      switch (value.message) {
		                        case 'NOPF':
		                        case 'NOPG':
		                          hasErroreNoCliente = true;
		                          break;
		                      }
		                    }
		                  );
		            }
		            
		            if (hasErroreNoCliente === true) {
		              self.ricercaClienteSrvc.clientiCervedTableData = [];
		              self.ricercaClienteSrvc.noResultsFlag = true;
		              return;
		            }
	
		            if (
		              self.messaggiFctr.processaResponse(
		                response.ricercaClientiCerved
		              ) !== false
		            ) {
		              self.ricercaClienteSrvc.noResultsFlag = false;
		              self.ricercaClienteSrvc.clientiCervedTableData = null;
		              return;
		            }
	
		            self.ricercaClienteSrvc.noResultsFlag = false;
		            self.ricercaClienteSrvc.clientiCervedTableData = [
		              response.ricercaClientiCerved.data.result
		            ];
		          },
		          function(reason) {
		            self.messaggiFctr.processaResponse(reason.ricercaClientiCerved);
		            self.ricercaClienteSrvc.clientiCervedTableData = null;
		          }
		        )
		        .finally(function() {
		          self.spinner.listaClientiCerved = false;
		        });
		    });
	
	    };
	
	    /**
			 * @ngdoc method
			 * @name hasRisultatiClientiBanca
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
			 * @description Verifica se la ricerca clienti banca ha restituito
			 *              risultati
			 * @return {boolean} - true se ho almeno un risultato, false se non sono
			 *         presenti risultati
			 */
	    this.hasRisultatiClientiBanca = function() {
	      return (
	        self.ricercaClienteSrvc.clientiBancaTableData.length &&
	        self.ricercaClienteSrvc.clientiBancaTableData.length > 0
	      );
	    };
	    
	    /**
		 * @ngdoc method
		 * @name formaCostitutivaValida
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
		 * @description Verifica che la forma costitutiva del cliente sia compatibile per l'apertura di una pratica di credito assicurativo
		 * @param {Object} cliente - i dati del cliente
		 * @return {boolean} - true se la forma costitutiva è ammesse, false se non è compresa tra quelle consentite
		 */
	    this.formaCostitutivaValida = function(cliente) {
	    	if (cliente.naturaGiuridica) {    		
	    		return FORME_COSTITUTIVE_AMMESSE.indexOf(cliente.naturaGiuridica.toUpperCase()) > -1;
	    	} else if (cliente.formaCostitutiva) {
	    		return FORME_COSTITUTIVE_AMMESSE.indexOf(cliente.formaCostitutiva.toUpperCase()) > -1;
	    	}
	    }
	
	    /**
			 * @ngdoc method
			 * @name openCliente
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
			 * @description Apre la scheda del cliente selezionato
			 * @param {Object}
			 *            row - Oggetto contenente i dati del cliente selezionato
			 */
	    this.openCliente = function(row) {
	    	
	      if (self.formaCostitutivaValida(row) !== true) {
	    	  self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.ricercacliente.alert.naturagiuridica') });
	    	  return;
	      }
	      
	      if (row.praticaVariazione) {
	    	  self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.ricercacliente.alert.variazione').replace("[INTESTAZIONE]",row.intestazione) });
	    	  return;
	      }
	      if (row.naturaGiuridica === 'PRV') {
	    	  self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.ricercacliente.alert.prv').replace("[INTESTAZIONE]",row.intestazione) });
	    	  return;
	      }
	      
	      self.dettPraticaSrvc.reset();
	      self.dettPraticaSrvc.datiClienteBanca = row;
	      var params = self.$stateParams;
	      params.ndg = row.ndg;
	      params.codProdotto = COD_PRODOTTO_CERVED;
	      params.idAnagrafica = row.idAnagrafica;
	
	      self.$state.go(ROTTA_CLIENTE, params);
	    };
	
	    /**
			 * @ngdoc method
			 * @name openClienteCerved
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
			 * @description Apre la procedura di creazione pratica per il cliente
			 *              Cerved Selezionato
			 * @param {Object}
			 *            row - Oggetto contenente i dati del cliente Cerved
			 *            selezionato
			 */
	    this.openClienteCerved = function(row) {
	    	
	      if (self.formaCostitutivaValida(row) !== true) {
	      	  self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.ricercacliente.alert.naturagiuridica') });
	      	  return;
	      }
	    	
	      self.dettPraticaSrvc.reset();
	      self.dettPraticaSrvc.datiClienteCerved = row;
	      self.spinner.listaClientiCerved = true;
	      this.$http({
	        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CLIENTI.CREA_DA_CERVED,
	        params: {
	          codFiscPiva: self.ricercaClienteSrvc.pivacfisc
	        },
	        method: 'GET'
	      })
	        .then(
	          function(response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              return;
	            }
	            var params = self.$stateParams;
	            params.ndg = response.data.result.ndg;
	            params.codProdotto = COD_PRODOTTO_CERVED;
	            self.$state.go(ROTTA_CLIENTE_CERVED, params);
	          },
	          function(reason) {
	            self.messaggiFctr.processaResponse(reason);
	          }
	        )
	        .finally(function() {
	          self.spinner.listaClientiCerved = false;
	        });
	    };
	
	    this.userSrvc.abilitazioniPronte.then(function(result) {
	    	//Verifico se vengo da un punto dove voglio preservare la ricerca
	       if(self.ricercaClienteSrvc.preserveSearch){
	    	   self.ricercaClienteSrvc.preserveSearch = false;
	       } else {
	    	   self.resetSearch();
	       }
	       
	    	
	      // Verifico se Credito assicurativo è abilitato
	      // in caso contrario rimando alla home
	      for (var i = 0; i < self.userSrvc.abilitazioni.length; i++) {
	        if (
	          self.userSrvc.abilitazioni[i].codice ===
	          'CreditoAssicurativoPMIAbilitato'
	        ) {
	          return;
	        }
	      }
	
	      self.$state.go('schedaCliente');
	    });
	  };
	
	  CreasRicercaClienteCtrl.$inject = [
	    '$http',
	    '$scope',
	    '$state',
	    '$stateParams',
	    '$window',
	    '$q',
	    '$httpParamSerializer',
	    '$uibModal',
	    'CONSTANTS',
	    'LabelSrvc',
	    'CreasMessaggiFctr',
	    'UserSrvc',
	    'CreasDettaglioPraticaSrvc',
	    'CreasRicercaClienteSrvc'
	  ];
	
	  var TemplateUrl = function(CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'creasRicercaCliente/creasRicercaCliente.html'
	    );
	  };
	
	  TemplateUrl.$inject = ['CONSTANTS'];
	
	  var CreasRicercaClienteComponent = {
	    controller: CreasRicercaClienteCtrl,
	    controllerAs: 'creasRicercaClienteCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.insuranceloanpmi.mf')
	    .component('creasRicercaCliente', CreasRicercaClienteComponent);
	})();


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	// TODO: Applicare FUNA
	/**
	 * @ngdoc directive
	 * @name cbl.insuranceloanpmi.mf.directive:creasRicercaPratiche
	 * @restrict E
	 * @description Componente per la ricerca delle pratiche di pratiche di Credito Assicurativo
	 */
	(function() {
	  'use strict';
	  var CreasRicercaPraticheCtrl = function(
	    $http,
	    $scope,
	    $state,
	    $stateParams,
	    $window,
	    $q,
	    $httpParamSerializer,
	    CONSTANTS,
	    labelSrvc,
	    userSrvc,
	    messaggiFctr
	  ) {
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.messaggiFctr = messaggiFctr;
	    this.userSrvc = userSrvc;
	    $scope.msg = labelSrvc.getLabel;
	
	    /* Spinner */
	    this.spinner = {
	      listaPratiche: false
	    };
	
	    /* Filtri di ricerca */
	    this.statiPratica = [
		    {key: '', description: 'Tutti'},
		    {key: 'INCORSO', description: 'In corso'},
		    {key: 'VALUTAZIONE', description: 'Valutazione'},
		    {key: 'INTEGRAZIONE', description: 'Integrazione'},
		    {key: 'DEFINITA', description: 'Definita'},
		    {key: 'CONSOLIDATA', description: 'Consolidata'},
		    {key: 'AFFIDATA', description: 'Affidata'},
		    {key: 'GESTIONEPOLIZZE', description: 'Gestione polizze'},
		    {key: 'CONCLUSA', description: 'Conclusa'},
		    {key: 'ANNULLATA', description: 'Annullata'},
		    {key: 'RIFIUTATA', description: 'Rifiutata'},
	      {key: 'LAVORAZIONE', description: 'In lavorazione'}
		  ];
	    
	    this.intestazioneSocieta = '';
	    this.statoPratica = this.statiPratica[0];
	    this.dataAperturaDa = null;
	    this.dataAperturaA = new Date();
	
	    /* Flag che visualizza il messaggio di nessun record trovato */
	    this.noResultsFlag = false;
	
	    /* Tabella Pratiche */
	    this.praticheTableData = null;
	    this.praticheTableLabel = [
	      {
	        name: 'ID Pratica',
	        field: 'idPratica',
	        minWidth: 130,
	        enableFiltering: true
	      },
	      {
	        name: 'Intestazione',
	        field: 'intestatario.intestazione',
	        minWidth: 200,
	        enableFiltering: true
	      },
	      {
	        name: 'Presa in carico',
	        field: 'dataPresaInCarico',
	        minWidth: 130,
	        enableFiltering: true
	      },
	      {name: 'Stato', field: 'stato', minWidth: 130, enableFiltering: true}
	    ];
	
	    var self = this;
	
	    this.init = function () {
	      this.initCampiRicerca();
	    };
	
	     /**
		 * @ngdoc method
		 * @name initCampiRicerca
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaPratiche
		 * @description Inizializza i campi di ricerca in base all'eventuale valorizzazione dei query params della rotta
		 */
	    this.initCampiRicerca = function () {
	      if (this.$stateParams.intestazione && this.$stateParams.intestazione !== '') {
	        this.intestazioneSocieta = this.$stateParams.intestazione;
	      }
	      if (this.$stateParams.stato && this.$stateParams.stato !== '') {
	        for (var i in this.statiPratica) {
	          var stato = this.statiPratica[i];
	          if (stato.key === this.$stateParams.stato) {
	            this.statoPratica = stato;
	          }
	        }        
	      }
	      if (this.$stateParams.dataDa) {
	        this.dataAperturaDa = new Date(this.$stateParams.dataDa);
	      }
	      if (this.$stateParams.dataA) {
	        this.dataAperturaA = new Date(this.$stateParams.dataA);
	      }
	      if (this.$stateParams.intestazione || this.$stateParams.stato || this.$stateParams.dataDa || this.$stateParams.dataA) {
	        this.searchPratiche();
	      }
	    }
	
	    /**
		 * @ngdoc method
		 * @name isSearchDisabled
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaPratiche
		 * @description Verifica se è possibile eseguire la ricerca in base ai filtri inseriti
		 * @return {boolean} - 'false' se la ricerca è avviabile, 'true' se è necessario modificare o inserire dati
		 */
	    this.isSearchDisabled = function() {
	      if (!self.intestazioneSocieta && self.statoPratica && self.statoPratica.key !== '') {
	        return false;
	      }
	
	      if (!self.statoPratica) {
	        return true;
	      }
	      
	      if (self.statoPratica.key === '' && self.intestazioneSocieta.trim().length < 2) {
	    	return true;
	      }
	
	      if (self.intestazioneSocieta && self.intestazioneSocieta.trim() !== '') {
	        return false;
	      }
	
	      if (self.statoPratica && self.intestazioneSocieta.trim() !== '') {
	        return false;
	      }
	
	      return true;
	    };
	
	    /**
			 * @ngdoc method
			 * @name promiseRicercaPratiche
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
			 * @description Esegue la chiamata per ottenere i risultati delle pratiche di Credito Assicurativo
			 * @return {Promise} - Restituisce una promise contenente la ricerca delle pratiche di Credito Assicurativo
			 */
	    this.promiseRicercaPratiche = function() {
	      var queryParamsObj = {};
	      if (self.intestazioneSocieta) {
	        queryParamsObj['ragioneSociale'] = self.intestazioneSocieta;
	      }
	      if (self.statoPratica && self.statoPratica.key) {
	        queryParamsObj['statoPratica'] = self.statoPratica.key;
	      }
	      if (self.dataAperturaDa) {
	        queryParamsObj['dataDa'] = new Date(self.dataAperturaDa).toISOString();
	      }
	      if (self.dataAperturaA) {
	        queryParamsObj['dataA'] = new Date(self.dataAperturaA).toISOString();
	      }
	
	      var queryParams = $httpParamSerializer(queryParamsObj);
	      var queryString = '';
	      if (queryParams !== '') {
	        queryString = '?' + queryParams;
	      }
	
	      return this.$http({
	        method: 'GET',
	        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICHE.RICERCA + queryString
	      });
	    };
	
	    /**
			 * @ngdoc method
			 * @name searchPratiche
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaPratiche
			 * @description Avvia la ricerca delle pratiche in base ai filtri inseriti e popola la tabella
			 */
	    this.searchPratiche = function() {
	      if (self.isSearchDisabled() !== false) {
	        return;
	      }
	
	      self.noResultsFlag = false;
	      self.spinner.listaPratiche = true;
	
	      $q
	        .all({
	          ricercaPratiche: self.promiseRicercaPratiche()
	        })
	        .then(
	          function(response) {
	            if (
	              self.messaggiFctr.processaResponse(response.ricercaPratiche) !==
	              false
	            ) {
	              self.noResultsFlag = false;
	              self.praticheTableData = null;
	              return;
	            }
	
	            self.noResultsFlag = (response.ricercaPratiche.data.result.length === 0);
	            self.praticheTableData = response.ricercaPratiche.data.result;
	          },
	          function(reason) {
	            self.messaggiFctr.processaResponse(reason.ricercaPratiche);
	            self.praticheTableData = null;
	          }
	        )
	        .finally(function() {
	          self.spinner.listaPratiche = false;
	        });
	    };
	
	    /**
			 * @ngdoc method
			 * @name openPratica
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaPratiche
			 * @description Apre la scheda della pratica selezionata
			 * @param {Object} tableRow - Oggetto contenente i dati della pratica selezionata
			 */
	    this.openPratica = function(tableRow) {
	      self.$state.go('creas-dettaglio-pratica', {
	    	  ndg:tableRow.intestatario.ndg,
	    	  idPratica: tableRow.idPratica
	      });
	    };
	
	    /**
			 * @ngdoc method
			 * @name createNewPratica
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaPratiche
			 * @description Apre la funzione di ricerca cliente per iniziare la procedura di creazione di una nuova pratica di credito assicurativo
			 */
	    this.createNewPratica = function() {
	      self.$state.go('creas-ricerca-cliente');
	    };
	
	    this.userSrvc.abilitazioniPronte.then(function(result) {
	      // Verifico se Credito assicurativo è abilitato
	      // in caso contrario rimando alla home
	      for (var i = 0; i < self.userSrvc.abilitazioni.length; i++) {
	        if (
	          self.userSrvc.abilitazioni[i].codice ===
	          'CreditoAssicurativoPMIAbilitato'
	        ) {
	          self.init();
	          return;
	        }
	      }
	
	      self.$state.go('schedaCliente');
	    });
	  };
	
	  CreasRicercaPraticheCtrl.$inject = [
	    '$http',
	    '$scope',
	    '$state',
	    '$stateParams',
	    '$window',
	    '$q',
	    '$httpParamSerializer',
	    'CONSTANTS',
	    'LabelSrvc',
	    'UserSrvc',
	    'CreasMessaggiFctr'
	  ];
	
	  var TemplateUrl = function(CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'creasRicercaPratiche/creasRicercaPratiche.html'
	    );
	  };
	
	  TemplateUrl.$inject = ['CONSTANTS'];
	
	  var CreasRicercaPraticheComponent = {
	    controller: CreasRicercaPraticheCtrl,
	    controllerAs: 'creasRicercaPraticheCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.insuranceloanpmi.mf')
	    .component('creasRicercaPratiche', CreasRicercaPraticheComponent);
	})();


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	// TODO: Applicare FUNA
	/**
	 * @ngdoc directive
	 * @name cbl.insuranceloanpmi.mf.directive:creasAffidamento
	 * @restrict E
	 * @description Componente per caricare il widget del dettaglio affidamento
	 */
	(function() {
	  'use strict';
	  var CreasAffidamentoCtrl = function(
	    $http,
	    $scope,
	    $state,
	    $stateParams,
	    $window,
	    $q,
	    $httpParamSerializer,
	    CONSTANTS,
	    labelSrvc,
	    userSrvc,
	    messaggiFctr
	  ) {
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.messaggiFctr = messaggiFctr;
	    this.userSrvc = userSrvc;
	    $scope.msg = labelSrvc.getLabel;
	    
	    this.ndg = this.$stateParams.ndg;
	
	    var self = this;
	  };
	
	  CreasAffidamentoCtrl.$inject = [
	    '$http',
	    '$scope',
	    '$state',
	    '$stateParams',
	    '$window',
	    '$q',
	    '$httpParamSerializer',
	    'CONSTANTS',
	    'LabelSrvc',
	    'UserSrvc',
	    'CreasMessaggiFctr'
	  ];
	
	  var TemplateUrl = function(CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'creasAffidamento/creasAffidamento.html'
	    );
	  };
	
	  TemplateUrl.$inject = ['CONSTANTS'];
	
	  var CreasAffidamentoComponent = {
	    controller: CreasAffidamentoCtrl,
	    controllerAs: 'creasAffidamentoCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.insuranceloanpmi.mf')
	    .component('creasAffidamento', CreasAffidamentoComponent);
	})();


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	 * @restrict E
	 * @description Componente per la visualizzazione di una pratica di credito
	 *              assicurativo
	 */
	(function () {
	  'use strict';
	  var CreasDettaglioPraticaCtrl = function (
	    $http,
	    $scope,
	    $state,
	    $stateParams,
	    $window,
	    $q,
	    $httpParamSerializer,
	    $uibModal,
	    CONSTANTS,
	    labelSrvc,
	    messaggiFctr,
	    userSrvc,
	    dettPraticaSrvc,
	    modelFctr,
	    ricercaClienteSrvc
	  ) {
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.$uibModal = $uibModal;
	    this.messaggiFctr = messaggiFctr;
	    this.userSrvc = userSrvc;
	    this.dettPraticaSrvc = dettPraticaSrvc;
	    this.ricercaClienteSrvc = ricercaClienteSrvc;
	    this.CONSTANTS = CONSTANTS;
	    $scope.msg = labelSrvc.getLabel;
	
	    // Variabile di controllo per la verifica della selezione di un cliente
	    this.noCustomerError = false;
	    this.errorFromService = false;
	
	    // Dati Pratica
	    this.datiCliente = {};
	    this.affidamenti = [];
	
	    // Spinner
	    this.spinner = this.dettPraticaSrvc.spinner;
	
	    // Configurazione Tab principali
	    // La configurazione "operationsVisibility" permette di impostare se un
	    // pulsante è visibile per un determinato step
	    this.TAB_LIST_MACRO = [];
	
	    // Configurazioni sotto-step
	    this.TAB_LIST_MICRO = {
	      STEP2: [],
	      STEP3: [],
	      STEP6: [],
	    };
	
	    // Tab attualmente attive
	    this.currentTabMacro = {};
	    this.currentTabMicro = {};
	
	    var self = this;
	
	    /**
	     * @ngdoc method
	     * @name generaTabs
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Genera le tab necessarie al processo sulla base del cliente
	     *              e della pratica ricevuti
	     */
	    this.dettPraticaSrvc.generaTabs = function () {
	      debugger;
	      var isAnagraficaCerved = self.dettPraticaSrvc.isClienteCerved();
	      var statoAffidamento = self.dettPraticaSrvc.affidamento.stato;
	
	      // Svuoto le tab
	      self.TAB_LIST_MACRO = [];
	      self.TAB_LIST_MICRO.STEP2 = [];
	      self.TAB_LIST_MICRO.STEP3 = [];
	      self.TAB_LIST_MICRO.STEP6 = [];
	
	      // Step principali
	      self.TAB_LIST_MACRO.push({
	        index: 0,
	        title: $scope.msg('label.dettagliopratica.step1.titolotab'),
	        url: 'statoAffidamento.tmpl.html',
	        operationsVisibility: {
	          cancel: false,
	          save: false,
	          prev: false,
	          next: false,
	          complete: false,
	        },
	      });
	
	      self.TAB_LIST_MACRO.push({
	        index: 1,
	        title: $scope.msg('label.dettagliopratica.step2.titolotab'),
	        url: 'richiestaFido.tmpl.html',
	      });
	
	      self.TAB_LIST_MACRO.push({
	        index: 2,
	        title: $scope.msg('label.dettagliopratica.step3.titolotab'),
	        url: 'valutazionePratica.tmpl.html',
	      });
	
	      self.TAB_LIST_MACRO.push({
	        index: 3,
	        title: $scope.msg('label.dettagliopratica.step4.titolotab'),
	        url: 'sceltaConto.tmpl.html',
	        operationsVisibility: {
	          cancel: false,
	          save: true,
	          prev: true,
	          next: true,
	          complete: false,
	        },
	      });
	
	      self.TAB_LIST_MACRO.push({
	        index: 4,
	        title: $scope.msg('label.dettagliopratica.step5.titolotab'),
	        url: 'affidamentoDocumenti.tmpl.html',
	        operationsVisibility: {
	          cancel: false,
	          save: true,
	          prev: true,
	          next: true,
	          complete: false,
	        },
	      });
	
	      self.TAB_LIST_MACRO.push({
	        index: 5,
	        title: $scope.msg('label.dettagliopratica.step6.titolotab'),
	        url: 'praticaPagamento.tmpl.html',
	      });
	
	      // Sotto-step - Step 2
	      self.TAB_LIST_MICRO.STEP2.push({
	        index: 0,
	        title: $scope.msg('label.dettagliopratica.step2.sub1.titolotab'),
	        url: 'datiAffidamento.tmpl.html',
	        operationsVisibility: {
	          cancel: true,
	          save: true,
	          prev: false,
	          next: true,
	          complete: false,
	        },
	      });
	
	      self.TAB_LIST_MICRO.STEP2.push({
	        index: 1,
	        title: $scope.msg('label.dettagliopratica.step2.sub2.titolotab'),
	        url: 'gestioneFirmatari.tmpl.html',
	        operationsVisibility: {
	          cancel: true,
	          save: false,
	          prev: true,
	          next: true,
	          complete: false,
	        },
	      });
	
	      // Questo step non viene utilizzato
	      self.TAB_LIST_MICRO.STEP2.push({
	        index: 2,
	        title: $scope.msg('label.dettagliopratica.step2.sub3.titolotab'),
	        url: 'gestioneFirmatari.tmpl.html',
	        operationsVisibility: {
	          cancel: true,
	          save: false,
	          prev: true,
	          next: true,
	          complete: false,
	        },
	      });
	
	      // Sotto-step - Step 3
	      self.TAB_LIST_MICRO.STEP3.push({
	        index: 0,
	        title: $scope.msg('label.dettagliopratica.step3.sub1.titolotab'),
	        url: 'valutazioneCerved.tmpl.html',
	        operationsVisibility: {
	          cancel: true,
	          save: false,
	          prev: true,
	          next: true,
	          complete: false,
	        },
	      });
	
	      if (isAnagraficaCerved === true) {
	        self.TAB_LIST_MICRO.STEP3.push({
	          index: 1,
	          title: $scope.msg('label.dettagliopratica.step3.sub2.titolotab'),
	          url: 'integrazioneAnagrafica.tmpl.html',
	          operationsVisibility: {
	            cancel: false,
	            save: false,
	            prev: true,
	            next: true,
	            complete: false,
	          },
	        });
	      }
	
	      // Sotto-step - Step 6
	      self.TAB_LIST_MICRO.STEP6.push({
	        index: 0,
	        title: $scope.msg('label.dettagliopratica.step6.sub1.titolotab'),
	        url: 'sceltaConvenzione.tmpl.html',
	        operationsVisibility: {
	          cancel: false,
	          save: true,
	          prev: false,
	          next: true,
	          complete: false,
	        },
	      });
	
	      self.TAB_LIST_MICRO.STEP6.push({
	        index: 1,
	        title: $scope.msg('label.dettagliopratica.step6.sub2.titolotab'),
	        url: 'sceltaPolizze.tmpl.html',
	        operationsVisibility: {
	          cancel: false,
	          save: true,
	          prev: true,
	          next: true,
	          complete: false,
	        },
	      });
	
	      self.TAB_LIST_MICRO.STEP6.push({
	        index: 2,
	        title: $scope.msg('label.dettagliopratica.step6.sub3.titolotab'),
	        url: 'riepilogoPolizze.tmpl.html',
	        operationsVisibility: {
	          cancel: false,
	          save: true,
	          prev: true,
	          next: true,
	          complete: false,
	        },
	      });
	
	      self.TAB_LIST_MICRO.STEP6.push({
	        index: 3,
	        title: $scope.msg('label.dettagliopratica.step6.sub4.titolotab'),
	        url: 'pagamentoGestioneDocumenti.tmpl.html',
	        operationsVisibility: {
	          cancel: false,
	          save: false,
	          prev: false,
	          next: false,
	          complete: true,
	        },
	      });
	
	      // Eseguo il refresh delle liste
	      self.TAB_LIST_MACRO = self.TAB_LIST_MACRO.concat([]);
	      self.TAB_LIST_MICRO.STEP2 = self.TAB_LIST_MICRO.STEP2.concat([]);
	      self.TAB_LIST_MICRO.STEP3 = self.TAB_LIST_MICRO.STEP3.concat([]);
	      self.TAB_LIST_MICRO.STEP6 = self.TAB_LIST_MICRO.STEP6.concat([]);
	
	      // Imposto i tab attivi
	      var tabMacroIndex = CONSTANTS.STATI_PRATICA.indexOf(
	        self.dettPraticaSrvc.datiPratica.stato
	      );
	      tabMacroIndex = tabMacroIndex < 0 ? 0 : tabMacroIndex;
	
	      var microStep = self.dettPraticaSrvc.datiPratica.step;
	      microStep = microStep ? microStep - 1 : 0;
	
	      // Step 2 - Forzatura per gestire il Widget FEA/Documenti
	      if (tabMacroIndex === 1 && microStep >= 2 && microStep <= 6) {
	        microStep = 1;
	      }
	      // Step 2 - Forzatura per gestire il Widget FEA/Documenti
	      if (tabMacroIndex === 5 && microStep >= 4) {
	        microStep = 3;
	      }
	      // Step 3 - Forzatura per convertire INTEGRAZIONE in VALUTAZIONE
	      if (tabMacroIndex === 6) {
	        tabMacroIndex = 2;
	        microStep = 1;
	      }
	
	      self.currentTabMacro = self.TAB_LIST_MACRO[tabMacroIndex];
	      self.currentTabMicro = {
	        STEP2: self.TAB_LIST_MICRO.STEP2[microStep],
	        STEP3: self.TAB_LIST_MICRO.STEP3[microStep],
	        STEP6: self.TAB_LIST_MICRO.STEP6[microStep],
	      };
	    };
	
	    /**
	     * @ngdoc method
	     * @name macroTabClicked
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Gestisce il click sulle macro tab
	     * @param {Object} tab: l'oggetto tab selezionato
	     */
	    this.macroTabClicked = function (tab) {
	      if (self.dettPraticaSrvc.isPraticaNavigabile() !== true) {
	        return;
	      }
	
	      // Non posso selezionare la tab Pagamento
	      if (tab.index === 5) {
	        return;
	      }
	
	      self.currentTabMacro = tab;
	      self.currentTabMicro = {
	        STEP2: self.TAB_LIST_MICRO.STEP2[0],
	        STEP3: self.TAB_LIST_MICRO.STEP3[0],
	        STEP6: self.TAB_LIST_MICRO.STEP6[0],
	      };
	    };
	
	    /**
	     * @ngdoc method
	     * @name apriMicroTab
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Apre la micro tab indicata per lo step passato
	     * @param {Object} tab: l'oggetto tab selezionato
	     * @param {number} macroTabIndex: l'indice della macro-tab da gestire (in base 1)
	     */
	    this.dettPraticaSrvc.apriMicroTab = function (tab, macroTabIndex) {
	      if (self.currentTabMicro['STEP' + macroTabIndex]) {
	        self.currentTabMicro['STEP' + macroTabIndex] = tab;
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name apriRicercaCliente
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Apre la pagina di ricerca cliente
	     */
	    this.apriRicercaCliente = function () {
	      self.$state.go('creas-ricerca-cliente');
	    };
	
	    /**
	     * @ngdoc method
	     * @name isCancelVisible
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Verifica se il pulsante di annullamento pratica è visibile
	     *              per lo step attivo
	     */
	    this.isCancelVisible = function () {
	      if (
	        self.dettPraticaSrvc.datiPratica &&
	        self.dettPraticaSrvc.datiPratica.stato === 'ANNULLATA'
	      ) {
	        return false;
	      }
	
	      if (
	        self.dettPraticaSrvc.datiPratica &&
	        self.dettPraticaSrvc.datiPratica.stato === 'RIFIUTATA'
	      ) {
	        return false;
	      }
	
	      if (self.dettPraticaSrvc.isPraticaNavigabile() === true) {
	        return false;
	      }
	
	      if (
	        self.dettPraticaSrvc.isCancelVisible &&
	        typeof self.dettPraticaSrvc.isCancelVisible === 'function'
	      ) {
	        return self.dettPraticaSrvc.isCancelVisible();
	      }
	
	      var stepNumber = self.currentTabMacro.index + 1;
	
	      // Se ho dei sotto-step, verifico le proprietà del sotto-step attivo
	      // invece che del macro-step
	      if (
	        self.currentTabMicro['STEP' + stepNumber] &&
	        self.currentTabMicro['STEP' + stepNumber].operationsVisibility
	      ) {
	        return self.currentTabMicro['STEP' + stepNumber].operationsVisibility
	          .cancel;
	      }
	
	      if (!self.currentTabMacro.operationsVisibility) {
	        return false;
	      }
	
	      return self.currentTabMacro.operationsVisibility.cancel;
	    };
	
	    /**
	     * @ngdoc method
	     * @name isCancelEnabled
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Verifica se il pulsante di annullamento pratica è
	     *              disabilitato per lo step attivo
	     */
	    this.isCancelEnabled = function () {
	      if (
	        self.dettPraticaSrvc.isCancelEnabled &&
	        typeof self.dettPraticaSrvc.isCancelEnabled === 'function'
	      ) {
	        return self.dettPraticaSrvc.isCancelEnabled();
	      }
	
	      return false;
	    };
	
	    /**
	     * @ngdoc method
	     * @name isCancelFinanziamentoVisible
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Verifica se il pulsante di annullamento finanziamento è visibile
	     *              per lo step attivo
	     */
	    this.isCancelFinanziamentoVisible = function () {
	      if (
	        self.dettPraticaSrvc.isCancelFinanziamentoVisible &&
	        typeof self.dettPraticaSrvc.isCancelFinanziamentoVisible === 'function'
	      ) {
	        return self.dettPraticaSrvc.isCancelFinanziamentoVisible();
	      }
	      return false;
	    };
	
	    /**
	     * @ngdoc method
	     * @name isCancelFinanziamentoEnabled
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Verifica se il pulsante di annullamento finanziamento è
	     *              disabilitato per lo step attivo
	     */
	    this.isCancelFinanziamentoEnabled = function () {
	      if (
	        self.dettPraticaSrvc.isCancelFinanziamentoEnabled &&
	        typeof self.dettPraticaSrvc.isCancelFinanziamentoEnabled === 'function'
	      ) {
	        return self.dettPraticaSrvc.isCancelFinanziamentoEnabled();
	      }
	
	      return false;
	    };
	    /**
	     * @ngdoc method
	     * @name isTornaASchedaClienteVisible
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Verifica se il pulsante Torna a scheda cliente è visibile
	     */
	    this.isTornaASchedaClienteVisible = function () {
	      if (
	        self.dettPraticaSrvc.datiPratica &&
	        self.dettPraticaSrvc.datiPratica.stato === 'ANNULLATA'
	      ) {
	        return true;
	      }
	
	      if (
	        self.dettPraticaSrvc.datiPratica &&
	        self.dettPraticaSrvc.datiPratica.stato === 'RIFIUTATA'
	      ) {
	        return true;
	      }
	
	      if (self.dettPraticaSrvc.isPraticaNavigabile() === true) {
	        return true;
	      }
	
	      return false;
	    };
	
	    /**
	     * @ngdoc method
	     * @name tornaASchedaCliente
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Apre la pagina della scheda cliente
	     */
	    this.tornaASchedaCliente = function () {
	      self.$state.go('schedaCliente', { ndg: self.datiCliente.ndg });
	    };
	
	    /**
	     * @ngdoc method
	     * @name isSaveVisible
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Verifica se il pulsante di salvataggio pratica è visibile
	     *              per lo step attivo
	     */
	    this.isSaveVisible = function () {
	      if (
	        self.dettPraticaSrvc.datiPratica &&
	        self.dettPraticaSrvc.datiPratica.stato === 'ANNULLATA'
	      ) {
	        return false;
	      }
	
	      if (
	        self.dettPraticaSrvc.datiPratica &&
	        self.dettPraticaSrvc.datiPratica.stato === 'RIFIUTATA'
	      ) {
	        return false;
	      }
	
	      var stepNumber = self.currentTabMacro.index + 1;
	
	      // Se ho dei sotto-step, verifico le proprietà del sotto-step attivo
	      // invece che del macro-step
	      if (
	        self.currentTabMicro['STEP' + stepNumber] &&
	        self.currentTabMicro['STEP' + stepNumber].operationsVisibility
	      ) {
	        return self.currentTabMicro['STEP' + stepNumber].operationsVisibility
	          .save;
	      }
	
	      if (!self.currentTabMacro.operationsVisibility) {
	        return false;
	      }
	
	      return self.currentTabMacro.operationsVisibility.save;
	    };
	
	    /**
	     * @ngdoc method
	     * @name isSaveEnabled
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Verifica se il pulsante di salvataggio pratica è
	     *              disabilitato per lo step attivo
	     */
	    this.isSaveEnabled = function () {
	      if (
	        self.dettPraticaSrvc.isSaveEnabled &&
	        typeof self.dettPraticaSrvc.isSaveEnabled === 'function'
	      ) {
	        return self.dettPraticaSrvc.isSaveEnabled();
	      }
	
	      return false;
	    };
	
	    /**
	     * @ngdoc method
	     * @name isPrevVisible
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Verifica se il pulsante "Indietro" è visibile per lo step
	     *              attivo
	     */
	    this.isPrevVisible = function () {
	      if (
	        self.dettPraticaSrvc.datiPratica &&
	        self.dettPraticaSrvc.datiPratica.stato === 'ANNULLATA'
	      ) {
	        return false;
	      }
	
	      if (
	        self.dettPraticaSrvc.datiPratica &&
	        self.dettPraticaSrvc.datiPratica.stato === 'RIFIUTATA'
	      ) {
	        return false;
	      }
	
	      var stepNumber = self.currentTabMacro.index + 1;
	
	      // Se ho dei sotto-step, verifico le proprietà del sotto-step attivo
	      // invece che del macro-step
	      if (
	        self.currentTabMicro['STEP' + stepNumber] &&
	        self.currentTabMicro['STEP' + stepNumber].operationsVisibility
	      ) {
	        return self.currentTabMicro['STEP' + stepNumber].operationsVisibility
	          .prev;
	      }
	
	      if (!self.currentTabMacro.operationsVisibility) {
	        return false;
	      }
	
	      return self.currentTabMacro.operationsVisibility.prev;
	    };
	
	    /**
	     * @ngdoc method
	     * @name isPrevEnabled
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Verifica se il pulsante 'Indietro' della pratica è
	     *              disabilitato per lo step attivo
	     */
	    this.isPrevEnabled = function () {
	      if (
	        self.dettPraticaSrvc.isPrevEnabled &&
	        typeof self.dettPraticaSrvc.isPrevEnabled === 'function'
	      ) {
	        return self.dettPraticaSrvc.isPrevEnabled();
	      }
	
	      return false;
	    };
	
	    /**
	     * @ngdoc method
	     * @name isNextVisible
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Verifica se il pulsante "Prosegui" è visibile per lo step
	     *              attivo
	     */
	    this.isNextVisible = function () {
	      if (
	        self.dettPraticaSrvc.datiPratica &&
	        self.dettPraticaSrvc.datiPratica.stato === 'ANNULLATA'
	      ) {
	        return false;
	      }
	
	      if (
	        self.dettPraticaSrvc.datiPratica &&
	        self.dettPraticaSrvc.datiPratica.stato === 'RIFIUTATA'
	      ) {
	        return false;
	      }
	
	      var stepNumber = self.currentTabMacro.index + 1;
	
	      // Se ho dei sotto-step, verifico le proprietà del sotto-step attivo
	      // invece che del macro-step
	      if (
	        self.currentTabMicro['STEP' + stepNumber] &&
	        self.currentTabMicro['STEP' + stepNumber].operationsVisibility
	      ) {
	        return self.currentTabMicro['STEP' + stepNumber].operationsVisibility
	          .next;
	      }
	
	      if (!self.currentTabMacro.operationsVisibility) {
	        return false;
	      }
	
	      return self.currentTabMacro.operationsVisibility.next;
	    };
	
	    /**
	     * @ngdoc method
	     * @name isNextEnabled
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Verifica se il pulsante 'Prosegui' della pratica è
	     *              disabilitato per lo step attivo
	     */
	    this.isNextEnabled = function () {
	      if (
	        self.dettPraticaSrvc.isNextEnabled &&
	        typeof self.dettPraticaSrvc.isNextEnabled === 'function'
	      ) {
	        return self.dettPraticaSrvc.isNextEnabled();
	      }
	
	      return false;
	    };
	
	    /**
	     * @ngdoc method
	     * @name isCompleteVisible
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Verifica se il pulsante "Completa" è visibile per lo step
	     *              attivo
	     */
	    this.isCompleteVisible = function () {
	      if (
	        self.dettPraticaSrvc.datiPratica &&
	        self.dettPraticaSrvc.datiPratica.stato === 'ANNULLATA'
	      ) {
	        return false;
	      }
	
	      if (
	        self.dettPraticaSrvc.datiPratica &&
	        self.dettPraticaSrvc.datiPratica.stato === 'RIFIUTATA'
	      ) {
	        return false;
	      }
	
	      var stepNumber = self.currentTabMacro.index + 1;
	
	      // Se ho dei sotto-step, verifico le proprietà del sotto-step attivo
	      // invece che del macro-step
	      if (
	        self.currentTabMicro['STEP' + stepNumber] &&
	        self.currentTabMicro['STEP' + stepNumber].operationsVisibility
	      ) {
	        return self.currentTabMicro['STEP' + stepNumber].operationsVisibility
	          .complete;
	      }
	
	      if (!self.currentTabMacro.operationsVisibility) {
	        return false;
	      }
	
	      return self.currentTabMacro.operationsVisibility.complete;
	    };
	
	    /**
	     * @ngdoc method
	     * @name isCompleteEnabled
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Verifica se il pulsante 'Prosegui' della pratica è
	     *              disabilitato per lo step attivo
	     */
	    this.isCompleteEnabled = function () {
	      if (
	        self.dettPraticaSrvc.isCompleteEnabled &&
	        typeof self.dettPraticaSrvc.isCompleteEnabled === 'function'
	      ) {
	        return self.dettPraticaSrvc.isCompleteEnabled();
	      }
	
	      return false;
	    };
	
	    /**
	     * @ngdoc method
	     * @name prevStep
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Permette all'utente di tornare indietro nei passaggi della
	     *              pratica
	     */
	    this.prevStep = function () {
	      self.spinner.pratica = true;
	      $q.all({
	        prevStep: self.dettPraticaSrvc.promiseCambiaStep('/indietroStep'),
	      })
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response.prevStep)) {
	              return;
	            }
	
	            self.dettPraticaSrvc.datiPratica = response.prevStep.data.result;
	            dettPraticaSrvc.generaTabs();
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason.prevStep);
	          }
	        )
	        .finally(function () {
	          self.spinner.pratica = false;
	        });
	    };
	
	    /**
	     * @ngdoc method
	     * @name nextStep
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Esegue le verifiche necessarie e fa avanzare l'utente al
	     *              passaggio successivo della pratica
	     */
	    this.nextStep = function () {
	      if (
	        self.dettPraticaSrvc.nextStep &&
	        typeof self.dettPraticaSrvc.nextStep === 'function'
	      ) {
	        return self.dettPraticaSrvc.nextStep();
	      }
	      return;
	    };
	
	    /**
	     * @ngdoc method
	     * @name setTabListIndex
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Imposta l'indice del tab in base a quanto riportato nella
	     *              pratica
	     */
	
	    /**
	     * @ngdoc method
	     * @name completaPratica
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Esegue le operazioni di chiusura e completamento della
	     *              pratica attiva
	     */
	    this.completaPratica = function () {
	      if (
	        self.dettPraticaSrvc.completed &&
	        typeof self.dettPraticaSrvc.completed === 'function'
	      ) {
	        return self.dettPraticaSrvc.completed();
	      }
	      return;
	    };
	
	    /**
	     * @ngdoc method
	     * @name openStepFinanziamentoPolizze
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Apre lo step 6, Pagamento - Sottostep 1, Scelta convenzione
	     */
	    this.openStepFinanziamentoPolizze = function () {
	      self.openDefinedTab(5, 0);
	    };
	
	    /**
	     * @ngdoc method
	     * @name getStyleTabMacro
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Imposta lo stile di visualizzazione per gli indicatori dei macro step
	     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
	     * @return {string} - Restituisce lo stile da applicare all'indicatore del macro step
	     */
	    this.getStyleTabMacro = function (currentTabIndex) {
	      // Pratica non navigabile
	      if (currentTabIndex < this.currentTabMacro.index) {
	        return 'progress-pass';
	      }
	
	      if (currentTabIndex === this.currentTabMacro.index) {
	        return 'progress-current';
	      }
	
	      return 'progress-next';
	    };
	
	    /**
	     * @ngdoc method
	     * @name getStyleTabMacroReadOnly
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Imposta lo stile di visualizzazione per gli indicatori dei macro step in modalità sola lettura
	     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
	     * @return {string} - Restituisce lo stile da applicare all'indicatore del macro step
	     */
	    this.getStyleTabMacroReadOnly = function (currentTabIndex) {
	      if (currentTabIndex < this.currentTabMacro.index) {
	        return 'progress-next-read';
	      }
	
	      if (currentTabIndex === this.currentTabMacro.index) {
	        return 'progress-current-read';
	      }
	
	      return 'progress-next-read';
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseAffidamenti
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Effettua una chiamata http per ricevere i dati degli affidamenti legati alla pratica
	     * @param {number} idPratica - ID Della pratica della quale recuperare i dati
	     * @return {Promise} - Ritorna una promise contenente i dati degli affidamenti legati alla pratica
	     */
	    this.promiseAffidamenti = function (idPratica) {
	      this.spinner.pratica = true;
	      return this.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.PRATICHE.DETTAGLIO +
	          idPratica +
	          '/affidamenti',
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name setAffidamentoAttuale
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Imposta l'affidamento corrente in base a quelli recuperati
	     *              per la pratica, basandosi sulla data apertura
	     */
	    this.setAffidamentoAttuale = function () {
	      self.dettPraticaSrvc.affidamento = self.affidamenti;
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseAnnullaPratica
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Effettua una chiamata http per eseguire l'annullamento della
	     *              pratica in lavorazione
	     * @return {Promise} - Ritorna una promise contenente l'esito
	     *         dell'annulamento pratica
	     */
	    this.promiseAnnullaPratica = function () {
	      this.spinner.pratica = true;
	      return this.$http({
	        method: 'DELETE',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.PRATICHE.DETTAGLIO +
	          self.dettPraticaSrvc.datiPratica.idPratica,
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name annullaPratica
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Richiede conferma e, in caso positivo, esegue l'annullamento
	     *              della pratica
	     */
	    this.annullaPratica = function () {
	      var modalController = function ($scope, LabelSrvc, $modalInstance) {
	        $scope.headerText = LabelSrvc.getLabel(
	          'label.dettagliopratica.annulla.header'
	        );
	        $scope.bodyText = LabelSrvc.getLabel(
	          'label.dettagliopratica.annulla.content'
	        );
	        $scope.cancelText = LabelSrvc.getLabel(
	          'button.dettagliopratica.annulla.cancel'
	        );
	        $scope.confirmText = LabelSrvc.getLabel(
	          'button.dettagliopratica.annulla.confirm'
	        );
	
	        $scope.optionSelected = function (result) {
	          $modalInstance.close(result);
	        };
	      };
	
	      modalController.$inject = ['$scope', 'LabelSrvc', '$modalInstance'];
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template:
	          '<creas-confirm-modal header-text="headerText" body-text="bodyText" cancel-text="cancelText" confirm-text="confirmText" option-selected="optionSelected(result)"></creas-confirm-modal>',
	        backdrop: 'static',
	        size: 'lg',
	        controller: modalController,
	      });
	
	      modalInstance.result.then(function (confirmResult) {
	        if (confirmResult !== true) {
	          return;
	        }
	
	        // Eseguo l'annullamento
	        $q.all({
	          annullamento: self.promiseAnnullaPratica(),
	        })
	          .then(
	            function (response) {
	              if (self.messaggiFctr.processaResponse(response.annullamento)) {
	                return;
	              }
	
	              if (response.annullamento.data.result !== true) {
	                return;
	              }
	
	              self.$state.go('creas-ricerca-pratiche');
	            },
	            function (reason) {
	              self.messaggiFctr.processaResponse(reason.annullamento);
	            }
	          )
	          .finally(function () {
	            self.spinner.pratica = false;
	          });
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseAnnullaFinanziamento
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Effettua una chiamata http per eseguire l'annullamento del finanziamento in lavorazione
	     * @return {Promise} - Ritorna una promise contenente l'esito
	     *         dell'annulamento finanziamento
	     */
	    this.promiseAnnullaFinanziamento = function () {
	      this.spinner.pratica = true;
	      return this.$http({
	        method: 'DELETE',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.FINANZIAMENTI +
	          '/' +
	          self.dettPraticaSrvc.getFinanziamentoBozza().idFinanziamentoPMI,
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name annullaPratica
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Richiede conferma e, in caso positivo, esegue l'annullamento
	     *              della pratica
	     */
	    this.annullaFinanziamento = function () {
	      var modalController = function ($scope, LabelSrvc, $modalInstance) {
	        $scope.headerText = LabelSrvc.getLabel(
	          'label.dettagliopratica.annulla.finanziamento.header'
	        );
	        $scope.bodyText = LabelSrvc.getLabel(
	          self.dettPraticaSrvc.datiPratica.step === 4
	            ? 'label.dettagliopratica.annulla.finanziamento.documenti.content'
	            : 'label.dettagliopratica.annulla.finanziamento.content'
	        );
	        $scope.cancelText = LabelSrvc.getLabel(
	          'button.dettagliopratica.annulla.cancel'
	        );
	        $scope.confirmText = LabelSrvc.getLabel(
	          'button.dettagliopratica.annulla.finanziamento.confirm'
	        );
	
	        $scope.optionSelected = function (result) {
	          $modalInstance.close(result);
	        };
	      };
	
	      modalController.$inject = ['$scope', 'LabelSrvc', '$modalInstance'];
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template:
	          '<creas-confirm-modal header-text="headerText" body-text="bodyText" cancel-text="cancelText" confirm-text="confirmText" option-selected="optionSelected(result)"></creas-confirm-modal>',
	        backdrop: 'static',
	        size: 'lg',
	        controller: modalController,
	      });
	
	      modalInstance.result.then(function (confirmResult) {
	        if (confirmResult !== true) {
	          return;
	        }
	
	        // Eseguo l'annullamento
	        $q.all({
	          annullamento: self.promiseAnnullaFinanziamento(),
	        })
	          .then(
	            function (response) {
	              if (self.messaggiFctr.processaResponse(response.annullamento)) {
	                return;
	              }
	              self.dettPraticaSrvc.isCancelFinanziamentoVisible = null;
	              self.dettPraticaSrvc.isCancelFinanziamentoEnabled = null;
	              self.dettPraticaSrvc.datiPratica =
	                response.annullamento.data.result;
	              self.dettPraticaSrvc.generaTabs();
	            },
	            function (reason) {
	              self.messaggiFctr.processaResponse(reason.annullamento);
	            }
	          )
	          .finally(function () {
	            self.spinner.pratica = false;
	          });
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseNuovaPratica
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Effettua una chiamata http per eseguire la creazione di una
	     *              nuova pratica
	     * @return {Promise} - Ritorna una promise contenente l'esito della
	     *         creazione della pratica
	     */
	    this.promiseNuovaPratica = function () {
	      var nuovaPratica = modelFctr.pratica();
	      // setto l'NDG
	      nuovaPratica.intestatario.ndg = self.$stateParams.ndg;
	      // Setto il codice prodotto CPT
	      nuovaPratica.prodotto.codiceProdottoCPT = self.$stateParams.codProdotto;
	
	      this.spinner.pratica = true;
	      return this.$http({
	        method: 'POST',
	        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICHE.DETTAGLIO,
	        data: nuovaPratica,
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name salvaPratica
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Esegue il salvataggio della pratica in lavorazione
	     */
	    this.salvaPratica = function () {
	      if (
	        self.dettPraticaSrvc.salva &&
	        typeof self.dettPraticaSrvc.salva === 'function'
	      ) {
	        return self.dettPraticaSrvc.salva();
	      }
	      return;
	    };
	
	    this.promiseRicercaClientiBanca = function (idPratica) {
	      var queryParamsObj = {
	        idPratica: idPratica,
	        firmatario: false,
	      };
	
	      var url = CONSTANTS.REST_ROOT + CONSTANTS.REST.CLIENTI.DETTAGLIO_CERCA;
	
	      return this.$http({
	        method: 'GET',
	        url: url,
	        params: queryParamsObj,
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name inizializzaPraticaEsistente
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Recupera i dati della pratica indicata come parametro
	     * @param {number}
	     *            idPratica - Identificativo della pratica da recuperare
	     */
	    this.inizializzaPraticaEsistente = function (idPratica) {
	      self.spinner.pratica = true;
	
	      $q.all({
	        datiPratica: self.dettPraticaSrvc.promiseDatiPratica(idPratica),
	        cliente: self.promiseRicercaClientiBanca(idPratica),
	      })
	        .then(
	          function (response) {
	            if (
	              self.messaggiFctr.processaResponse(response.datiPratica) ||
	              self.messaggiFctr.processaResponse(response.cliente)
	            ) {
	              self.dettPraticaSrvc.datiPratica = {};
	              self.dettPraticaSrvc.datiCliente = null;
	              self.affidamenti = [];
	              return;
	            }
	
	            self.dettPraticaSrvc.reset();
	
	            self.dettPraticaSrvc.datiPratica = response.datiPratica.data.result;
	            self.dettPraticaSrvc.finanziamento =
	              self.dettPraticaSrvc.getFinanziamentoBozza();
	
	            self.datiCliente = self.dettPraticaSrvc.datiCliente =
	              response.cliente.data.result;
	            self.affidamenti =
	              response.datiPratica.data.result.fidoNonOperativo;
	
	            self.setAffidamentoAttuale();
	            dettPraticaSrvc.generaTabs();
	            // if (
	            // self.dettPraticaSrvc.datiPratica.step &&
	            // self.dettPraticaSrvc.datiPratica.step > 1
	            // ) {
	            // self.openDefinedTab(self.dettPraticaSrvc.datiPratica.step);
	            // }
	            self.verificaStatoFido();
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason.datiPratica);
	            self.messaggiFctr.processaResponse(reason.affidamenti);
	            self.dettPraticaSrvc.datiPratica = {};
	            self.affidamenti = [];
	          }
	        )
	        .finally(function () {
	          self.spinner.pratica = false;
	        });
	    };
	
	    this.verificaStatoFido = function () {
	      if (self.dettPraticaSrvc.datiPratica.stato === 'GESTIONEPOLIZZE') {
	        var msg = null;
	        //TODO Spostare in messages.properties
	        if (
	          self.dettPraticaSrvc.datiPratica.fidoNonOperativo.stato === 'BLOCCATO'
	        ) {
	          msg =
	            "Attenzione, il fido è bloccato. E' necessario annullare l'utilizzo in corso. Confermi?";
	        } else if (
	          self.dettPraticaSrvc.datiPratica.fidoNonOperativo.stato ===
	          'DA_RINNOVARE'
	        ) {
	          var date = new Date(
	            self.dettPraticaSrvc.datiPratica.fidoNonOperativo.dataFineValidita
	          );
	          msg =
	            'Attenzione, il fido è scaduto in data ' +
	            date.getDate() +
	            '/' +
	            (date.getMonth() + 1) +
	            '/' +
	            date.getFullYear() +
	            ". E' necessario annullare l'utilizzo in corso. Confermi?";
	        }
	        if (msg) {
	          // Richiedo conferma prima di proseguire con l'avanzamento di step
	          var modalController = function ($scope, LabelSrvc, $modalInstance) {
	            $scope.headerText = LabelSrvc.getLabel('label.alertFido.header');
	            $scope.bodyText = msg;
	            $scope.cancelText = LabelSrvc.getLabel('label.alertFido.annulla');
	            $scope.confirmText = LabelSrvc.getLabel('label.alertFido.conferma');
	
	            $scope.optionSelected = function (result) {
	              $modalInstance.close(result);
	            };
	          };
	
	          modalController.$inject = ['$scope', 'LabelSrvc', '$modalInstance'];
	
	          var modalInstance = self.$uibModal.open({
	            animation: true,
	            template:
	              '<creas-confirm-modal header-text="headerText" body-text="bodyText" cancel-text="cancelText" confirm-text="confirmText" option-selected="optionSelected(result)"></creas-confirm-modal>',
	            backdrop: 'static',
	            size: 'lg',
	            controller: modalController,
	          });
	
	          modalInstance.result.then(function (confirmResult) {
	            if (confirmResult !== true) {
	              return;
	            }
	            // Eseguo l'annullamento
	            $q.all({
	              annullamento: self.promiseAnnullaFinanziamento(),
	            })
	              .then(
	                function (response) {
	                  if (
	                    self.messaggiFctr.processaResponse(response.annullamento)
	                  ) {
	                    return;
	                  }
	                  self.dettPraticaSrvc.isCancelFinanziamentoVisible = null;
	                  self.dettPraticaSrvc.isCancelFinanziamentoEnabled = null;
	                  self.dettPraticaSrvc.datiPratica =
	                    response.annullamento.data.result;
	                  self.dettPraticaSrvc.generaTabs();
	                },
	                function (reason) {
	                  self.messaggiFctr.processaResponse(reason.annullamento);
	                }
	              )
	              .finally(function () {
	                self.spinner.pratica = false;
	              });
	          });
	        }
	      }
	    };
	    /**
	     * @ngdoc method
	     * @name inizializzaNuovaPratica
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
	     * @description Recupera i dati necessari e genera la nuova pratica da
	     *              lavorare
	     */
	    this.inizializzaNuovaPratica = function () {
	      self.datiCliente = self.dettPraticaSrvc.getDatiCliente();
	
	      if (!self.$stateParams.ndg || self.$stateParams.ndg === '') {
	        self.noCustomerError = true;
	        return;
	      }
	
	      self.spinner.pratica = true;
	
	      // Genero la nuova pratica
	      $q.all({
	        nuovaPratica: self.promiseNuovaPratica(),
	      })
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response.nuovaPratica)) {
	              self.errorFromService = true;
	              self.ricercaClienteSrvc.preserveSearch = true;
	              self.$window.history.back();
	              return;
	            }
	
	            var param = self.$stateParams;
	            param.idPratica = response.nuovaPratica.data.result.idPratica;
	            param.ndg = response.nuovaPratica.data.result.intestatario.ndg;
	
	            self.$state.go('creas-dettaglio-pratica', param);
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason.nuovaPratica);
	            self.errorFromService = true;
	          }
	        )
	        .finally(function () {
	          self.spinner.pratica = false;
	        });
	    };
	
	    self.spinner.pratica = true;
	    this.userSrvc.abilitazioniPronte.then(function (result) {
	      // Verifico se Credito assicurativo è abilitato
	      // in caso contrario rimando alla home
	      self.spinner.pratica = false;
	      for (var i = 0; i < self.userSrvc.abilitazioni.length; i++) {
	        if (
	          self.userSrvc.abilitazioni[i].codice ===
	          'CreditoAssicurativoPMIAbilitato'
	        ) {
	          // Se ho ricevuto un id pratica dai parametri, eseguo il
	          // recupero dei dati altrimenti verifico di aver
	          // ricevuto i dati del cliente. Successivamente, elaboro
	          // le tab
	          if (self.$stateParams.idPratica) {
	            self.inizializzaPraticaEsistente(self.$stateParams.idPratica);
	          } else {
	            self.inizializzaNuovaPratica();
	          }
	          return;
	        }
	      }
	
	      self.$state.go('schedaCliente');
	    });
	  };
	
	  CreasDettaglioPraticaCtrl.$inject = [
	    '$http',
	    '$scope',
	    '$state',
	    '$stateParams',
	    '$window',
	    '$q',
	    '$httpParamSerializer',
	    '$uibModal',
	    'CONSTANTS',
	    'LabelSrvc',
	    'CreasMessaggiFctr',
	    'UserSrvc',
	    'CreasDettaglioPraticaSrvc',
	    'CreasModelFctr',
	    'CreasRicercaClienteSrvc',
	  ];
	
	  var TemplateUrl = function (CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'creasDettaglioPratica/creasDettaglioPratica.html'
	    );
	  };
	
	  TemplateUrl.$inject = ['CONSTANTS'];
	
	  var CreasDettaglioPraticaComponent = {
	    controller: CreasDettaglioPraticaCtrl,
	    controllerAs: 'creasDettaglioPraticaCtrl',
	    templateUrl: TemplateUrl,
	  };
	
	  angular
	    .module('cbl.insuranceloanpmi.mf')
	    .component('creasDettaglioPratica', CreasDettaglioPraticaComponent);
	})();


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.insuranceloanpmi.mf.directive:creasStatoAffidamento
	 * @restrict E
	 * @description Componente che gestisce il primo step "Stato Affidamento" del
	 *              dettaglio pratica
	 */
	(function() {
	  'use strict';
	  var CreasStatoAffidamentoCtrl = function(
	    $http,
	    $scope,
	    $state,
	    $stateParams,
	    $window,
	    $q,
	    $httpParamSerializer,
	    $uibModal,
	    $sce,
	    CONSTANTS,
	    labelSrvc,
	    messaggiFctr,
	    dettPraticaSrvc
	  ) {
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.$uibModal = $uibModal;
	    this.$sce = $sce;
	    this.messaggiFctr = messaggiFctr;
	    this.CONSTANTS = CONSTANTS;
	    $scope.msg = labelSrvc.getLabel;
	
	    this.idPratica = dettPraticaSrvc.datiPratica.idPratica;
	    this.dettPraticaSrvc = dettPraticaSrvc;
	    
	    // Spinner
	    this.spinner = this.dettPraticaSrvc.spinner;
	    this.subSpinner = {
	      utilizzi: false
	    };
	    
	    // Filtro visualizzazione utilizzi estinti
	    this.visualizzaEstinti = false;
	    this.utilizziAffidamento = [];
	    var self = this;
	
	    /**
		 * @ngdoc method
		 * @name promiseUtilizzi
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasStatoAffidamento
		 * @description Effettua una chiamata http per eseguire la ricerca degli
		 *              utilizzi inerenti l'affidamento
		 * @param {boolean}
		 *            visualizzaEstinti - Filtro che permette di richiedere o meno
		 *            anche gli utilizzi estinti
		 * @return {Promise} - Ritorna una promise contenente gli utilizzi trovati
		 *         in base ai filtri di ricerca
		 */
	    this.promiseUtilizzi = function(visualizzaEstinti) {
	      var queryParamsObj = {
	        estinti: visualizzaEstinti
	      };
	      
	      var queryParams = $httpParamSerializer(queryParamsObj);
	      
	      return this.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.PRATICHE.DETTAGLIO +
	          self.idPratica +
	          '/finanziamenti' +
	          (queryParams ? '?' + queryParams : '')
	      });
	    };
	
	    /**
		 * @ngdoc method
		 * @name ricercaUtilizzi
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasStatoAffidamento
		 * @description Esegue la ricerca degli utilizzi inerenti l'affidamento
		 */
	    this.ricercaUtilizzi = function() {
	      self.subSpinner.utilizzi = true;
	    	
	      $q
	        .all({
	          utilizzi: self.promiseUtilizzi(self.visualizzaEstinti)
	        })
	        .then(
	          function(response) {
	            if (self.messaggiFctr.processaResponse(response.utilizzi)) {
	              self.utilizziAffidamento = [];
	              return;
	            }
	
	            self.utilizziAffidamento = response.utilizzi.data.result;
	          },
	          function(reason) {
	            self.messaggiFctr.processaResponse(reason.utilizzi);
	            self.utilizziAffidamento = [];
	          }
	        )
	        .finally(function() {
	        	self.subSpinner.utilizzi = false;
	        });
	    };
	    
	    /**
		 * @ngdoc method
		 * @name generaStileStatoFido
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasStatoAffidamento
		 * @description Restiutisce lo stile da applicare al testo dello stato affidamento
		 */
	    this.generaStileStatoFido = function() {
	    	
	    	if (!self.dettPraticaSrvc.datiPratica.fidoNonOperativo) {
	    		return {};
	    	}
	    	
	    	switch(self.dettPraticaSrvc.datiPratica.fidoNonOperativo.stato) {
	    		case 'DA_EROGARE':
	    		case 'DA_RINNOVARE':
	    			return { 'text-xl': true };
	    		case 'VALIDO':
	    			return { 'text-success': true };
	    		case 'BLOCCATO':
	    			return { 'text-danger': true };
	    	}
	    	
	    	return {};
	    }
	
	    /**
		 * @ngdoc method
		 * @name openDettagliUtilizzo
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasStatoAffidamento
		 * @description Apre una finestra modale con i dettagli delle polizze
		 *              assegnate all'utilizzo
		 * @param {Object}
		 *            utilizzo - Oggetto che rappresenta l'utilizzo di cui
		 *            visualizzare i dettagli
		 */
	    this.openDettagliUtilizzo = function(utilizzo) {
	      var modalController = function(
	        $scope,
	        $modalInstance,
	        $http,
	        $q,
	        $state,
	        LabelSrvc,
	        CreasMessaggiFctr,
	        CreasDettaglioPraticaSrvc,
	        items
	      ) {
	    	this.$state = $state;
	        $scope.msg = LabelSrvc.getLabel;
	        $scope.utilizzo = items.utilizzo;
	        $scope.polizzeUtilizzo = [];
	        $scope.spinner = false;
	                
	        $scope.stampaLetteraUtilizzo = function() {
	        	$scope.spinner = true;
	        	
	        	$http({
	    			method: 'POST',
	    			url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICHE.DETTAGLIO + CreasDettaglioPraticaSrvc.datiPratica.idPratica + '/richiestautilizzo',
	    			data: utilizzo
	    		}) 
	    		.then(
	    			function(response) {
	    				$scope.download(response.data.result, 'lettera-utilizzo.pdf');
	    			},
	    			function(reason) {
	    				CreasMessaggiFctr.processaResponse(reason);
	    			}
	    		).finally(function() {
	    			$scope.spinner = false;
	            });
	        }
	        
	        // Converte la stringa di dati a 64 bit in byteArrays
	        $scope.b64toByteArrays = function(b64Data, sliceSize) {
	              sliceSize = sliceSize || 512;
	              var byteCharacters = atob(b64Data);
	              var byteArrays = [];
	
	              for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	                    var slice = byteCharacters.slice(offset, offset + sliceSize);
	
	                    var byteNumbers = new Array(slice.length);
	                    for (var i = 0; i < slice.length; i++) {
	                          byteNumbers[i] = slice.charCodeAt(i);
	                    }
	
	                    var byteArray = new Uint8Array(byteNumbers);
	
	                    byteArrays.push(byteArray);
	              }
	              return byteArrays;
	        };
	
	        // Genera un oggetto di tipo Blob (per IE) o di tipo File e fa partire il download
	        $scope.download = function(strData, fileName) {
	              var byteArrays = $scope.b64toByteArrays(strData);
	
	              var isChromium = window.chrome, winNav = window.navigator, vendorName = winNav.vendor, isOpera = winNav.userAgent.indexOf("OPR") > -1, isIEedge =
	                          winNav.userAgent.indexOf("Edge") > -1, isIOSChrome = winNav.userAgent.match("CriOS");
	                          
	              var blob = null;
	              var blobUrl = null;
	              if (isIOSChrome ||
	                    (isChromium !== null && isChromium !== undefined && vendorName === "Google Inc." && isOpera === false && isIEedge === false)) {
	                    // Google Chrome
	                    blob = new Blob(byteArrays, {
	                         type : 'application/octet-stream'
	                    });
	                    blobUrl = URL.createObjectURL(blob);
	                    // soluzione per costringere chrome a mostrare nome ed estensione del file
	                    var a = document.createElement("a");
	                    document.body.appendChild(a);
	                    a.style = "display: none";
	                    a.href = blobUrl;
	                    a.download = fileName;
	                    a.click();
	                    window.URL.revokeObjectURL(fileUrl);
	                    a.parentNode.removeChild(a);
	              } else {
	                    // non Google Chrome
	                    // Blob per internet explorer
	                    if (navigator.msSaveOrOpenBlob) {
	                         blob = new Blob(byteArrays, {
	                               type : 'application/octet-stream'
	                         });
	                         blobUrl = URL.createObjectURL(blob);
	                          navigator.msSaveOrOpenBlob(blob, fileName);
	                    } // File per altri browser
	                    else {
	                         var file = new File(byteArrays, fileName, {
	                               type : 'application/octet-stream;'
	                         });
	                         var fileUrl = URL.createObjectURL(file);
	                          window.open(fileUrl);
	                    }
	              }
	        };
	
	        $scope.ok = function() {
	          $modalInstance.close();
	        };
	      };
	
	      modalController.$inject = [
	        '$scope',
	        '$modalInstance',
	        '$http',
	        '$q',
	        '$state',
	        'LabelSrvc',
	        'CreasMessaggiFctr',
	        'CreasDettaglioPraticaSrvc',
	        'items'
	      ];
	
	      this.$uibModal.open({
	        animation: true,
	        templateUrl: 'dettagliUtilizzo.tmpl.html',
	        backdrop: 'static',
	        size: 'lg',
	        resolve: {
	          items: function() {
	            return {affidamento: self.dettPraticaSrvc.datiPratica.fidoNonOperativo.idFidoNonOperativoPMI, utilizzo: utilizzo};
	          }
	        },
	        controller: modalController
	      });
	    };
	    
	    /**
		 * @ngdoc method
		 * @name richiediAffidamento
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasStatoAffidamento
		 * @description Avvia la richiesta di affidamento per la pratica
		 */
	    this.richiediAffidamento = function() {
	    	self.spinner.pratica = true;
	    	
			self.$http({
				method: 'PUT',
				url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICHE.DETTAGLIO + self.dettPraticaSrvc.datiPratica.idPratica + '/richiediFido'
			})
			.then(
				function(response) {
					if (self.messaggiFctr.processaResponse(response)) {
						return;
					}
					
					dettPraticaSrvc.datiPratica = response.data.result;
					dettPraticaSrvc.generaTabs();
				},
				function(reason) {
					self.messaggiFctr.processaResponse(reason);
				}
			).finally(function() {
	        	self.spinner.pratica = false;
	        });
	    }
	    
	    /**
		 * @ngdoc method
		 * @name rinnovaAffidamento
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasStatoAffidamento
		 * @description Avvia la procedura di rinnovo affidamento per la pratica
		 */
	    this.rinnovaAffidamento = function() {
	    	self.spinner.pratica = true;
	    	
	    	self.$http({
				method: 'PUT',
				url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICHE.DETTAGLIO + self.dettPraticaSrvc.datiPratica.idPratica + '/rinnovaFido'
			})
			.then(
				function(response) {
					if (self.messaggiFctr.processaResponse(response)) {
						return;
					}
					 self.$state.go('creas-dettaglio-pratica', {
				    	  ndg: response.data.result.intestatario.ndg,
				    	  idPratica: response.data.result.idPratica
				      });				
				},
				function(reason) {
					self.messaggiFctr.processaResponse(reason);
				}
			).finally(function() {
				self.spinner.pratica = false;
	        });
	    }
	    
	    /**
		 * @ngdoc method
		 * @name finanziaPolizze
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasStatoAffidamento
		 * @description Porta la pratica al passaggio di finanziamento polizze
		 */
	    this.finanziaPolizze = function() {
	    	self.spinner.pratica = true;
	    	
	    	self.$http({
				method: 'PUT',
				url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICHE.DETTAGLIO + self.dettPraticaSrvc.datiPratica.idPratica + '/finanziaPolizze'
			})
			.then(
				function(response) {
					if (self.messaggiFctr.processaResponse(response)) {
						return;
					}
					
					dettPraticaSrvc.datiPratica = response.data.result;
					dettPraticaSrvc.generaTabs();
				},
				function(reason) {
					self.messaggiFctr.processaResponse(reason);
				}
			).finally(function() {
				self.spinner.pratica = false;
	        });
	    }
	    
	    /**
		 * @ngdoc method
		 * @name totaleErogato
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasStatoAffidamento
		 * @description Calcola e restituisce il totale degli importi erogati per gli affidamenti
		 * @returns {number} La somma degli importi erogati
		 */
	    this.totaleErogato = function() {
	    	var tot = 0;
	    	
	    	if (self.utilizziAffidamento && self.utilizziAffidamento.length > 0) {
	    		for(var i = 0; i < self.utilizziAffidamento.length; i++) {
	    			tot = tot + self.utilizziAffidamento[i].importoErogato;
	    		}
	    	} 
	    	
	    	return tot;
	    }
	    
	    /**
		 * @ngdoc totaleResiduo
		 * @name totaleErogato
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasStatoAffidamento
		 * @description Calcola e restituisce il totale degli importi residui da erogare per gli affidamenti
		 * @returns {number} La somma degli importi residui da erogare
		 */
	    this.totaleResiduo = function() {
	    	var tot = 0;
	    	
	    	if (self.utilizziAffidamento && self.utilizziAffidamento.length > 0) {
	    		for(var i = 0; i < self.utilizziAffidamento.length; i++) {
	    			tot = tot + self.utilizziAffidamento[i].importoResiduo;
	    		}
	    	} 
	    	
	    	return tot;
	    }
	
	    // Eseguo di default una ricerca per visualizzare gli utilizzi correnti
	    self.ricercaUtilizzi();
	  };
	
	  CreasStatoAffidamentoCtrl.$inject = [
	    '$http',
	    '$scope',
	    '$state',
	    '$stateParams',
	    '$window',
	    '$q',
	    '$httpParamSerializer',
	    '$uibModal',
	    '$sce',
	    'CONSTANTS',
	    'LabelSrvc',
	    'CreasMessaggiFctr',
	    'CreasDettaglioPraticaSrvc'
	  ];
	
	  var TemplateUrl = function(CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'creasDettaglioPratica/creasStatoAffidamento/creasStatoAffidamento.html'
	    );
	  };
	
	  TemplateUrl.$inject = ['CONSTANTS'];
	
	  var CreasStatoAffidamentoComponent = {
	    bindings: {},
	    controller: CreasStatoAffidamentoCtrl,
	    controllerAs: 'creasStatoAffidamentoCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.insuranceloanpmi.mf')
	    .component('creasStatoAffidamento', CreasStatoAffidamentoComponent);
	})();


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.insuranceloanpmi.mf.directive:creasRichiestaFido
	 * @restrict E
	 * @description Componente che gestisce il secondo step "Richiesta fido" del dettaglio pratica
	 * @param {Object[]} steps - Un array che rappresenta i sotto-step da visualizzare
	 * @param {Object} currentStep - Rappresenta il sotto-step attualmente visualizzato
	 */
	(function() {
	  'use strict';
	  var CreasRichiestaFidoCtrl = function(
	    $http,
	    $scope,
	    $state,
	    $stateParams,
	    $window,
	    $q,
	    $httpParamSerializer,
	    CONSTANTS,
	    labelSrvc,
	    messaggiFctr,
	    dettPraticaSrvc
	  ) {
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.messaggiFctr = messaggiFctr;
	    this.CONSTANTS = CONSTANTS;
	    this.dettPraticaSrvc = dettPraticaSrvc;
	    this.$scope = $scope;
	    $scope.msg = labelSrvc.getLabel;
	
	    // Spinner
	    this.spinner = dettPraticaSrvc.spinner;
	
	    var self = this;
	    
	    /**
		 * @ngdoc method
		 * @name generaClasseContainer
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRichiestaFido
		 * @description Genera la classe da attribuire al container del componente, per gestire la visualizzazione dei sotto-step
		 * @return {string} - La classe attribuita al container del componente
		 */
	    this.generaClasseContainer = function() {
	    	if (self.currentStep.index > 0) {
	    		return 'richiesta-fido-container';
	    	}
	    	
	    	return '';
	    }
	
	    /**
		 * @ngdoc method
		 * @name getStyleTabMicro
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRichiestaFido
		 * @description Imposta lo stile di visualizzazione per gli indicatori dei micro step
		 * @param {string} currentStep - Il macro step correntemente visualizzato
		 * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
		 * @return {string} - Restituisce lo stile da applicare all'indicatore del micro step
		 */
	    this.getStyleTabMicro = function(currentTabIndex) {
	      // Pratica navigabile
		  if (self.dettPraticaSrvc.isPraticaNavigabile() === true) {
			if (currentTabIndex === self.currentStep.index) {
		      return 'ab-step-tabs cliccabile active-read';
		    }
			
	  	    return 'ab-step-tabs cliccabile ab-last-read';
	      }
	    	
	      // Pratica non navigabile
	      if (currentTabIndex < self.currentStep.index) {
	        return 'ab-step-tabs';
	      }
	      
	      if (self.currentStep.index > 0 && currentTabIndex > 0) {
	    	  return 'ab-step-tabs hidden-tab';
	      }
	      
	      if (currentTabIndex === self.currentStep.index) {
	        return 'ab-step-tabs active';
	      }
	      
	      return "ab-step-tabs ab-last";
	    };
	    
	    /**
		 * @ngdoc method
		 * @name getStyleStepMicro
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRichiestaFido
		 * @description Imposta lo stile di visualizzazione per la barra dell'indicatore del micro step
		 * @param {string} currentStep - Il macro step correntemente visualizzato
		 * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
		 * @return {string} - Restituisce lo stile da applicare alla barra dell'indicatore del micro step
		 */
	    this.getStyleStepMicro = function(currentTabIndex) {
	      if (self.dettPraticaSrvc.isPraticaNavigabile() === true) {
	    	return 'step read';
		  }
			
	      if (currentTabIndex < self.currentStep.index) {
	        return 'step success';
	      }
	      
	      return 'step';
	    };
	    
	    /**
		 * @ngdoc method
		 * @name microTabClicked
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRichiestaFido
		 * @description Apre il micro-tab selezionato
		 * @param {Object} tab - il micro-tab selezionato
		 */
	    this.microTabClicked = function(tab) {
	    	if (self.dettPraticaSrvc.isPraticaNavigabile() !== true) {
	    		return;
	    	}
	    	
	    	var selectedTab = tab;
	    	
	    	if (selectedTab.index === 1 || selectedTab.index === 2) {
	      	  selectedTab = self.steps[1];
	        } 
	    	
	    	self.dettPraticaSrvc.apriMicroTab(selectedTab, 2);
	    }
	
	    // Configuro il comportamento del pulsante prosegui per lo step
	    dettPraticaSrvc.nextStep = function() {
	      self.spinner.pratica = true;
	      
	      self.dettPraticaSrvc.datiPratica.fidoNonOperativo.fasciaFido =
	        self.dettPraticaSrvc.fasciaAffidamento;
	      
	      $q
	        .all({salvaFido: self.dettPraticaSrvc.promiseSalvaFido()})
	        .then(function(response) {
	          if (response.salvaFido.data.result) {
	            $q
	              .all({
	                nextStep: self.dettPraticaSrvc.promiseCambiaStep('/avantiStep')
	              })
	              .then(
	                function(response) {
	                  if (self.messaggiFctr.processaResponse(response.nextStep)) {
	                    return;
	                  }
	                  
	                  self.dettPraticaSrvc.datiPratica = response.nextStep.data.result;
	                  dettPraticaSrvc.generaTabs();
	                },
	                function(reason) {
	                  self.messaggiFctr.processaResponse(reason.nextStep);
	                }
	              )
	              .finally(function() {
	                self.spinner.pratica = false;
	              });
	          } else {
	            self.spinner.pratica = false;
	          }
	        });
	    };
	
	    // Configuro il comportamento del pulsante salva per lo step
	    dettPraticaSrvc.salva = function() {
	      self.spinner.pratica = true;
	      
	      self.dettPraticaSrvc.datiPratica.fidoNonOperativo.fasciaFido =
	        self.dettPraticaSrvc.fasciaAffidamento;
	      
	      $q
	        .all({salvaFido: self.dettPraticaSrvc.promiseSalvaFido()})
	        .then(
	          function(response) {
	            self.dettPraticaSrvc.datiPratica = response.salvaFido.data.result;
	            if (self.messaggiFctr.processaResponse(response.salvaFido)) {
	              return;
	            }
	          },
	          function(reason) {
	            self.messaggiFctr.processaResponse(reason.salvaFido);
	          }
	        )
	        .finally(function() {
	          self.spinner.pratica = false;
	        });
	    };
	  };
	
	  CreasRichiestaFidoCtrl.$inject = [
	    '$http',
	    '$scope',
	    '$state',
	    '$stateParams',
	    '$window',
	    '$q',
	    '$httpParamSerializer',
	    'CONSTANTS',
	    'LabelSrvc',
	    'CreasMessaggiFctr',
	    'CreasDettaglioPraticaSrvc'
	  ];
	
	  var TemplateUrl = function(CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'creasDettaglioPratica/creasRichiestaFido/creasRichiestaFido.html'
	    );
	  };
	
	  TemplateUrl.$inject = ['CONSTANTS'];
	
	  var CreasRichiestaFidoComponent = {
	    bindings: {
	      steps: '<',
	      currentStep: '<'
	    },
	    controller: CreasRichiestaFidoCtrl,
	    controllerAs: 'creasRichiestaFidoCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.insuranceloanpmi.mf')
	    .component('creasRichiestaFido', CreasRichiestaFidoComponent);
	})();


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.insuranceloanpmi.mf.directive:creasDatiAffidamento
	 * @restrict E
	 * @description Componente che gestisce il primo sotto-step "Dati Affidamento"
	 *              dello step "Richiesta fido"
	 * @param {Object}
	 *            step - Rappresenta la configurazione da assegnare a questo
	 *            sotto-step
	 */
	(function() {
	  'use strict';
	  var CreasDatiAffidamentoCtrl = function(
	    $http,
	    $scope,
	    $state,
	    $stateParams,
	    $window,
	    $q,
	    $httpParamSerializer,
	    CONSTANTS,
	    labelSrvc,
	    messaggiFctr,
	    dettPraticaSrvc
	  ) {
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.messaggiFctr = messaggiFctr;
	    this.dettPraticaSrvc = dettPraticaSrvc;
	    this.CONSTANTS = CONSTANTS;
	    $scope.msg = labelSrvc.getLabel;
	
	    this.datiCliente = this.dettPraticaSrvc.getDatiCliente();
	    this.firmatari = this.dettPraticaSrvc.firmatariCliente;
	    this.fasceAffidamento = [];
	    
	    this.spinner = this.dettPraticaSrvc.spinner;
	    
	    this.subSpinner = {
	      firmatari: false,
	      fasce: false
	    };
	
	    var self = this;
	
	    // Configuro l'abilitazione dei pulsanti di scorrimento tra gli step
	    dettPraticaSrvc.isCancelEnabled = function() {
	      return true;
	    };
	
	    dettPraticaSrvc.isSaveEnabled = function() {
	      return (
	        (self.dettPraticaSrvc.firmatario !== null || self.dettPraticaSrvc.datiPratica.idPraticaRinnovata) &&
	        self.dettPraticaSrvc.fasciaAffidamento !== null
	      );
	    };
	
	    dettPraticaSrvc.isNextEnabled = function() {
	      return (
	    	(self.dettPraticaSrvc.firmatario !== null || self.dettPraticaSrvc.datiPratica.idPraticaRinnovata) &&
	        self.dettPraticaSrvc.fasciaAffidamento !== null
	      );
	    };
	
	    /**
		 * @ngdoc method
		 * @name promiseFasceAffidamento
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDatiAffidamento
		 * @description Effettua una chiamata http per recuperare le fasce di
		 *              affidamento abilitate
		 * @return {Promise} - Ritorna una promise contenente le fasce di
		 *         affidamento abilitate
		 */
	    this.promiseFasceAffidamento = function() {
	      return this.$http({
	        method: 'GET',
	        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.FASCEAFFIDAMENTO
	      });
	    };
	
	    /**
		 * @ngdoc method
		 * @name recuperaFasceAffidamento
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDatiAffidamento
		 * @description Esegue il recupero della fasce di affidamento selezionabili
		 */
	    this.recuperaFasceAffidamento = function() {
	      self.subSpinner.fasce = true;
	    	
	      $q
	        .all({
	          fasceAffidamento: self.promiseFasceAffidamento()
	        })
	        .then(
	          function(response) {
	            if (self.messaggiFctr.processaResponse(response.fasceAffidamento)) {
	              self.fasceAffidamento = [];
	              return;
	            }
	            self.fasceAffidamento = response.fasceAffidamento.data.result;
	            self.impostaFasciaSelezionata();
	          },
	          function(reason) {
	            self.messaggiFctr.processaResponse(reason.fasceAffidamento);
	            self.fasceAffidamento = [];
	          }
	        )
	        .finally(function() {
	        	self.subSpinner.fasce = false;
	        });
	    };
	
	    /**
		 * @ngdoc method
		 * @name impostaFasciaSelezionata
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDatiAffidamento
		 * @description Visualizza come selezionata nella tendina la fascia
		 *              assegnata alla pratica
		 */
	    this.impostaFasciaSelezionata = function() {
	      angular.forEach(self.fasceAffidamento, function(value) {
	        if (
	          self.dettPraticaSrvc.fasciaAffidamento &&
	          self.dettPraticaSrvc.fasciaAffidamento.idFasciaFidoPMI ===
	            value.idFasciaFidoPMI
	        ) {
	          self.dettPraticaSrvc.fasciaAffidamento = value;
	        } else if (
	          self.dettPraticaSrvc.datiPratica.fidoNonOperativo &&
	          self.dettPraticaSrvc.datiPratica.fidoNonOperativo.fasciaFido &&
	          self.dettPraticaSrvc.datiPratica.fidoNonOperativo.fasciaFido
	            .idFasciaFidoPMI === value.idFasciaFidoPMI
	        ) {
	          self.dettPraticaSrvc.fasciaAffidamento = value;
	        }
	      });
	    };
	
	    /**
		 * @ngdoc method
		 * @name getFirmatariCliente
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDatiAffidamento
		 * @description Recupera i firmatari del cliente con una struttura standard,
		 *              valorizzata a seconda del tipo di dato ottenuto (DB Banca o
		 *              Cerved)
		 */
	    this.getFirmatariCliente = function() {
	      self.subSpinner.firmatari = true;
	    	
	      self.firmatari = [];
	      $q
	        .all({
	          firmatariCliente: self.dettPraticaSrvc.promiseFirmatariCliente()
	        })
	        .then(
	          function(response) {
	            if (
	              self.messaggiFctr.processaResponse(response.firmatariCliente) !==
	              false
	            ) {
	              return;
	            }
	            // imposta l'array firmatari locale e del service
	            self.firmatari = response.firmatariCliente.data.result;
	            self.dettPraticaSrvc.firmatariCliente = response.firmatariCliente.data.result;
	            self.impostaFirmatarioSelezionato();
	          },
	          function(reason) {
	            self.messaggiFctr.processaResponse(reason.firmatariCliente);
	            self.firmatariCliente = [];
	          }
	        )
	        .finally(
	        	function() {
	        		self.subSpinner.firmatari = false;
	        	}
	        );
	      return;
	    };
	
	    /**
		 * @ngdoc method
		 * @name impostaFirmatarioSelezionato
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDatiAffidamento
		 * @description Visualizza come selezionato il firmatario scelto per la
		 *              pratica
		 */
	    this.impostaFirmatarioSelezionato = function() {
	      angular.forEach(self.firmatari, function(value) {
	        if (
	          self.dettPraticaSrvc.firmatario &&
	          self.dettPraticaSrvc.firmatario.ndg === value.ndg
	        ) {
	          self.dettPraticaSrvc.firmatario = value;
	        } else if (
	          self.dettPraticaSrvc.datiPratica.intestatario &&
	          self.dettPraticaSrvc.datiPratica.intestatario.relazioniAnagrafiche &&
	          self.dettPraticaSrvc.datiPratica.intestatario.relazioniAnagrafiche[0]
	            .ndg === value.ndg
	        ) {
	          self.dettPraticaSrvc.firmatario = value;
	        }
	      });
	    };
	
	    /**
		 * @ngdoc method
		 * @name setFirmatarioPratica
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDatiAffidamento
		 * @description Esegue il salvataggio del firmatario per la pratica in
		 *              lavorazione
		 * @param {Object}
		 *            firmatario - Il firmatario da assegnare alla pratica
		 */
	    this.setFirmatarioPratica = function(firmatario) {
	      var firmatarioObject = {
	        formaCostitutiva: firmatario.formaCostitutiva,
	        intestazione: firmatario.intestazione,
	        ndg: firmatario.ndg,
	        idAnagrafica: firmatario.idAnagrafica
	      };
	      // this.dettPraticaSrvc.firmatario = firmatarioObject;
	      this.dettPraticaSrvc.datiPratica.intestatario.relazioniAnagrafiche = [
	        firmatarioObject
	      ];
	    };
	    this.recuperaFasceAffidamento();
	    this.getFirmatariCliente();
	  };
	
	  CreasDatiAffidamentoCtrl.$inject = [
	    '$http',
	    '$scope',
	    '$state',
	    '$stateParams',
	    '$window',
	    '$q',
	    '$httpParamSerializer',
	    'CONSTANTS',
	    'LabelSrvc',
	    'CreasMessaggiFctr',
	    'CreasDettaglioPraticaSrvc'
	  ];
	
	  var TemplateUrl = function(CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'creasDettaglioPratica/creasRichiestaFido/creasDatiAffidamento/creasDatiAffidamento.html'
	    );
	  };
	
	  TemplateUrl.$inject = ['CONSTANTS'];
	
	  var CreasDatiAffidamentoComponent = {
	    bindings: {
	      step: '='
	    },
	    controller: CreasDatiAffidamentoCtrl,
	    controllerAs: 'creasDatiAffidamentoCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.insuranceloanpmi.mf')
	    .component('creasDatiAffidamento', CreasDatiAffidamentoComponent);
	})();


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.insuranceloanpmi.mf.directive:creasGestioneFirmatari
	 * @restrict E
	 * @description Componente che gestisce il secondo sotto-step "Gestione Firmatari" dello step "Richiesta fido"
	 */
	(function() {
	  'use strict';
	  var CreasGestioneFirmatariCtrl = function(
	    $http,
	    $scope,
	    $state,
	    $stateParams,
	    $window,
	    $q,
	    $httpParamSerializer,
	    CONSTANTS,
	    labelSrvc,
	    messaggiFctr,
	    dettPraticaSrvc
	  ) {
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.messaggiFctr = messaggiFctr;
	    this.dettPraticaSrvc = dettPraticaSrvc;
	    this.CONSTANTS = CONSTANTS;
	    $scope.msg = labelSrvc.getLabel;
	
	    this.selezioneFirmaElettronica = false;
	    this.aderitoFirmaElettronica = false;
	    this.fieldConfiguration;
	    this.showSecondLevelKey = false;
	    // Workaround per bug widget fea
	    this.anagraficaFea = angular.copy(this.dettPraticaSrvc.datiPratica.intestatario);
	    this.anagraficaFea.naturaGiuridica = this.anagraficaFea.formaCostitutiva;
	    
	    // Spinner
	    this.spinner = dettPraticaSrvc.spinner;
	
	    var self = this;
	
	    // Configuro l'abilitazione dei pulsanti di scorrimento tra gli step
	    dettPraticaSrvc.isCancelEnabled = function() {
	      return true;
	    };
	
	    dettPraticaSrvc.isPrevEnabled = function() {
	      return true;
	    };
	
	    dettPraticaSrvc.isNextEnabled = function() {
	      return true;
	    };
	    
	    dettPraticaSrvc.nextStep = function() {
	        self.spinner.pratica = true;
	        $q
	          .all({nextStep: dettPraticaSrvc.promiseCambiaStep('/passaValutazione')})
	          .then(
	            function(response) {
	              if (self.messaggiFctr.processaResponse(response.nextStep)) {
	                return;
	              }
	              
	              dettPraticaSrvc.datiPratica = response.nextStep.data.result;
	              dettPraticaSrvc.generaTabs();
	            },
	            function(reason) {
	              self.messaggiFctr.processaResponse(reason.nextStep);
	            }
	          )
	          .finally(function() {
	            self.spinner.pratica = false;
	          });
	      };
	      
	      this.promiseFieldConfigurator = function() {
	    	  
	    	  return self.$http({
	    	        method: 'GET',
	    	        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.FIELDCONFIGURATOR
	    	  });
	    	  
	      }
	      
	      // Recupero la configurazione dei campi
	      this.loadFieldConfiguration = function() {
	          $q
	            .all({fldConfig: self.promiseFieldConfigurator()})
	            .then(
	              function(response) {
	                if (self.messaggiFctr.processaResponse(response.fldConfig)) {
	                  return;
	                }
	                
	                self.fieldConfiguration = response.fldConfig.data.result;
	              },
	              function(reason) {
	                self.messaggiFctr.processaResponse(reason.fldConfig);
	              }
	            );
	      }
	      
	      if (!self.fieldConfiguration) {
	    	  self.loadFieldConfiguration();
	      }
	      
	  };
	
	  CreasGestioneFirmatariCtrl.$inject = [
	    '$http',
	    '$scope',
	    '$state',
	    '$stateParams',
	    '$window',
	    '$q',
	    '$httpParamSerializer',
	    'CONSTANTS',
	    'LabelSrvc',
	    'CreasMessaggiFctr',
	    'CreasDettaglioPraticaSrvc'
	  ];
	
	  var TemplateUrl = function(CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'creasDettaglioPratica/creasRichiestaFido/creasGestioneFirmatari/creasGestioneFirmatari.html'
	    );
	  };
	
	  TemplateUrl.$inject = ['CONSTANTS'];
	
	  var CreasGestioneFirmatariComponent = {
	    bindings: {},
	    controller: CreasGestioneFirmatariCtrl,
	    controllerAs: 'creasGestioneFirmatariCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.insuranceloanpmi.mf')
	    .component('creasGestioneFirmatari', CreasGestioneFirmatariComponent);
	})();


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.insuranceloanpmi.mf.directive:creasValutazionePratica
	 * @restrict E
	 * @description Componente che gestisce il terzo step "Valutazione" del dettaglio pratica
	 * @param {Object[]} steps - Un array che rappresenta i sotto-step da visualizzare
	 * @param {Object} currentStep - Rappresenta il sotto-step attualmente visualizzato
	 */
	(function() {
	  'use strict';
	  var CreasValutazionePraticaCtrl = function(
	    $http,
	    $scope,
	    $state,
	    $stateParams,
	    $window,
	    $q,
	    $httpParamSerializer,
	    CONSTANTS,
	    labelSrvc,
	    messaggiFctr,
	    dettPraticaSrvc
	  ) {
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.messaggiFctr = messaggiFctr;
	    this.CONSTANTS = CONSTANTS;
	    this.dettPraticaSrvc = dettPraticaSrvc;
	    $scope.msg = labelSrvc.getLabel;
	
	    this.spinner = this.dettPraticaSrvc.spinner;
	    
	    var self = this;
	    // Spinner
	
	    // Se l'integrazione anagrafica è richiesta da Cerved si abilita la sezione
		// apposita.
	    // Il comportamento associato al pulsante Prosegui viene impostato in base a
		// questo.
	    if (
	      dettPraticaSrvc.datiPratica.infoCerved &&
	      dettPraticaSrvc.datiPratica.infoCerved.richiestaAnagrafica
	    ) {
	      dettPraticaSrvc.datiClienteCerved = dettPraticaSrvc.datiPratica.infoCerved;
	      dettPraticaSrvc.generaTabs();
	      
	      dettPraticaSrvc.nextStep = function() {
	        self.spinner.pratica = true;
	        $q
	          .all({nextStep: dettPraticaSrvc.promiseCambiaStep('/avantiStep')})
	          .then(
	            function(response) {
	              if (self.messaggiFctr.processaResponse(response.nextStep)) {
	                return;
	              }
	              
	              dettPraticaSrvc.datiPratica = response.nextStep.data.result;
	              dettPraticaSrvc.generaTabs();
	            },
	            function(reason) {
	              self.messaggiFctr.processaResponse(reason.nextStep);
	            }
	          )
	          .finally(function() {
	            self.spinner.pratica = false;
	          });
	      };
	    } else {
	      dettPraticaSrvc.nextStep = function() {
	        self.spinner.pratica = true;
	        $q
	          .all({
	            nextStep: dettPraticaSrvc.promiseCambiaStep('/passaSceltaConto')
	          })
	          .then(
	            function(response) {
	              if (self.messaggiFctr.processaResponse(response.nextStep)) {
	                return;
	              }
	              
	              dettPraticaSrvc.datiPratica = response.nextStep.data.result;
	              dettPraticaSrvc.generaTabs();
	            },
	            function(reason) {
	              self.messaggiFctr.processaResponse(reason.nextStep);
	            }
	          )
	          .finally(function() {
	            self.spinner.pratica = false;
	          });
	      };
	    }
	
	    /**
		 * @ngdoc method
		 * @name getStyleTabMicro
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazionePratica
		 * @description Imposta lo stile di visualizzazione per gli indicatori dei micro step
		 * @param {string} currentStep - Il macro step correntemente visualizzato
		 * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
		 * @return {string} - Restituisce lo stile da applicare all'indicatore del micro step
		 */
	    this.getStyleTabMicro = function(currentTabIndex) {
	    	// Pratica navigabile
	  	  if (self.dettPraticaSrvc.isPraticaNavigabile() === true) {
	  		if (currentTabIndex === self.currentStep.index) {
	  	      return 'ab-step-tabs cliccabile active-read';
	  	    }
	  		
		    return 'ab-step-tabs cliccabile ab-last-read';
	  	  }
	      	
		    // Pratica non navigabile
		    if (currentTabIndex < self.currentStep.index) {
		      return 'ab-step-tabs';
		    }
		    
		    if (currentTabIndex === self.currentStep.index) {
		      return 'ab-step-tabs active';
		    }
		    
		    return "ab-step-tabs ab-last";
	    };
	    
	    /**
		 * @ngdoc method
		 * @name getStyleStepMicro
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazionePratica
		 * @description Imposta lo stile di visualizzazione per la barra dell'indicatore del micro step
		 * @param {string} currentStep - Il macro step correntemente visualizzato
		 * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
		 * @return {string} - Restituisce lo stile da applicare alla barra dell'indicatore del micro step
		 */
		  this.getStyleStepMicro = function(currentTabIndex) {
			if (self.dettPraticaSrvc.isPraticaNavigabile() === true) {
				return 'step read';
			}
			
		    if (currentTabIndex < self.currentStep.index) {
		      return 'step success';
		    }
		    
		    return 'step';
		  };
	  };
	
	  CreasValutazionePraticaCtrl.$inject = [
	    '$http',
	    '$scope',
	    '$state',
	    '$stateParams',
	    '$window',
	    '$q',
	    '$httpParamSerializer',
	    'CONSTANTS',
	    'LabelSrvc',
	    'CreasMessaggiFctr',
	    'CreasDettaglioPraticaSrvc'
	  ];
	
	  var TemplateUrl = function(CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'creasDettaglioPratica/creasValutazionePratica/creasValutazionePratica.html'
	    );
	  };
	
	  TemplateUrl.$inject = ['CONSTANTS'];
	
	  var CreasValutazionePraticaComponent = {
	    bindings: {
	      steps: '<',
	      currentStep: '<'
	    },
	    controller: CreasValutazionePraticaCtrl,
	    controllerAs: 'creasValutazionePraticaCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.insuranceloanpmi.mf')
	    .component('creasValutazionePratica', CreasValutazionePraticaComponent);
	})();


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
	 * @restrict E
	 * @description Componente che gestisce il primo sotto-step "Gestione Firmatari"
	 *              dello step "Valutazione"
	 */
	(function() {
	  'use strict';
	  var CreasValutazioneCervedCtrl = function(
	    $http,
	    $scope,
	    $state,
	    $stateParams,
	    $window,
	    $q,
	    $httpParamSerializer,
	    CONSTANTS,
	    labelSrvc,
	    messaggiFctr,
	    dettPraticaSrvc
	  ) {
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.messaggiFctr = messaggiFctr;
	    this.dettPraticaSrvc = dettPraticaSrvc;
	    this.CONSTANTS = CONSTANTS;
	    $scope.msg = labelSrvc.getLabel;
	
	    this.firmatariAttuali = null;
	    this.nuovoFirmatario = null;
	    
	    this.isClienteCerved = false;
	    
	    this.valutazioneMerito = false;
	    this.esitoValutazioneMerito = false;
	
	    this.verificheAmministrative = false;
	    this.verificheAmministrativePending = false;
	    this.esitoVerificheAmministrative = false;
	
	    // Spinner
	    this.spinner = this.dettPraticaSrvc.spinner;
	    this.subSpinner = {
	      valutazione: false
	    };
	
	    // Configuro l'abilitazione dei pulsanti di scorrimento tra gli step
		dettPraticaSrvc.isCancelVisible = function() {
			return !(self.valutazioneMerito || self.verificheAmministrative);
		};
	      
	    dettPraticaSrvc.isCancelEnabled = function() {
	      return true;
	    };
	
	    dettPraticaSrvc.isSaveEnabled = function() {
	      return false;
	    };
	
	    dettPraticaSrvc.isPrevEnabled = function() {
	      return true;
	    };
	
	    dettPraticaSrvc.isNextEnabled = function() {
	      return self.esitoValutazioneMerito && self.esitoVerificheAmministrative;
	    };
	
	    var self = this;
	
	    /**
		 * @ngdoc method
		 * @name promiseVerificaMeritoCreditizio
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
		 * @description Effettua una chiamata http per eseguire la verifica del
		 *              merito creditizio ed ottenerne l'esito
		 * @return {Promise} - Ritorna una promise contenente l'esito della verifica
		 */
	    this.promiseVerificaMeritoCreditizio = function(idPratica) {
	      return this.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.PRATICHE.DETTAGLIO +
	          self.dettPraticaSrvc.datiPratica.idPratica +
	          '/valutazione/meritoCreditizio'
	      });
	    };
	
	    /**
		 * @ngdoc method
		 * @name promiseVerificheAmministrative
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
		 * @description Effettua una chiamata http per avviare le verifiche
		 *              amministrative sulla pratica
		 * @return {Promise} - Ritorna una promise contenente l'esito o lo stato
		 *         della verifica
		 */
	    this.promiseVerificheAmministrative = function(ndgNuovoFirmatario) {
	    	
	      var queryParamsObj = {};
	      
	      if (ndgNuovoFirmatario) {
	    	  queryParamsObj.ndg = ndgNuovoFirmatario;
	      }
	    	
	      return this.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.PRATICHE.DETTAGLIO +
	          self.dettPraticaSrvc.datiPratica.idPratica +
	          '/valutazione/verificheAmministrative',
	        params: queryParamsObj
	      });
	    };
	    
	    /**
		 * @ngdoc method
		 * @name recuperaDatiPratica
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
		 * @description Recupera i dati della pratica corrente
		 */
	    this.recuperaDatiPratica = function(keepSpinner) {
	    	self.subSpinner.valutazione = true;
	    	
	    	$q
	        .all({
	          datiPratica: self.dettPraticaSrvc.promiseDatiPratica(self.dettPraticaSrvc.datiPratica.idPratica),
	        })
	        .then(
	          function(response) {
	            if (
	              self.messaggiFctr.processaResponse(response.datiPratica)
	            ) {
	              self.dettPraticaSrvc.datiPratica = {};
	              return;
	            }
	            
	            self.firmatariAttuali = null;
	        	self.nuovoFirmatario = null;
	            self.dettPraticaSrvc.datiPratica = response.datiPratica.data.result;
	            self.verificaInfoCerved();
	          },
	          function(reason) {
	            self.messaggiFctr.processaResponse(reason.datiPratica);
	            self.dettPraticaSrvc.datiPratica = {};
	          }
	        )
	        .finally(function() {
	        	if (keepSpinner !== true) {        		
	        		self.subSpinner.valutazione = false;
	        	}
	        });
	    }
	
	    /**
		 * @ngdoc method
		 * @name verificaInfoCerved
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
		 * @description Verifica gli esiti presenti sulla pratica per le verifiche
		 *              amministrative
		 */
	    this.verificaInfoCerved = function() {
	    	
	    	self.isClienteCerved = self.dettPraticaSrvc.isClienteCerved();
	    	
	    	if (self.dettPraticaSrvc.datiPratica.infoCerved) {
	    		
	    		// Valutazione merito creditizio
	    		
	    		if (self.dettPraticaSrvc.datiPratica.infoCerved.scoreNegativo === undefined || self.dettPraticaSrvc.datiPratica.infoCerved.scoreNegativo === null) {
	    			self.valutazioneMerito = false;
	    			self.esitoValutazioneMerito = false;
	    			
	    			self.subSpinner.valutazione = false;
	    		} else if (self.dettPraticaSrvc.datiPratica.infoCerved.scoreNegativo === 0) {
	    			self.valutazioneMerito = true;
					self.esitoValutazioneMerito = false;
					
					self.subSpinner.valutazione = false;
	    		} else if (self.dettPraticaSrvc.datiPratica.infoCerved.scoreCgsx === 0) {
	    			self.valutazioneMerito = true;
					self.esitoValutazioneMerito = false;
					
					self.subSpinner.valutazione = false;
	    		} else {
	    			self.valutazioneMerito = true;
					self.esitoValutazioneMerito = true; 
					
					self.subSpinner.valutazione = false;
	    		}
	    		
	    		if (self.dettPraticaSrvc.datiPratica.infoCerved.scoreNegativo === undefined || self.dettPraticaSrvc.datiPratica.infoCerved.scoreNegativo === null) {
	    			self.verificheAmministrative = false;
					self.esitoVerificheAmministrative = false;
					
					self.subSpinner.valutazione = false;
	    		} else if (self.isClienteCerved === false || /* Issue CAPMI-228 */ self.dettPraticaSrvc.datiPratica.intestatario.formaCostitutiva === 'IND') { 
	    			//Forzatura per sbloccare il pulsante
	    			self.verificheAmministrative = true;
					self.esitoVerificheAmministrative = true;
					self.subSpinner.valutazione = false;
	    		} else if (self.dettPraticaSrvc.datiPratica.infoCerved.verificaFirma === undefined || self.dettPraticaSrvc.datiPratica.infoCerved.verificaFirma === null || self.dettPraticaSrvc.datiPratica.infoCerved.verificaFirma === -1) {
	    			self.verificheAmministrative = true;
	    			self.verificheAmministrativePending = true;
					self.esitoVerificheAmministrative = false;
					
					self.subSpinner.valutazione = false;
	    		} else if(self.dettPraticaSrvc.datiPratica.infoCerved.verificaFirma === 0){
	    			self.verificheAmministrative = true;
	    			self.verificheAmministrativePending = false;
	    			self.esitoVerificheAmministrative = false;
	    			
	    			self.getFirmatariCliente();
	    		} else if(self.dettPraticaSrvc.datiPratica.infoCerved.verificaFirma === 1){
	    			self.verificheAmministrative = true;
	    			self.verificheAmministrativePending = false;
	    			self.esitoVerificheAmministrative = true;
	    			
	    			self.subSpinner.valutazione = false;
	    		}    		
	    	}
	    	
	    }
	
	    /**
		 * @ngdoc method
		 * @name eseguiValutazioni
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
		 * @description Lancia l'esecuzione delle verifiche di merito creditizio e
		 *              amministrative e ne recupera l'esito
		 */
	    this.eseguiValutazioni = function() {
	    	self.subSpinner.valutazione = true;
	    	
	    	if (self.isClienteCerved === false || /* Issue CAPMI-228 */ self.dettPraticaSrvc.datiPratica.intestatario.formaCostitutiva === 'IND') {
	    		self.eseguiVerificaMeritoCreditizio();
	    		return;
	    	}
	    	
	    	self.eseguiVerificaMeritoCreditizio(self.eseguiVerificheAmministrative);
	    };
	    
	    /**
		 * @ngdoc method
		 * @name eseguiVerificaMeritoCreditizio
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
		 * @description Lancia l'esecuzione della verifica di merito creditizio
		 */
	    this.eseguiVerificaMeritoCreditizio = function(callOnSuccess) {
	      self.subSpinner.valutazione = true;
	      
	      $q
	        .all({
	        	meritoCreditizio: self.promiseVerificaMeritoCreditizio(),
	        })
	        .then(
	          function(response) {
	            if (self.messaggiFctr.processaResponse(response.meritoCreditizio)) {
	            	self.recuperaDatiPratica();
	            	return;
	            }
	            
	            if (typeof callOnSuccess === 'function') {
	            	callOnSuccess();
	            } else {            	
	            	self.recuperaDatiPratica();
	            }
	            
	          },
	          function(reason) {
	            self.messaggiFctr.processaResponse(reason.meritoCreditizio);
	            self.recuperaDatiPratica();
	          }
	        )
	        .finally(function() { });
	    };
	
	    /**
		 * @ngdoc method
		 * @name eseguiVerificheAmministrative
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
		 * @description Lancia l'esecuzione o richiede lo stato delle sole verifiche
		 *              amministrative e ne recupera l'esito
		 */
	    this.eseguiVerificheAmministrative = function() {
	      self.subSpinner.valutazione = true;
	      
	      var ndgNuovoFirmatario = null;
	      
	      if (self.nuovoFirmatario) {
	    	  ndgNuovoFirmatario = self.nuovoFirmatario.ndg;
	      }
	      
	      $q
	        .all({
	          verificheAmministrative: self.promiseVerificheAmministrative(ndgNuovoFirmatario)
	        })
	        .then(
	          function(response) {
	            self.messaggiFctr.processaResponse(response.verificheAmministrative);       	            
	          },
	          function(reason) {
	            self.messaggiFctr.processaResponse(reason.verificheAmministrative);
	          }
	        )
	        .finally(function() {
	          self.recuperaDatiPratica(true);
	        });
	    };
	    
	    /**
		 * @ngdoc method
		 * @name getFirmatariCliente
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
		 * @description Recupera i firmatari del cliente
		 */ 
	    this.getFirmatariCliente = function() {    	
			self.subSpinner.valutazione = true;
			$q
			.all({
				firmatariCliente: self.dettPraticaSrvc.promiseFirmatariCliente()
			})
			.then(
				function(response) {
					if (self.messaggiFctr.processaResponse(response.firmatariCliente) !== false) {
						self.subSpinner.valutazione = false;
						return;
					}
					
					self.dettPraticaSrvc.firmatariCliente = response.firmatariCliente.data.result;
					self.getFirmatariPratica();
				},
				function(reason) {
					self.dettPraticaSrvc.firmatariCliente = [];
					self.messaggiFctr.processaResponse(reason.firmatariCliente);
				}
			);
	    };
	    
	    /**
		 * @ngdoc method
		 * @name getFirmatariPratica
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
		 * @description Recupera i firmatari già valutati per la pratica
		 */ 
	    this.getFirmatariPratica = function() {
			self.subSpinner.valutazione = true;
			$q
			.all({
				firmatariPratica: self.dettPraticaSrvc.promiseFirmatariVerificati()
			})
			.then(
				function(response) {
					if (self.messaggiFctr.processaResponse(response.firmatariPratica) !== false) {
						return;
					}
					
					self.firmatariAttuali = response.firmatariPratica.data.result;
				},
				function(reason) {
					self.dettPraticaSrvc.firmatariCliente = [];
					self.messaggiFctr.processaResponse(reason.firmatariPratica);
				}
			)
			.finally(
				function() {
					self.subSpinner.valutazione = false;
				}
			);
	    };
	    
	    /**
		 * @ngdoc method
		 * @name isFirmatarioNonValido
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
		 * @description Permette di verificare se il firmatario passato è o meno selezionabile per eseguire la valutazione
		 * @param {object} firmatario - L'oggetto firmatario da valutare
		 * @return {boolean} - Restituisce true se il firmatario non è selezionabile per la valutazione (ad esempio, è già stato valutato con esito negativo), o false se invece è selezionabile
		 */
	    this.isFirmatarioNonValido = function(firmatario) {
	    	if (self.firmatariAttuali && self.firmatariAttuali.length) {    		
	    		for(var i = 0; i < self.firmatariAttuali.length; i++) {
	    			if (self.firmatariAttuali[i].cfFirmatario.toUpperCase() === firmatario.codiceFiscale.toUpperCase() && self.firmatariAttuali[i].esito === 'KO') {
	    				return true;
	    			}
	    		}
	    	}
	    	
	    	return false;
	    };
	    
	    // Carico i dati della pratica
	    this.recuperaDatiPratica();
	  };
	
	  CreasValutazioneCervedCtrl.$inject = [
	    '$http',
	    '$scope',
	    '$state',
	    '$stateParams',
	    '$window',
	    '$q',
	    '$httpParamSerializer',
	    'CONSTANTS',
	    'LabelSrvc',
	    'CreasMessaggiFctr',
	    'CreasDettaglioPraticaSrvc'
	  ];
	
	  var TemplateUrl = function(CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'creasDettaglioPratica/creasValutazionePratica/creasValutazioneCerved/creasValutazioneCerved.html'
	    );
	  };
	
	  TemplateUrl.$inject = ['CONSTANTS'];
	
	  var CreasValutazioneCervedComponent = {
	    bindings: {},
	    controller: CreasValutazioneCervedCtrl,
	    controllerAs: 'creasValutazioneCervedCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.insuranceloanpmi.mf')
	    .component('creasValutazioneCerved', CreasValutazioneCervedComponent);
	})();


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.insuranceloanpmi.mf.directive:creasIntegrazioneAnagrafica
	 * @restrict E
	 * @description Componente che gestisce il secondo sotto-step "Integrazione
	 *              Anagrafica" dello step "Valutazione"
	 */
	(function() {
	  'use strict';
	  var CreasIntegrazioneAnagraficaCtrl = function(
	    $http,
	    $scope,
	    $state,
	    $stateParams,
	    $window,
	    $q,
	    $httpParamSerializer,
	    $cacheFactory,
	    $location,
	    CONSTANTS,
	    labelSrvc,
	    messaggiFctr,
	    dettPraticaSrvc
	  ) {
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.$cacheFactory = $cacheFactory;
	    this.$location = $location;
	    this.messaggiFctr = messaggiFctr;
	    this.dettPraticaSrvc = dettPraticaSrvc;
	    this.CONSTANTS = CONSTANTS;
	    $scope.msg = labelSrvc.getLabel;
	
	    this.datiFirmatario = null;
	    this.datiTitolari = null;
	    this.datiCliente = null;
	
	    // Spinner
	    this.spinner = this.dettPraticaSrvc.spinner;
	    this.subSpinner = {
	      cliente: false,
	      firmatari: false,
	      titolari: false
	    };
	
	    this.esiti = {
	      cliente: false,
	      firmatari: false,
	      titolari: false
	    };
	
	    // Configuro l'abilitazione dei pulsanti di scorrimento tra gli step
	    dettPraticaSrvc.isSaveEnabled = function() {
	      return false;
	    };
	
	    dettPraticaSrvc.isPrevEnabled = function() {
	      return true;
	    };
	
	    dettPraticaSrvc.isNextEnabled = function() {
	      return self.esiti.cliente === true && self.esiti.firmatari === true && self.esiti.titolari === true;
	    };
	
	    dettPraticaSrvc.nextStep = function() {
	      self.spinner.pratica = true;
	      $q
	        .all({
	          nextStep: dettPraticaSrvc.promiseCambiaStep('/passaSceltaConto')
	        })
	        .then(
	          function(response) {
	            if (self.messaggiFctr.processaResponse(response.nextStep)) {
	              return;
	            }
	            
	            dettPraticaSrvc.datiPratica = response.nextStep.data.result;
	            dettPraticaSrvc.generaTabs();
	          },
	          function(reason) {
	            self.messaggiFctr.processaResponse(reason.nextStep);
	          }
	        )
	        .finally(function() {
	          self.spinner.pratica = false;
	        });
	    };
	
	    var self = this;
	
	    /**
		 * @ngdoc method
		 * @name promiseIntegrazioneFirmatari
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasIntegrazioneAnagrafica
		 * @description Effettua una chiamata http per eseguire l'integrazione dei
		 *              dati dei firmatari nel DB Banca
		 * @return {Promise} - Ritorna una promise contenente l'esito
		 *         dell'integrazione
		 */
	    this.promiseIntegrazioneFirmatari = function() {
	      return this.$http({
	        method: 'POST',
	        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CLIENTI.INTEGRAZIONE.FIRMATARI
	      });
	    };
	
	    /**
		 * @ngdoc method
		 * @name promiseIntegrazioneCliente
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasIntegrazioneAnagrafica
		 * @description Effettua una chiamata http per eseguire l'integrazione dei
		 *              dati del cliente nel DB Banca
		 * @return {Promise} - Ritorna una promise contenente l'esito
		 *         dell'integrazione
		 */
	    this.promiseIntegrazioneCliente = function() {
	      return this.$http({
	        method: 'POST',
	        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CLIENTI.INTEGRAZIONE.CLIENTE
	      });
	    };
	
	    /**
		 * @ngdoc method
		 * @name recuperaDatiCliente
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasIntegrazioneAnagrafica
		 * @description Esegue il recupero dei dati del cliente e dei firmatari
		 */
	    this.recuperaDatiCliente = function() {
	      self.subSpinner.firmatari = true;
	      CblBrioLoader.hideLoader();
	      $q
	        .all({
	          datiCliente: self.dettPraticaSrvc.promiseDatiClienteIntegrazione()
	        })
	        .then(
	          function(response) {
	            if (self.messaggiFctr.processaResponse(response.datiCliente)) {
	              return;
	            }
	            
	            // Titolari
	            self.esiti.titolari = true;
	            
	            if (
	              response.datiCliente.data.result.titolari &&
	              response.datiCliente.data.result.titolari.length > 0
	            ) {
	              self.datiTitolari = [];
	              for (
	                var i = 0;
	                i < response.datiCliente.data.result.titolari.length;
	                i++
	              ) {
	                self.datiTitolari.push(
	                  response.datiCliente.data.result.titolari[i]
	                );
	                
	                if (
	                  response.datiCliente.data.result.titolari[i].prospetto
	                    .stato === 'INCORSO'
	                ) {
	                  self.esiti.titolari = false;
	                }
	              }
	            }
	            
	            // Firmatario
	            self.datiFirmatario = response.datiCliente.data.result.firmatario;
	            
	            if (self.datiFirmatario && self.datiFirmatario.prospetto && (
	              self.datiFirmatario.prospetto.stato === 'INCORSO')
	            ) {
	              self.esiti.firmatari = false;
	            } else {
	              self.esiti.firmatari = true;
	            }
	
	            // Persona Giuridica
	            self.datiCliente = response.datiCliente.data.result.giuridica;
	            if (
	              self.datiCliente.prospetto.stato === 'INCORSO'
	            ) {
	              self.esiti.cliente = false;
	            } else {
	              self.esiti.cliente = true;
	            }
	          },
	          function(reason) {
	            self.messaggiFctr.processaResponse(reason.datiCliente);
	          }
	        )
	        .finally(function() {
	          self.subSpinner.firmatari = false;
	        });
	    };
	    
	    /**
		 * @ngdoc method
		 * @name integrazioneSocietaAbilitata
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasIntegrazioneAnagrafica
		 * @description Verifica se è possibile eseguire l'integrazione dei dati della società
		 * Sarà possibile eseguirla quando sia i dati del titolare, sia dei firmatari sono integrati
		 */
	    this.integrazioneSocietaAbilitata = function() {
	    	
	    	// Verifico, se presente, il firmatario
	    	if (this.datiFirmatario && this.datiFirmatario.prospetto && this.datiFirmatario.prospetto.stato === 'INCORSO') {
					return false;
	    	}
	    	
	    	// Verifico, se presenti, i titolari
	    	if (this.datiTitolari && this.datiTitolari.length && this.datiTitolari.length > 0) {
	    		for(var i = 0; i < this.datiTitolari.length; i++) {
	    			if (this.datiTitolari[i].prospetto.stato === 'INCORSO') {
	    				return false;
	    			}
	    		}
	    	}
	    	
	    	return true;
	    }
	
	    /**
		 * @ngdoc method
		 * @name eseguiIntegrazioneFirmatari
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasIntegrazioneAnagrafica
		 * @description Esegue l'integrazione dei dati dei firmatari
		 */
	    this.eseguiIntegrazioneFirmatari = function(firmatario) {
	        var CACHE_ID = 'creas-integr-pf';
	        var cache = self.$cacheFactory.get(CACHE_ID) || self.$cacheFactory(CACHE_ID);
	        cache.put('backUrl', self.$location.path());
	        self.$state.transitionTo('censimentoPersonaFisica', {
	            idAnagrafica: firmatario.idAnagrafica,
	            ndg: firmatario.ndg,
	            retId: CACHE_ID
	        }, {
	            reload: true,
	            notify: true
	        });
	    };
	
	    /**
		 * @ngdoc method
		 * @name eseguiIntegrazioneCliente
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasIntegrazioneAnagrafica
		 * @description Esegue l'integrazione dei dati del cliente
		 */
	    this.eseguiIntegrazioneCliente = function() {
	    	var CACHE_ID = 'creas-integr-pg';
	    	var DEST_ROUTE = 'censimentoPersonaGiuridica';
	    	if(self.datiCliente.anagrafica.formaCostitutiva === 'IND'){
	    		CACHE_ID = 'creas-integr-pf';
	        	DEST_ROUTE = 'censimentoPersonaFisica';
	    	}    	
	        var cache = self.$cacheFactory.get(CACHE_ID) || self.$cacheFactory(CACHE_ID);
	        cache.put('backUrl', self.$location.path());
	        self.$state.transitionTo(DEST_ROUTE, {
	            idAnagrafica: self.datiCliente.anagrafica.idAnagrafica,
	            ndg: self.datiCliente.anagrafica.ndg,
	            retId: CACHE_ID
	        }, {
	            reload: true,
	            notify: true
	        });
	    };
	
	    this.recuperaDatiCliente();
	  };
	
	  CreasIntegrazioneAnagraficaCtrl.$inject = [
	    '$http',
	    '$scope',
	    '$state',
	    '$stateParams',
	    '$window',
	    '$q',
	    '$httpParamSerializer',
	    '$cacheFactory',
	    '$location',
	    'CONSTANTS',
	    'LabelSrvc',
	    'CreasMessaggiFctr',
	    'CreasDettaglioPraticaSrvc'
	  ];
	
	  var TemplateUrl = function(CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'creasDettaglioPratica/creasValutazionePratica/creasIntegrazioneAnagrafica/creasIntegrazioneAnagrafica.html'
	    );
	  };
	
	  TemplateUrl.$inject = ['CONSTANTS'];
	
	  var CreasIntegrazioneAnagraficaComponent = {
	    bindings: {},
	    controller: CreasIntegrazioneAnagraficaCtrl,
	    controllerAs: 'creasIntegrazioneAnagraficaCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.insuranceloanpmi.mf')
	    .component(
	      'creasIntegrazioneAnagrafica',
	      CreasIntegrazioneAnagraficaComponent
	    );
	})();


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.insuranceloanpmi.mf.directive:creasSceltaConto
	 * @restrict E
	 * @description Componente che gestisce il quarto step "SCelta Conto" del dettaglio pratica
	 * @param {number} id-pratica - Rappesenta l'ID univoco della pratica in lavorazione
	 */
	(function() {
	  'use strict';
	  var CreasSceltaContoCtrl = function(
	    $http,
	    $scope,
	    $state,
	    $stateParams,
	    $window,
	    $q,
	    $httpParamSerializer,
	    CONSTANTS,
	    labelSrvc,
	    messaggiFctr,
	    dettPraticaSrvc
	  ) {
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.messaggiFctr = messaggiFctr;
	    this.dettPraticaSrvc = dettPraticaSrvc;
	    this.CONSTANTS = CONSTANTS;
	    $scope.msg = labelSrvc.getLabel;
	
	    // Spinner
	    this.spinner = this.dettPraticaSrvc.spinner;
	    this.subSpinner = {
	      conto: false
	    };
	
	    this.ibanAddebito = null;
	    this.esitoSalvataggio = false;
	    var self = this;
	
	    // Configuro l'abilitazione dei pulsanti di scorrimento tra gli step
	    dettPraticaSrvc.isSaveEnabled = function() {
	      return !!self.dettPraticaSrvc.ibanAddebito;
	    };
	
	    dettPraticaSrvc.isPrevEnabled = function() {
	      return true;
	    };
	
	    dettPraticaSrvc.isNextEnabled = function() {
	      return self.dettPraticaSrvc.ibanAddebito !== null;
	    };
	
	    dettPraticaSrvc.salva = function() {
	      self.spinner.pratica = true;
	      
	      self.dettPraticaSrvc.datiPratica.fidoNonOperativo.contoAppoggio =
	        self.dettPraticaSrvc.ibanAddebito;
	      
	      $q
	        .all({salvaPratica: dettPraticaSrvc.promiseSalvaFido('/salvaConto')})
	        .then(
	          function(response) {
	            dettPraticaSrvc.datiPratica = response.salvaPratica.data.result;
	            if (self.messaggiFctr.processaResponse(response.salvaPratica)) {
	              return;
	            }
	          },
	          function(reason) {
	            self.messaggiFctr.processaResponse(reason.salvaPratica);
	          }
	        )
	        .finally(function() {
	          self.spinner.pratica = false;
	        });
	    };
	
	    dettPraticaSrvc.nextStep = function() {
	      self.spinner.pratica = true;
	      
	      self.dettPraticaSrvc.datiPratica.fidoNonOperativo.contoAppoggio =
	        self.dettPraticaSrvc.ibanAddebito;
	      
	      $q
	        .all({salvaPratica: dettPraticaSrvc.promiseSalvaFido('/salvaConto')})
	        .then(function(res) {
	          if (res.salvaPratica.data.result) {
	            $q
	              .all({
	                nextStep: dettPraticaSrvc.promiseCambiaStep('/passaDocumenti')
	              })
	              .then(
	                function(response) {
	                  if (self.messaggiFctr.processaResponse(response.nextStep)) {
	                    return;
	                  }
	                  
	                  dettPraticaSrvc.datiPratica = response.nextStep.data.result;
	                  dettPraticaSrvc.generaTabs();
	                },
	                function(reason) {
	                  self.messaggiFctr.processaResponse(reason.nextStep);
	                }
	              )
	              .finally(function() {
	                self.spinner.pratica = false;
	              });
	          } else {
	            self.spinner.pratica = false;
	          }
	        });
	    };
	
	    /**
		 * @ngdoc method
		 * @name salvaIbanAddebito
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaConto
		 * @description Esegue il salvataggio dell'iban per la pratica
		 */
	    this.salvaIbanAddebito = function() {
	      if (!self.ibanAddebito) {
	        return;
	      }
	      if (self.ibanAddebito && self.ibanAddebito.trim() === '') {
	        return;
	      }
	      
	      self.subSpinner.conto = true;
	
	      $q
	        .all({
	          salvataggioiban: self.dettPraticaSrvc.promiseSalvataggioIban(
	            self.ibanAddebito
	          )
	        })
	        .then(
	          function(response) {
	            if (self.messaggiFctr.processaResponse(response.salvataggioiban)) {
	              self.esitoSalvataggio = false;
	              return;
	            }
	            
	            self.dettPraticaSrvc.datiPratica.fidoNonOperativo.contoAppoggio =
	              response.salvataggioiban.data.result;
	            
	            self.dettPraticaSrvc.ibanAddebito = self.dettPraticaSrvc.datiPratica.fidoNonOperativo.contoAppoggio;
	          },
	          function(reason) {
	            self.messaggiFctr.processaResponse(reason.salvataggioiban);
	            self.esitoSalvataggio = false;
	          }
	        )
	        .finally(function() {
	          self.subSpinner.conto = false;
	        });
	    };
	    
	    // Se ho disponibile il conto di addebito, lo mostro in visualizzazione
	    if (self.dettPraticaSrvc.datiPratica.fidoNonOperativo.contoAppoggio && self.dettPraticaSrvc.datiPratica.fidoNonOperativo.contoAppoggio.ibanEsterno) {
	      self.ibanAddebito = self.dettPraticaSrvc.datiPratica.fidoNonOperativo.contoAppoggio.ibanEsterno;
	      self.dettPraticaSrvc.ibanAddebito = self.dettPraticaSrvc.datiPratica.fidoNonOperativo.contoAppoggio;
	    }
	  };
	
	  CreasSceltaContoCtrl.$inject = [
	    '$http',
	    '$scope',
	    '$state',
	    '$stateParams',
	    '$window',
	    '$q',
	    '$httpParamSerializer',
	    'CONSTANTS',
	    'LabelSrvc',
	    'CreasMessaggiFctr',
	    'CreasDettaglioPraticaSrvc'
	  ];
	
	  var TemplateUrl = function(CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'creasDettaglioPratica/creasSceltaConto/creasSceltaConto.html'
	    );
	  };
	
	  TemplateUrl.$inject = ['CONSTANTS'];
	
	  var CreasSceltaContoComponent = {
	    bindings: {},
	    controller: CreasSceltaContoCtrl,
	    controllerAs: 'creasSceltaContoCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.insuranceloanpmi.mf')
	    .component('creasSceltaConto', CreasSceltaContoComponent);
	})();


/***/ }),
/* 25 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.insuranceloanpmi.mf.directive:creasAffidamentoDocumenti
	 * @restrict E
	 * @description Componente che gestisce il quarto step "Scelta Conto" del dettaglio pratica
	 * @param {number} id-pratica - Rappesenta l'ID univoco della pratica in lavorazione
	 */
	(function() {
	    'use strict';
	    var CreasAffidamentoDocumentiCtrl = function(
	        $http,
	        $scope,
	        $state,
	        $stateParams,
	        $window,
	        $q,
	        $httpParamSerializer,
	        $uibModal,
	        CONSTANTS,
	        labelSrvc,
	        messaggiFctr,
	        dettPraticaSrvc
	    ) {
	        this.$http = $http;
	        this.$state = $state;
	        this.$stateParams = $stateParams;
	        this.$window = $window;
	        this.$uibModal = $uibModal;
	        this.messaggiFctr = messaggiFctr;
	        this.CONSTANTS = CONSTANTS;
	        this.dettPraticaSrvc = dettPraticaSrvc;
	        $scope.msg = labelSrvc.getLabel;
	        // Workaround per bug widget fea
	        this.anagraficaFea = angular.copy(
	            this.dettPraticaSrvc.datiPratica.intestatario
	        );
	        this.anagraficaFea.naturaGiuridica = this.anagraficaFea.formaCostitutiva;
	
	        // Spinner
	        this.spinner = this.dettPraticaSrvc.spinner;
	        this.subSpinner = {
	            documenti: false
	        };
	
	        this.documentsSigned = false;
	        this.viewCancelDocument = false;
	
	        var self = this;
	
	        // Configuro l'abilitazione dei pulsanti di scorrimento tra gli step
	        dettPraticaSrvc.isSaveEnabled = function() {
	            return false;
	        };
	
	        dettPraticaSrvc.isPrevEnabled = function() {
	            return self.documentsSigned;
	        };
	
	        dettPraticaSrvc.isNextEnabled = function() {
	            return self.documentsSigned;
	        };
	
	        dettPraticaSrvc.nextStep = function() {
	            self.spinner.pratica = true;
	
	            self.verificaDocumenti();
	        };
	
	        this.verificaDocumenti = function() {
	            $q.all({
	                verifica: self.dettPraticaSrvc.promiseCheckDocumenti(
	                    self.dettPraticaSrvc.datiPratica.idPratica
	                )
	            }).then(
	                function(response) {
	                    if (self.messaggiFctr.processaResponse(response.verifica)) {
	                        self.spinner.pratica = false;
	                        return;
	                    }
	
	                    if (response.verifica.data.result !== true) {
	                        self.spinner.pratica = false;
	                        return;
	                    }
	                    self.messaggiFctr.addMessage({
	                        type: 'I',
	                        message: $scope.msg(
	                            'label.dettagliopratica.step5.checkdocumenticompleto'
	                        )
	                    });
	                    self.eseguiAccettazioni();
	                },
	                function(reason) {
	                    self.spinner.pratica = false;
	                    self.messaggiFctr.processaResponse(reason.verifica);
	                }
	            );
	        };
	
	        this.firmaDocumenti = function() {
	            $q.all({
	                firma: self.dettPraticaSrvc.promiseFirmaDocumenti(
	                    self.dettPraticaSrvc.datiPratica.idPratica
	                )
	            }).then(
	                function(response) {
	                    if (self.messaggiFctr.processaResponse(response.firma)) {
	                        self.spinner.pratica = false;
	                        return;
	                    }
	
	                    if (response.firma.data.result !== true) {
	                        self.spinner.pratica = false;
	                        return;
	                    }
	
	                    self.messaggiFctr.addMessage({
	                        type: 'I',
	                        message: $scope.msg(
	                            'label.dettagliopratica.step5.firmamassivacompleta'
	                        )
	                    });
	                    self.passaAPagamento();
	                },
	                function(reason) {
	                    self.spinner.pratica = false;
	                    self.messaggiFctr.processaResponse(reason.firma);
	                }
	            );
	        };
	
	        this.passaAPagamento = function() {
	            var promiseCambioVisibilita = this.$http({
	                method: 'PUT',
	                url: this.CONSTANTS.REST_ROOT +
	                    this.CONSTANTS.REST.PRATICHE.DETTAGLIO +
	                    this.dettPraticaSrvc.datiPratica.idPratica +
	                    '/cambiaVisibilitaAnagrafiche'
	            });
	            $q.all({
	                    nextStep: self.dettPraticaSrvc.promiseCambiaStep('/passaPagamento'),
	                    cambioVisibilita: promiseCambioVisibilita
	                })
	                .then(
	                    function(response) {
	                        if (self.messaggiFctr.processaResponse(response.nextStep)) {
	                            return;
	                        }
	                        if (self.messaggiFctr.processaResponse(response.cambioVisibilita)) {
	                            return;
	                        }
	                        self.dettPraticaSrvc.datiPratica = response.nextStep.data.result;
	                        self.dettPraticaSrvc.generaTabs();
	                    },
	                    function(reason) {
	                        self.messaggiFctr.processaResponse(reason.nextStep);
	                    }
	                )
	                .finally(function() {
	                    self.spinner.pratica = false;
	                });
	        };
	
	        this.eseguiAccettazioni = function() {
	            // Se nelle infoCerved ho richiestaAnagrafica a true, eseguo prima l'accettazione dei prospetti
	            if (
	                self.dettPraticaSrvc.datiPratica.infoCerved &&
	                self.dettPraticaSrvc.datiPratica.infoCerved.richiestaAnagrafica === true
	            ) {
	                // Verifico se le pratiche propedeutiche sono tutte evase correttamente
	                $q.all({
	                    checkPropedeutiche: self.dettPraticaSrvc.promiseCheckPratichePropedeutiche(
	                        self.dettPraticaSrvc.datiPratica.idPratica
	                    )
	                }).then(
	                    function(response) {
	                        // Se l'accettazione è andata male passo direttamente allo step successivo
	                        if (response.checkPropedeutiche.data.result === false) {
	                            self.passaAPagamento();
	                            return;
	                        }
	                        // Se ho degli errori, esco dalla procedura
	                        if (
	                            self.messaggiFctr.processaResponse(response.checkPropedeutiche)
	                        ) {
	                            self.spinner.pratica = false;
	                            return;
	                        }
	                        self.messaggiFctr.addMessage({
	                            type: 'I',
	                            message: $scope.msg(
	                                'label.dettagliopratica.step5.checkpropedeutichecompleto'
	                            )
	                        });
	                        // Richiedo i dettagli delle anagrafiche della pratica
	                        $q.all({
	                            datiAnagrafica: self.dettPraticaSrvc.promiseDatiClienteIntegrazione()
	                        }).then(
	                            function(response) {
	                                // Se ho degli errori, esco dalla procedura
	                                if (
	                                    self.messaggiFctr.processaResponse(response.datiAnagrafica)
	                                ) {
	                                    self.spinner.pratica = false;
	                                    return;
	                                }
	
	                                // Elaboro i dati dei firmatari e richiamo l'accettazione per ognuno di essi
	                                // Eseguo tutte le chiamate di accettazione
	                                if (
	                                    response.datiAnagrafica.data.result.firmatario &&
	                                    response.datiAnagrafica.data.result.firmatario.anagrafica
	                                ) {
	                                    self.eseguiAccettazioneFirmatariPF(
	                                        response.datiAnagrafica.data.result
	                                    );
	                                } else {
	                                    self.eseguiAccettazioneFirmatariPG(
	                                        response.datiAnagrafica.data.result
	                                    );
	                                }
	                            },
	                            function(reason) {
	                                self.spinner.pratica = false;
	                                self.messaggiFctr.processaResponse(reason.datiAnagrafica);
	                            }
	                        );
	                    },
	                    function(reason) {
	                        self.spinner.pratica = false;
	                        self.messaggiFctr.processaResponse(reason.checkPropedeutiche);
	                    }
	                );
	
	                return;
	            } else {
	                // Altrimenti richiamo direttamente "firmaDocumenti"
	                self.firmaDocumenti();
	            }
	        };
	
	        this.eseguiAccettazioneFirmatariPF = function(datiAnagrafica) {
	            var firmatariCalls = {};
	            var prospetti = [];
	
	            if (
	                datiAnagrafica.firmatario === undefined ||
	                datiAnagrafica.firmatario === null
	            ) {
	                self.messaggiFctr.addMessage({
	                    type: 'W',
	                    message: $scope.msg(
	                        'label.dettagliopratica.step5.firmatariononvalido'
	                    )
	                });
	                self.spinner.pratica = false;
	                return;
	            } else if (
	                datiAnagrafica.firmatario.anagrafica.prospetto === true &&
	                (datiAnagrafica.firmatario.prospetto === undefined ||
	                    datiAnagrafica.firmatario.prospetto === null)
	            ) {
	                self.messaggiFctr.addMessage({
	                    type: 'W',
	                    message: $scope.msg(
	                        'label.dettagliopratica.step5.firmatariononvalido'
	                    )
	                });
	                self.spinner.pratica = false;
	                return;
	            } else if (datiAnagrafica.firmatario.anagrafica.prospetto === true) {
	                var callPraticaFirmatarioProspetto =
	                    self.dettPraticaSrvc.promiseAccettaPersonaFisica(
	                        datiAnagrafica.firmatario.prospetto.idPratica
	                    );
	                firmatariCalls[
	                    'firmatario' + datiAnagrafica.firmatario.prospetto.idPratica
	                ] = callPraticaFirmatarioProspetto;
	                prospetti.push(datiAnagrafica.firmatario.prospetto.idPratica);
	            }
	
	            if (datiAnagrafica.titolari && datiAnagrafica.titolari.length > 0) {
	                for (var i = 0; i < datiAnagrafica.titolari.length; i++) {
	                    if (
	                        datiAnagrafica.titolari[i] === undefined ||
	                        datiAnagrafica.titolari[i] === null
	                    ) {
	                        self.messaggiFctr.addMessage({
	                            type: 'W',
	                            message: $scope.msg(
	                                'label.dettagliopratica.step5.firmatariononvalido'
	                            )
	                        });
	                        self.spinner.pratica = false;
	                        return;
	                    } else if (
	                        datiAnagrafica.titolari[i].anagrafica.prospetto === true &&
	                        (datiAnagrafica.titolari[i].prospetto === undefined ||
	                            datiAnagrafica.titolari[i].prospetto === null)
	                    ) {
	                        self.messaggiFctr.addMessage({
	                            type: 'W',
	                            message: $scope.msg(
	                                'label.dettagliopratica.step5.firmatariononvalido'
	                            )
	                        });
	                        self.spinner.pratica = false;
	                        return;
	                    } else if (datiAnagrafica.titolari[i].anagrafica.prospetto === true) {
	                        var callPraticaProspetto =
	                            self.dettPraticaSrvc.promiseAccettaPersonaFisica(
	                                datiAnagrafica.titolari[i].prospetto.idPratica
	                            );
	                        firmatariCalls[
	                            'firmatario' + datiAnagrafica.titolari[i].prospetto.idPratica
	                        ] = callPraticaProspetto;
	                        prospetti.push(datiAnagrafica.titolari[i].prospetto.idPratica);
	                    }
	                }
	            }
	
	            // Se non ho prospetti, passo direttamente all'integrazione della persona giuridica
	            if (prospetti.length === 0) {
	                self.eseguiAccettazioneFirmatariPG(datiAnagrafica);
	                return;
	            }
	
	            $q.all(firmatariCalls).then(
	                function(firmatariResponse) {
	                    // Elaboro le risposte di tutti i prospetti
	                    // La chiamata ha esito positivo se la risposta è vuota
	                    for (var i = 0; i < prospetti.length; i++) {
	                        if (
	                            self.messaggiFctr.processaResponse(
	                                firmatariResponse['firmatario' + prospetti[i]]
	                            )
	                        ) {
	                            self.spinner.pratica = false;
	                            return;
	                        }
	                    }
	
	                    // Se tutte sono andate a buon fine, procedo con l'accettazione della persona giuridica
	                    self.messaggiFctr.addMessage({
	                        type: 'I',
	                        message: $scope.msg(
	                            'label.dettagliopratica.step5.accettatofirmatario'
	                        )
	                    });
	                    self.eseguiAccettazioneFirmatariPG(datiAnagrafica);
	                },
	                function(firmatariReason) {
	                    if (Array.isArray(firmatariReason)) {
	                        for (var i = 0; i < prospetti.length; i++) {
	                            self.messaggiFctr.processaResponse(
	                                firmatariReason['firmatario' + prospetti[i]]
	                            );
	                        }
	                    } else {
	                        self.messaggiFctr.processaResponse(firmatariReason);
	                    }
	                    self.spinner.pratica = false;
	
	                    return;
	                }
	            );
	        };
	
	        this.eseguiAccettazioneFirmatariPG = function(datiAnagrafica) {
	            if (
	                datiAnagrafica.giuridica === undefined ||
	                datiAnagrafica.giuridica === null
	            ) {
	                self.spinner.pratica = false;
	                self.messaggiFctr.addMessage({
	                    type: 'W',
	                    message: $scope.msg('label.dettagliopratica.step5.pgnonvalida')
	                });
	                return;
	            } else if (
	                datiAnagrafica.giuridica.anagrafica.prospetto === true &&
	                (datiAnagrafica.giuridica.prospetto === undefined ||
	                    datiAnagrafica.giuridica.prospetto === null)
	            ) {
	                self.spinner.pratica = false;
	                self.messaggiFctr.addMessage({
	                    type: 'W',
	                    message: $scope.msg('label.dettagliopratica.step5.pgnonvalida')
	                });
	                return;
	            } else if (datiAnagrafica.giuridica.anagrafica.prospetto === true) {
	                $q.all({
	                    prospettoPG: self.dettPraticaSrvc.promiseAccettaPersonaGiuridica(
	                        datiAnagrafica.giuridica.prospetto.idPratica,
	                        datiAnagrafica.giuridica.anagrafica.formaCostitutiva
	                    )
	                }).then(
	                    function(prospettoPGResponse) {
	                        // La chiamata ha esito positivo se la risposta è vuota
	                        if (
	                            self.messaggiFctr.processaResponse(
	                                prospettoPGResponse.prospettoPG
	                            )
	                        ) {
	                            self.spinner.pratica = false;
	                            return;
	                        }
	
	                        // Se la chiamata è andata a buon fine, procedo col passaggio al firma documenti
	                        self.messaggiFctr.addMessage({
	                            type: 'I',
	                            message: $scope.msg('label.dettagliopratica.step5.accettatapg')
	                        });
	                        self.firmaDocumenti();
	                    },
	                    function(pgReason) {
	                        self.spinner.pratica = false;
	                        var errorMsg = JSON.parse(pgReason.data);
	
	                        if (errorMsg && errorMsg.Messages) {
	                            for (var i = 0; i < errorMsg.Messages.length; i++) {
	                                self.messaggiFctr.addMessage({
	                                    type: 'E',
	                                    message: errorMsg.Messages[i].Message
	                                });
	                            }
	                        }
	
	                        return;
	                    }
	                );
	            } else {
	                self.firmaDocumenti();
	            }
	        };
	
	        /**
	         * @ngdoc method
	         * @name generaDocumenti
	         * @methodOf cbl.insuranceloanpmi.mf.directive:creasAffidamentoDocumenti
	         * @description Apre una finestra modale per l'inserimento di luogo e data da apporre sui documenti da generare
	         */
	        this.generaDocumenti = function() {
	            self.subSpinner.documenti = false;
	            self.documentsSigned = true;
	        };
	
	        self.generaDocumenti();
	    };
	
	    CreasAffidamentoDocumentiCtrl.$inject = [
	        '$http',
	        '$scope',
	        '$state',
	        '$stateParams',
	        '$window',
	        '$q',
	        '$httpParamSerializer',
	        '$uibModal',
	        'CONSTANTS',
	        'LabelSrvc',
	        'CreasMessaggiFctr',
	        'CreasDettaglioPraticaSrvc'
	    ];
	
	    var TemplateUrl = function(CONSTANTS) {
	        return (
	            CONSTANTS.BASE_ROOT +
	            CONSTANTS.COMPONENTS_PATH +
	            'creasDettaglioPratica/creasAffidamentoDocumenti/creasAffidamentoDocumenti.html'
	        );
	    };
	
	    TemplateUrl.$inject = ['CONSTANTS'];
	
	    var CreasAffidamentoDocumentiComponent = {
	        bindings: {},
	        controller: CreasAffidamentoDocumentiCtrl,
	        controllerAs: 'creasAffidamentoDocumentiCtrl',
	        templateUrl: TemplateUrl
	    };
	
	    angular
	        .module('cbl.insuranceloanpmi.mf')
	        .component('creasAffidamentoDocumenti', CreasAffidamentoDocumentiComponent);
	})();

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.insuranceloanpmi.mf.directive:creasPraticaPagamento
	 * @restrict E
	 * @description Componente che gestisce il sesto step "Pagamento" del dettaglio pratica
	 * @param {Object[]} steps - Un array che rappresenta i sotto-step da visualizzare
	 * @param {Object} currentStep - Rappresenta il sotto-step attualmente visualizzato
	 */
	(function() {
	  'use strict';
	  var CreasPraticaPagamentoCtrl = function(
	    $http,
	    $scope,
	    $state,
	    $stateParams,
	    $window,
	    $q,
	    $httpParamSerializer,
	    CONSTANTS,
	    labelSrvc,
	    messaggiFctr,
	    dettPraticaSrvc
	  ) {
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.messaggiFctr = messaggiFctr;
	    this.CONSTANTS = CONSTANTS;
	    $scope.msg = labelSrvc.getLabel;
	
	    // Spinner
	    this.spinner = dettPraticaSrvc.spinner;
	    this.dettPraticaSrvc = dettPraticaSrvc;
	    var self = this;
	    
	    /**
		 * @ngdoc method
		 * @name microTabClicked
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasPraticaPagamento
		 * @description Apre il micro-tab selezionato
		 * @param {Object} tab - il micro-tab selezionato
		 */
	    this.microTabClicked = function(tab) {
	    	if (self.dettPraticaSrvc.isPraticaNavigabile() !== true) {
	    		return;
	    	}
	    	
	    	self.dettPraticaSrvc.apriMicroTab(tab, 6);
	    }
	
	    // Si usa la promiseCambiaStep per eseguire il salvataggio
	    dettPraticaSrvc.salva = function() {
	      self.spinner.pratica = true;
	      dettPraticaSrvc.datiPratica.prodotto.convenzione =
	        dettPraticaSrvc.convenzione;
	      $q
	        .all({salvaConvenzione: dettPraticaSrvc.promiseSalvaConvenzione()})
	        .then(
	          function(response) {
	            dettPraticaSrvc.datiPratica = response.salvaConvenzione.data.result;
	            if (self.messaggiFctr.processaResponse(response.salvaConvenzione)) {
	              return;
	            }
	          },
	          function(reason) {
	            self.messaggiFctr.processaResponse(reason.salvaConvenzione);
	          }
	        )
	        .finally(function() {
	          self.spinner.pratica = false;
	        });
	    };
	
	    dettPraticaSrvc.nextStep = function() {
	      self.spinner.pratica = true;
	      dettPraticaSrvc.datiPratica.prodotto.convenzione =
	        dettPraticaSrvc.convenzione;
	      $q
	        .all({nextStep: self.dettPraticaSrvc.promiseCambiaStep('/avantiStep')})
	        .then(
	          function(response) {
	            if (self.messaggiFctr.processaResponse(response.nextStep)) {
	              return;
	            }
	            
	            self.dettPraticaSrvc.datiPratica = response.nextStep.data.result;
	            dettPraticaSrvc.generaTabs();
	          },
	          function(reason) {
	            self.messaggiFctr.processaResponse(reason.nextStep);
	          }
	        )
	        .finally(function() {
	          self.spinner.pratica = false;
	        });
	    };
	
	    /**
		 * @ngdoc method
		 * @name getStyleTabMicro
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasPraticaPagamento
		 * @description Imposta lo stile di visualizzazione per gli indicatori dei micro step
		 * @param {string} currentStep - Il macro step correntemente visualizzato
		 * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
		 * @return {string} - Restituisce lo stile da applicare all'indicatore del micro step
		 */
	    this.getStyleTabMicro = function(currentTabIndex) {
	    	// Pratica navigabile
	  	  if (self.dettPraticaSrvc.isPraticaNavigabile() === true) {
	  		if (currentTabIndex === self.currentStep.index) {
	  	      return 'ab-step-tabs cliccabile active-read';
	  	    }
	  		
	    	    return 'ab-step-tabs cliccabile ab-last-read';
	        }
	      	
	        // Pratica non navigabile
	        if (currentTabIndex < self.currentStep.index) {
	          return 'ab-step-tabs';
	        }
	        
	        if (currentTabIndex === self.currentStep.index) {
	          return 'ab-step-tabs active';
	        }
	        
	        return "ab-step-tabs ab-last";
	    };
	    
	    /**
		 * @ngdoc method
		 * @name getStyleStepMicro
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasPraticaPagamento
		 * @description Imposta lo stile di visualizzazione per la barra dell'indicatore del micro step
		 * @param {string} currentStep - Il macro step correntemente visualizzato
		 * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
		 * @return {string} - Restituisce lo stile da applicare alla barra dell'indicatore del micro step
		 */
		  this.getStyleStepMicro = function(currentTabIndex) {
			if (self.dettPraticaSrvc.isPraticaNavigabile() === true) {
			  return 'step read';
			}
				
			  
		    if (currentTabIndex < self.currentStep.index) {
		      return 'step success';
		    }
		    
		    return 'step';
		  };
	  };
	
	  CreasPraticaPagamentoCtrl.$inject = [
	    '$http',
	    '$scope',
	    '$state',
	    '$stateParams',
	    '$window',
	    '$q',
	    '$httpParamSerializer',
	    'CONSTANTS',
	    'LabelSrvc',
	    'CreasMessaggiFctr',
	    'CreasDettaglioPraticaSrvc'
	  ];
	
	  var TemplateUrl = function(CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'creasDettaglioPratica/creasPraticaPagamento/creasPraticaPagamento.html'
	    );
	  };
	
	  TemplateUrl.$inject = ['CONSTANTS'];
	
	  var CreasPraticaPagamentoComponent = {
	    bindings: {
	      steps: '<',
	      currentStep: '<'
	    },
	    controller: CreasPraticaPagamentoCtrl,
	    controllerAs: 'creasPraticaPagamentoCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.insuranceloanpmi.mf')
	    .component('creasPraticaPagamento', CreasPraticaPagamentoComponent);
	})();


/***/ }),
/* 27 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.insuranceloanpmi.mf.directive:creasSceltaConvenzione
	 * @restrict E
	 * @description Componente che gestisce il primo sotto-step "Scelta Convenzione" dello step "Pagamento"
	 * @param {Object[]} convenzioni - Array delle convenzioni disponibili
	 */
	(function() {
	  'use strict';
	  var CreasSceltaConvenzioneCtrl = function(
	    $http,
	    $scope,
	    $state,
	    $stateParams,
	    $window,
	    $q,
	    $httpParamSerializer,
	    CONSTANTS,
	    labelSrvc,
	    messaggiFctr,
	    dettPraticaSrvc
	  ) {
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.messaggiFctr = messaggiFctr;
	    this.dettPraticaSrvc = dettPraticaSrvc;
	    this.CONSTANTS = CONSTANTS;
	    $scope.msg = labelSrvc.getLabel;
	    this.convenzioni = [];
	
	    // this.convenzioni = [];
	    // Spinner
	    this.spinner = dettPraticaSrvc.spinner;
	    this.subSpinner = {
	    	convenzioni: false
	    };
	
	    var self = this;
	
	    // Configuro l'abilitazione dei pulsanti di scorrimento tra gli step
	    dettPraticaSrvc.isCancelFinanziamentoVisible = function() {
	      return true;
	    };
	    dettPraticaSrvc.isCancelFinanziamentoEnabled = function() {
	      return true;
	    };
	      
	    dettPraticaSrvc.isSaveEnabled = function() {
	      return self.dettPraticaSrvc.convenzione !== null;
	    };
	
	    dettPraticaSrvc.isNextEnabled = function() {
	      return self.dettPraticaSrvc.convenzione !== null;
	    };
	    
	    // Configuro il comportamento del pulsante prosegui per lo step
	    dettPraticaSrvc.nextStep = function() {
	    	
			self.spinner.pratica = true;
			
			// Se le polizze sono già state assegnate, procedo direttamente allo step successivo
			if (self.finanziamentoGiaAperto() === true) {
				
				$q
	            .all({
	              nextStep: self.dettPraticaSrvc.promiseCambiaStep('/avantiStep')
	            })
	            .then(
	              function(response) {
	                if (self.messaggiFctr.processaResponse(response.nextStep)) {
	                  return;
	                }
	                
	                self.dettPraticaSrvc.datiPratica = response.nextStep.data.result;
	                dettPraticaSrvc.generaTabs();
	              },
	              function(reason) {
	                self.messaggiFctr.processaResponse(reason.nextStep);
	              }
	            )
	            .finally(function() {
	              self.spinner.pratica = false;
	            });
				
			} else {
				
				$q
				.all({salvaConvenzione: self.dettPraticaSrvc.promiseSalvaConvenzione()})
				.then(
				  function(response) {
					  if (response.salvaConvenzione.data.result) {
			            $q
			              .all({
			                nextStep: self.dettPraticaSrvc.promiseCambiaStep('/avantiStep')
			              })
			              .then(
			                function(response) {
			                  if (self.messaggiFctr.processaResponse(response.nextStep)) {
			                    return;
			                  }
			                  
			                  self.dettPraticaSrvc.datiPratica = response.nextStep.data.result;
			                  dettPraticaSrvc.generaTabs();
			                },
			                function(reason) {
			                  self.messaggiFctr.processaResponse(reason.nextStep);
			                }
			              )
			              .finally(function() {
			                self.spinner.pratica = false;
			              });
			          } else {
			            self.spinner.pratica = false;
			          }
				  },
				  function(reason) {
				    self.messaggiFctr.processaResponse(reason.salvaConvenzione);
				    self.spinner.pratica = false;
				  }
				);
				
			}
	    	
	    };
	
	    // Configuro il comportamento del pulsante salva per lo step
	    dettPraticaSrvc.salva = function() {
	      self.spinner.pratica = true;
	      
	      $q
	        .all({salvaConvenzione: self.dettPraticaSrvc.promiseSalvaConvenzione()})
	        .then(
	          function(response) {
	            self.dettPraticaSrvc.datiPratica = response.salvaConvenzione.data.result;
	            if (self.messaggiFctr.processaResponse(response.salvaConvenzione)) {
	              return;
	            }
	          },
	          function(reason) {
	            self.messaggiFctr.processaResponse(reason.salvaConvenzione);
	          }
	        )
	        .finally(function() {
	          self.spinner.pratica = false;
	        });
	    };
	    
	    /**
		 * @ngdoc method
		 * @name recuperaConvenzioni
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaConvenzione
		 * @description Recupera le convenzioni per l'affidamento attuale
		 */
	    this.recuperaConvenzioni = function() {
	      self.subSpinner.convenzioni = true;
	      $q
	        .all({
	          convenzioni: self.dettPraticaSrvc.promiseConvenzioni()
	        })
	        .then(
	          function(response) {
	            if (self.messaggiFctr.processaResponse(response.convenzioni)) {
	              self.convenzioni = [];
	              return;
	            }
	            self.convenzioni = response.convenzioni.data.result;
	            
	            self.impostaConvenzioneSelezionata();
	          },
	          function(reason) {
	            self.messaggiFctr.processaResponse(reason.convenzioni);
	            self.convenzioni = [];
	          }
	        )
	        .finally(function() {
			  self.subSpinner.convenzioni = false;
			});
	    };
	
	    /**
		 * @ngdoc method
		 * @name impostaConvenzioneSelezionata
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaConvenzione
		 * @description Se disponibile, imposta in visualizzazione la convenzione selezionata per la pratica
		 */
	    this.impostaConvenzioneSelezionata = function() {
	      if (!self.dettPraticaSrvc.convenzione) {
	        return;
	      }
	      
	      angular.forEach(self.convenzioni, function(value) {
	        if (self.dettPraticaSrvc.convenzione.idConvenzioneCPT === value.idConvenzione) {
	          self.dettPraticaSrvc.convenzione = value;
	        }
	      });
	    };
	    
	    /**
		 * @ngdoc method
		 * @name finanziamentoGiaAperto
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaConvenzione
		 * @description Indica se per la pratica in corso sono già state assegnate o meno polizze
		 * @return {boolean} True se almeno una polizza è assegnata, false se non sono state assegnate polizze
		 */
	    this.finanziamentoGiaAperto = function() {
	    	return self.dettPraticaSrvc.datiPratica.elencoFinanziamentoMultiPolizzaPMI.length > 1;
	    }
	    
	    // Se presente nella pratica, imposto la convenzione già selezionata
	    if (this.dettPraticaSrvc.datiPratica.prodotto && this.dettPraticaSrvc.datiPratica.prodotto.convenzione) {
	    	this.dettPraticaSrvc.convenzione = this.dettPraticaSrvc.datiPratica.prodotto.convenzione;
	    }
	    
	    // Recupero l'elenco convenzioni
	    this.recuperaConvenzioni();
	  };
	
	  CreasSceltaConvenzioneCtrl.$inject = [
	    '$http',
	    '$scope',
	    '$state',
	    '$stateParams',
	    '$window',
	    '$q',
	    '$httpParamSerializer',
	    'CONSTANTS',
	    'LabelSrvc',
	    'CreasMessaggiFctr',
	    'CreasDettaglioPraticaSrvc'
	  ];
	
	  var TemplateUrl = function(CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'creasDettaglioPratica/creasPraticaPagamento/creasSceltaConvenzione/creasSceltaConvenzione.html'
	    );
	  };
	
	  TemplateUrl.$inject = ['CONSTANTS'];
	
	  var CreasSceltaConvenzioneComponent = {
	    bindings: {
	      convenzioni: '<'
	    },
	    controller: CreasSceltaConvenzioneCtrl,
	    controllerAs: 'creasSceltaConvenzioneCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.insuranceloanpmi.mf')
	    .component('creasSceltaConvenzione', CreasSceltaConvenzioneComponent);
	})();


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
	 * @restrict E
	 * @description Componente che gestisce il secondo sotto-step "Scelta Polizze" dello step "Pagamento"
	 */
	(function() {
		"use strict";
		var CreasSceltaPolizzeCtrl = function($http, $scope, $state, $stateParams, $window, $q, $httpParamSerializer, CONSTANTS, labelSrvc, messaggiFctr, dettPraticaSrvc) {
			this.$http = $http;
			this.$state = $state;
			this.$stateParams = $stateParams;
			this.$window = $window;
			this.messaggiFctr = messaggiFctr;
			this.dettPraticaSrvc = dettPraticaSrvc;
			this.CONSTANTS = CONSTANTS;
			$scope.msg = labelSrvc.getLabel;
			
			// Spinner
		    this.spinner = this.dettPraticaSrvc.spinner;
			this.subSpinner = {
				ricerca: false
			}
			
			this.numeroTitolo = null;
			
			this.compagnie = [
				{ id: 1, descrizione: 'Reale Mutua' },
				{ id: 3, descrizione: 'Italiana Assicurazioni' }
			];
			this.compagnia = null;
			
			this.titoliCercati = [];
			this.titoloSelezionato = null;
			
			var self = this;
			
			// Configuro l'abilitazione dei pulsanti di scorrimento tra gli step	
			dettPraticaSrvc.isCancelFinanziamentoVisible = function() {
		      return true;
		    };
		    dettPraticaSrvc.isCancelFinanziamentoEnabled = function() {
		      return true;
		    };
			dettPraticaSrvc.isSaveEnabled = function() {
				return self.dettPraticaSrvc.finanziamento && self.dettPraticaSrvc.finanziamento.elencoPolizze && self.dettPraticaSrvc.finanziamento.elencoPolizze.length > 0;
			}
			
			dettPraticaSrvc.isPrevEnabled = function() {
				return true;
			}
			
			dettPraticaSrvc.isNextEnabled = function() {
				return self.dettPraticaSrvc.finanziamento && self.dettPraticaSrvc.finanziamento.elencoPolizze && self.dettPraticaSrvc.finanziamento.elencoPolizze.length > 0;
			}
			
			// Configuro il comportamento del pulsante prosegui per lo step
		    dettPraticaSrvc.nextStep = function() {
		    	
		    	if (self.dettPraticaSrvc.verificaImportiPolizze() !== true) {
					return;
				}
		    	
				self.spinner.pratica = true;
				  
				// SALVATAGGIO POLIZZE
				$q
				.all({salvaPolizze: self.dettPraticaSrvc.promiseSalvaPolizze()})
				.then(
				  function(response) {
					  if (self.messaggiFctr.processaResponse(response.salvaPolizze)) {
						  self.spinner.pratica = false;
	            		  return;
	            	  }
					  
					  if (response.salvaPolizze.data.result) {
			            $q
			              .all({
			                nextStep: self.dettPraticaSrvc.promiseCambiaStep('/avantiStep')
			              })
			              .then(
			                function(response) {
		                	  if (self.messaggiFctr.processaResponse(response.nextStep)) {
		                		  return;
		                	  }
		                	  
			                  self.dettPraticaSrvc.datiPratica = response.nextStep.data.result;
			                  self.dettPraticaSrvc.generaTabs();
			                },
			                function(reason) {
			                  self.messaggiFctr.processaResponse(reason.nextStep);
			                }
			              )
			              .finally(function() {
			                self.spinner.pratica = false;
			              });
			          } else {
			            self.spinner.pratica = false;
			          }
				  },
				  function(reason) {
				    self.messaggiFctr.processaResponse(reason.salvaPolizze);
				    self.spinner.pratica = false;
				  }
				);
		    	
		    };
	
		    // Configuro il comportamento del pulsante salva per lo step
			dettPraticaSrvc.salva = function() {
				
				if (self.dettPraticaSrvc.verificaImportiPolizze() !== true) {
					return;
				}
					
				self.spinner.pratica = true;
				  
				$q
				.all({salvaPolizze: self.dettPraticaSrvc.promiseSalvaPolizze()})
				.then(
					function(response) {
						self.dettPraticaSrvc.finanziamento = response.salvaPolizze.data.result;
						if (self.messaggiFctr.processaResponse(response.salvaPolizze)) {
							return;
						}
					},
					function(reason) {
						self.messaggiFctr.processaResponse(reason.salvaPolizze);
					}
				)
				.finally(function() {
					self.spinner.pratica = false;
				});
			
			};
			
			/**
			 * @ngdoc method
			 * @name promiseTitoli
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
			 * @description Effettua una chiamata http che recupera un titolo in base al numero specificato
			 * @return {Promise} - Ritorna una promise contenente il titolo cercato
			 */
			this.promiseTitoli = function() {
				
				var queryParamsObj = {
					numTitolo: self.numeroTitolo,
					codiceCompagnia: self.compagnia
				};
				
				var queryParams = $httpParamSerializer(queryParamsObj);
				
				return this.$http({
					method: 'GET',
					url: CONSTANTS.REST_ROOT + CONSTANTS.REST.TITOLI + '?' + queryParams
				});
			}
			
			/**
			 * @ngdoc method
			 * @name recuperaTitoli
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
			 * @description Esegue la ricerca degli utilizzi inerenti l'affidamento
			 */
			this.recuperaTitoli = function() {
				
				// FIXME: rimuovere o impostare a false!
				if (false) {
					self.titoliCercati = [
						{"idDatiPagamento":null,"codiceIncasso":"182060000000076712","dataPagamento":1416870000000,"scadenzaCopertura":1340143200000,"importoPremioLordo":104.00,"codiceDivisa":"EUR","codiceCompagnia":"3","codiceAgenzia":"838","codiceRamo":"08","numeroPolizza":"2011086086200","nominativoContraente":"D'ALESSANDRO FRANCESCO","tipoModello":"00019","descrizioneModello":"PROTEZIONE  9","intestazioneCCAgente":"DE LEO  S.N.C. DI DE LEO CANDELORO","ibanStatoAgente":"","cinEUAgente":null,"cinITAgente":"","abiAgente":"01020","cabAgente":"04605","contoCorrenteAgente":"000300488537"},
						{"idDatiPagamento":null,"codiceIncasso":"182060000000076713","dataPagamento":1416870000000,"scadenzaCopertura":1340143200000,"importoPremioLordo":105.00,"codiceDivisa":"EUR","codiceCompagnia":"3","codiceAgenzia":"838","codiceRamo":"08","numeroPolizza":"2011086086201","nominativoContraente":"D'ALESSANDRO FRANCESCO","tipoModello":"00019","descrizioneModello":"PROTEZIONE  9","intestazioneCCAgente":"DE LEO  S.N.C. DI DE LEO CANDELORO","ibanStatoAgente":"","cinEUAgente":null,"cinITAgente":"","abiAgente":"01020","cabAgente":"04605","contoCorrenteAgente":"000300488537"},
						{"idDatiPagamento":null,"codiceIncasso":"182060000000076714","dataPagamento":1416870000000,"scadenzaCopertura":1340143200000,"importoPremioLordo":106.00,"codiceDivisa":"EUR","codiceCompagnia":"3","codiceAgenzia":"838","codiceRamo":"08","numeroPolizza":"2011086086202","nominativoContraente":"D'ALESSANDRO FRANCESCO","tipoModello":"00019","descrizioneModello":"PROTEZIONE  9","intestazioneCCAgente":"DE LEO  S.N.C. DI DE LEO CANDELORO","ibanStatoAgente":"","cinEUAgente":null,"cinITAgente":"","abiAgente":"01020","cabAgente":"04606","contoCorrenteAgente":"000300488539"}
					];
					return;
				}
				
				if (!self.numeroTitolo) {
					return;
				}
				
				if (!self.compagnia) {
					return;
				}
				
				if (self.numeroTitolo && self.numeroTitolo.trim() === '') {
					return;
				}
				
				self.subSpinner.ricerca = true;
				
				$q.all({
					titoli: self.promiseTitoli(),
				}).then(function(response) {
					
					if (self.messaggiFctr.processaResponse(response.titoli)) {
						self.titoliCercati = [];
						return;
					}
					
					if (self.titoloGiaAggiunto(response.titoli.data.result) === true) {
						self.titoliCercati = [];
						return;
					}
					
					self.titoliCercati = [ response.titoli.data.result ];
				}, function(reason) {
		    		self.messaggiFctr.processaResponse(reason.titoli);
		    		self.polizzeCercate = [];
				}).finally(function() {
					self.subSpinner.ricerca = false;
				});
				
			}
			
			/**
			 * @ngdoc method
			 * @name titoloGiaAggiunto
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
			 * @description Verifica se il titolo specificato è già stato aggiunto alla pratica
			 * @param {Object} titolo - Il titolo da verificare
			 * @return {boolean} - Ritorna true se il titolo è già aggiunto, false se non è presente tra gli aggiunti
			 */
			this.titoloGiaAggiunto = function(titolo) {
				if (!self.dettPraticaSrvc.finanziamento) {
					return false;
				}
				
				if (!self.dettPraticaSrvc.finanziamento.elencoPolizze) {
					return false;
				}
				
				var titoliPresenti = self.dettPraticaSrvc.finanziamento.elencoPolizze.filter(function(ttl) {
					return ttl.datiPagamento.codiceIncasso === titolo.codiceIncasso;
				});
				
				return titoliPresenti.length > 0;
			}
			
			/**
			 * @ngdoc method
			 * @name titoloInAggiunta
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
			 * @description Verifica se il titolo specificato è in fase di aggiunta nella pratica
			 * @param {Object} titolo - Il titolo da verificare
			 * @return {boolean} - Ritorna true se il titolo è in fase di aggiunta, false in caso contrario
			 */
			this.titoloInAggiunta = function(titolo) {
				if (!self.titoloSelezionato) {
					return false;
				}
				
				return self.titoloSelezionato.codiceIncasso === titolo.codiceIncasso;
			}
			
			/**
			 * @ngdoc method
			 * @name aggiungiTitolo
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
			 * @description Aggiunge, se non è già presente, il titolo alla pratica
			 * @param {Object} titolo - Il titolo da aggiungere
			 */
			this.aggiungiTitolo = function(titolo) {
				if (self.titoloGiaAggiunto(titolo) === true) {
					self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.dettagliopratica.step6.sub2.titologiaaggiunto') });
					return;
				}
				
				var tmpTitolo = angular.copy(titolo);
				
				// Se ho delle polizze selezionate, verifico che quella che sto aggiungendo abbia il solito iban
				// Se non ho polizze selezionate, mostro il passaggio intermedio per richiedere cinEUAgente e cinITAgente
				var datiIBANPolizze = self.recuperaIBANPolizze();
				
				if (!datiIBANPolizze) {				
					if (!tmpTitolo.ibanStatoAgente || (tmpTitolo.ibanStatoAgente && tmpTitolo.ibanStatoAgente.trim() === '')) {
						tmpTitolo.ibanStatoAgente = 'IT';
					}
					
					self.titoloSelezionato = tmpTitolo;
					return;
				}
				
				var noStatoIban = false;
				if (!tmpTitolo.ibanStatoAgente || (tmpTitolo.ibanStatoAgente && tmpTitolo.ibanStatoAgente.trim() === '')) {
					noStatoIban = true;
					tmpTitolo.ibanStatoAgente = 'IT';
				}
				
				if (
					datiIBANPolizze.ibanStatoAgente !== tmpTitolo.ibanStatoAgente ||
					datiIBANPolizze.abiAgente !== tmpTitolo.abiAgente ||
					datiIBANPolizze.cabAgente !== tmpTitolo.cabAgente ||
					datiIBANPolizze.contoCorrenteAgente !== tmpTitolo.contoCorrenteAgente
				) {
					if (noStatoIban === true) {
						tmpTitolo.ibanStatoAgente = '';
					}
					
					self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.dettagliopratica.step6.sub2.ibannoncorrisp') });
					return;
				}
				
				// Se i dati dell'IBAN corrispondono, aggiungo il titolo direttamente assegnando cin EU e cin IT
				tmpTitolo.cinEUAgente = datiIBANPolizze.cinEUAgente;
				tmpTitolo.cinITAgente = datiIBANPolizze.cinITAgente;
				
				var polizza = {
					idFinanziamentoMultiPolizzaPMI: self.dettPraticaSrvc.finanziamento.idFinanziamentoMultiPolizzaPMI,
				    numeroPolizza: tmpTitolo.numeroPolizza,
				    importoPremio: tmpTitolo.importoPremioLordo,
				    preventivo: false,
				    descrizionePolizza: tmpTitolo.descrizioneModello,
				    datiPagamento: tmpTitolo
				};
				
				if (!self.dettPraticaSrvc.finanziamento.elencoPolizze) {
					self.dettPraticaSrvc.finanziamento.elencoPolizze = [];
				}
				
				self.dettPraticaSrvc.finanziamento.elencoPolizze.push(polizza);
				self.aggiornaTitoli();
			}
			
			/**
			 * @ngdoc method
			 * @name recuperaIBANPolizze
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
			 * @description Recupera i dati dell'IBAN di accredito per le polizze selezionate
			 * @return {Object} Struttura contenente i dati dell'IBAN delle polizze selezionate
			 */
			this.recuperaIBANPolizze = function() {
				if (!self.dettPraticaSrvc.finanziamento) {
					return null;
				}
				
				if (!self.dettPraticaSrvc.finanziamento.elencoPolizze) {
					return null;
				}
				
				if (self.dettPraticaSrvc.finanziamento.elencoPolizze.length === 0) {
					return null;
				}
				
				return {
					ibanStatoAgente: self.dettPraticaSrvc.finanziamento.elencoPolizze[0].datiPagamento.ibanStatoAgente,
					cinEUAgente: self.dettPraticaSrvc.finanziamento.elencoPolizze[0].datiPagamento.cinEUAgente,
					cinITAgente: self.dettPraticaSrvc.finanziamento.elencoPolizze[0].datiPagamento.cinITAgente,
					abiAgente: self.dettPraticaSrvc.finanziamento.elencoPolizze[0].datiPagamento.abiAgente,
					cabAgente: self.dettPraticaSrvc.finanziamento.elencoPolizze[0].datiPagamento.cabAgente,
					contoCorrenteAgente: self.dettPraticaSrvc.finanziamento.elencoPolizze[0].datiPagamento.contoCorrenteAgente
				};
			}
			
			/**
			 * @ngdoc method
			 * @name confermaTitoloSelezionato
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
			 * @description Conferma l'aggiunta del titolo selezionato e per il quale si stanno compilando i dati
			 */
			this.confermaTitoloSelezionato = function() {
				
				if (!self.titoloSelezionato) {
					return;
				}
				
				// CONTROLLI CIN EU
				if (!self.titoloSelezionato.cinEUAgente || (self.titoloSelezionato.cinEUAgente && self.titoloSelezionato.cinEUAgente.trim() === '')) {
					self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.dettagliopratica.step6.sub2.invalidcineu') });
					return;
				}
				
				if (self.titoloSelezionato.cinEUAgente.trim().length !== 2) {
					self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.dettagliopratica.step6.sub2.invalidcineu') });
					return;
				}
				
				if (!(/^\d+$/.test(self.titoloSelezionato.cinEUAgente.trim()))) {
					self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.dettagliopratica.step6.sub2.invalidcineu') });
					return;
				}
				
				// CONTROLLI CIN IT
				if (!self.titoloSelezionato.cinITAgente || (self.titoloSelezionato.cinITAgente && self.titoloSelezionato.cinITAgente.trim() === '')) {
					self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.dettagliopratica.step6.sub2.invalidcinit') });
					return;
				}
				
				if (self.titoloSelezionato.cinITAgente.trim().length !== 1) {
					self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.dettagliopratica.step6.sub2.invalidcinit') });
					return;
				}
				
				if (!(/^[a-zA-Z]$/.test(self.titoloSelezionato.cinITAgente.trim()))) {
					self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.dettagliopratica.step6.sub2.invalidcinit') });
					return;
				}
				
				self.titoloSelezionato.cinITAgente = self.titoloSelezionato.cinITAgente.toUpperCase();
				
				// SALVO LA POLIZZA CON L'IBAN
				var polizza = {
					idFinanziamentoMultiPolizzaPMI: self.dettPraticaSrvc.finanziamento.idFinanziamentoMultiPolizzaPMI,
				    numeroPolizza: self.titoloSelezionato.numeroPolizza,
				    importoPremio: self.titoloSelezionato.importoPremioLordo,
				    descrizionePolizza: self.titoloSelezionato.descrizioneModello,
				    preventivo: false,
				    datiPagamento: self.titoloSelezionato
				};
				
				if (!self.dettPraticaSrvc.finanziamento.elencoPolizze) {
					self.dettPraticaSrvc.finanziamento.elencoPolizze = [];
				}
				
				self.dettPraticaSrvc.finanziamento.elencoPolizze.push(polizza);
				self.aggiornaTitoli();
				self.titoloSelezionato = null;
			}
			
			/**
			 * @ngdoc method
			 * @name annullaTitoloSelezionato
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
			 * @description Annulla l'aggiunta del titolo selezionato per il quale si stanno compilando i dati
			 */
			this.annullaTitoloSelezionato = function() {
				self.aggiornaTitoli();
				self.titoloSelezionato = null;
			}
			
			/**
			 * @ngdoc method
			 * @name rimuoviTitolo
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
			 * @description Rimuove il titolo selezionato da quelli aggiunti alla pratica
			 * @param {Object} titolo - Il titolo da rimuovere
			 */
			this.rimuoviTitolo = function(titolo) {
				var itemIndex = self.dettPraticaSrvc.finanziamento.elencoPolizze.indexOf(titolo);
				
				if (itemIndex === -1) {
					return;
				}
				
				self.dettPraticaSrvc.finanziamento.elencoPolizze.splice(itemIndex, 1);
				self.aggiornaTitoli();
			}
			
			/**
			 * @ngdoc method
			 * @name aggiornaTitoli
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
			 * @description Aggiorna la visualizzazione degli elenchi di titoli cercati e aggiunti
			 */
			this.aggiornaTitoli = function() {
				self.titoliCercati = self.titoliCercati.concat([]);
				
				if (self.dettPraticaSrvc.finanziamento && self.dettPraticaSrvc.finanziamento.elencoPolizze) {				
					self.dettPraticaSrvc.finanziamento.elencoPolizze = self.dettPraticaSrvc.finanziamento.elencoPolizze.concat([]);
				}
			}
			
			/**
			 * @ngdoc method
			 * @name recuperaTotaleTitoli
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
			 * @description Calcola e mostra il totale dei titoli selezionati
			 */
			this.recuperaTotaleTitoli = function() {			
				var totaleTitoli = 0;
				
				if (self.dettPraticaSrvc.finanziamento.elencoPolizze && self.dettPraticaSrvc.finanziamento.elencoPolizze.length > 0) {
					for(var i = 0; i < self.dettPraticaSrvc.finanziamento.elencoPolizze.length; i++) {
						totaleTitoli += self.dettPraticaSrvc.finanziamento.elencoPolizze[i].datiPagamento.importoPremioLordo;
					}
				}
				
				return totaleTitoli;
			}
			
			/**
			 * @ngdoc method
			 * @name mostraTitoliSalvati
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
			 * @description Recupera i titoli salvati nella pratica e li mostra tra quelli selezionati
			 */
			this.mostraTitoliSalvati = function() {
				self.dettPraticaSrvc.finanziamento = self.dettPraticaSrvc.getFinanziamentoBozza();
				
				if (!self.dettPraticaSrvc.finanziamento) {
					return;
				}
				
				if (!self.dettPraticaSrvc.finanziamento.elencoPolizze) {
					return;
				}
	
				self.aggiornaTitoli();
			}
			
			this.mostraTitoliSalvati();
	
		};
	
		CreasSceltaPolizzeCtrl.$inject = [ '$http', '$scope', '$state', '$stateParams', '$window', '$q', '$httpParamSerializer', 'CONSTANTS', 'LabelSrvc', 'CreasMessaggiFctr', 'CreasDettaglioPraticaSrvc' ];
	
		var TemplateUrl = function(CONSTANTS) {
			return CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + "creasDettaglioPratica/creasPraticaPagamento/creasSceltaPolizze/creasSceltaPolizze.html";
		}
	
		TemplateUrl.$inject = [ 'CONSTANTS' ];
	
		var CreasSceltaPolizzeComponent = {
			bindings : {},
			controller : CreasSceltaPolizzeCtrl,
			controllerAs : "creasSceltaPolizzeCtrl",
			templateUrl : TemplateUrl
		};
	
		angular.module("cbl.insuranceloanpmi.mf").component("creasSceltaPolizze", CreasSceltaPolizzeComponent);
	}());

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.insuranceloanpmi.mf.directive:creasRiepilogoPolizze
	 * @restrict E
	 * @description Componente che gestisce il terzo sotto-step "Riepilogo Polizze" dello step "Pagamento"
	 */
	(function() {
		"use strict";
		var CreasRiepilogoPolizzeCtrl = function($http, $scope, $state, $stateParams, $window, $q, $httpParamSerializer, $uibModal, CONSTANTS, labelSrvc, messaggiFctr, dettPraticaSrvc) {
			this.$http = $http;
			this.$state = $state;
			this.$stateParams = $stateParams;
			this.$window = $window;
			this.$uibModal = $uibModal;
			this.messaggiFctr = messaggiFctr;
			this.dettPraticaSrvc = dettPraticaSrvc;
			this.CONSTANTS = CONSTANTS;
			$scope.msg = labelSrvc.getLabel;
			
			// Spinner
		    this.spinner = dettPraticaSrvc.spinner;
	
			var self = this;
			
			// Configuro l'abilitazione dei pulsanti di scorrimento tra gli step	
			dettPraticaSrvc.isCancelFinanziamentoVisible = function() {
		      return true;
		    };
		    dettPraticaSrvc.isCancelFinanziamentoEnabled = function() {
		      return true;
		    };
			dettPraticaSrvc.isSaveEnabled = function() {
				return self.dettPraticaSrvc.finanziamento.elencoPolizze && self.dettPraticaSrvc.finanziamento.elencoPolizze.length > 0;
			}
			
			dettPraticaSrvc.isPrevEnabled = function() {
				return true;
			}
			
			dettPraticaSrvc.isNextEnabled = function() {
				return self.dettPraticaSrvc.finanziamento.elencoPolizze && self.dettPraticaSrvc.finanziamento.elencoPolizze.length > 0;
			}
			
			// Configuro il comportamento del pulsante prosegui per lo step
		    dettPraticaSrvc.nextStep = function() {
				
				if (!self.dettPraticaSrvc.finanziamento) {
					return;
				}
				
				if (self.dettPraticaSrvc.verificaImportiPolizze() !== true) {
					return;
				}
				
				// Richiedo conferma prima di proseguire con l'avanzamento di step
			      var modalController = function($scope, LabelSrvc, $modalInstance) {
				      $scope.headerText = LabelSrvc.getLabel(
				        'label.riepilogopolizze.confermaavanti.header'
				      );
				      $scope.bodyText = LabelSrvc.getLabel(
				        'label.riepilogopolizze.confermaavanti.content'
				      );
				      $scope.cancelText = LabelSrvc.getLabel(
				        'label.riepilogopolizze.confermaavanti.cancel'
				      );
				      $scope.confirmText = LabelSrvc.getLabel(
				        'label.riepilogopolizze.confermaavanti.confirm'
				      );
				
				      $scope.optionSelected = function(result) {
				        $modalInstance.close(result);
				      };
				    };
				
				    modalController.$inject = ['$scope', 'LabelSrvc', '$modalInstance'];
				
				    var modalInstance = self.$uibModal.open({
				      animation: true,
				      template:
				        '<creas-confirm-modal header-text="headerText" body-text="bodyText" cancel-text="cancelText" confirm-text="confirmText" option-selected="optionSelected(result)"></creas-confirm-modal>',
				      backdrop: 'static',
				      size: 'lg',
				      controller: modalController
				    });
				
				    modalInstance.result.then(function(confirmResult) {
				      if (confirmResult !== true) {
				        return;
				      }
						// SALVATAGGIO POLIZZE
						self.spinner.pratica = true;
						
						$q
						.all({salvaPolizze: self.dettPraticaSrvc.promiseSalvaPolizze()})
						.then(
						  function(response) {
							  if (response.salvaPolizze.data.result) {
					            $q
					              .all({
					                nextStep: self.dettPraticaSrvc.promiseCambiaStep('/avantiStep')
					              })
					              .then(
					                function(response) {
					                  if (self.messaggiFctr.processaResponse(response.nextStep)) {
					                    return;
					                  }
					                  
					                  self.dettPraticaSrvc.datiPratica = response.nextStep.data.result;
					                  dettPraticaSrvc.generaTabs();
					                },
					                function(reason) {
					                  self.messaggiFctr.processaResponse(reason.nextStep);
					                }
					              )
					              .finally(function() {
					                self.spinner.pratica = false;
					              });
					          } else {
					            self.spinner.pratica = false;
					          }
						  },
						  function(reason) {
						    self.messaggiFctr.processaResponse(reason.salvaPolizze);
						    self.spinner.pratica = false;
						  }
						);
				    });
		    };
	
		    // Configuro il comportamento del pulsante salva per lo step
			dettPraticaSrvc.salva = function() {
					
				if (self.dettPraticaSrvc.verificaImportiPolizze() !== true) {
					return;
				}
				
				self.spinner.pratica = true;
				  
				$q
				.all({salvaPolizze: self.dettPraticaSrvc.promiseSalvaPolizze()})
				.then(
					function(response) {
						self.dettPraticaSrvc.finanziamento = response.salvaPolizze.data.result;
						if (self.messaggiFctr.processaResponse(response.salvaPolizze)) {
							return;
						}
					},
					function(reason) {
						self.messaggiFctr.processaResponse(reason.salvaPolizze);
					}
				)
				.finally(function() {
					self.spinner.pratica = false;
				});
				
			};
			
			/**
			 * @ngdoc method
			 * @name rimuoviTitolo
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRiepilogoPolizze
			 * @description Rimuove il titolo selezionato da quelli aggiunti alla pratica
			 * @param {Object} titolo - Il titolo da rimuovere
			 */
			this.rimuoviTitolo = function(titolo) {
				var itemIndex = self.dettPraticaSrvc.finanziamento.elencoPolizze.indexOf(titolo);
				
				if (itemIndex === -1) {
					return;
				}
				
				self.dettPraticaSrvc.finanziamento.elencoPolizze.splice(itemIndex, 1);
				self.aggiornaTitoli();
			}
			
			/**
			 * @ngdoc method
			 * @name aggiornaTitoli
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRiepilogoPolizze
			 * @description Aggiorna la visualizzazione dell'elenco dei titoli aggiunti
			 */
			this.aggiornaTitoli = function() {
				self.dettPraticaSrvc.finanziamento.elencoPolizze = self.dettPraticaSrvc.finanziamento.elencoPolizze.concat([]);
			}
			
			/**
			 * @ngdoc method
			 * @name recuperaTotaleTitoli
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRiepilogoPolizze
			 * @description Calcola e mostra il totale dei titoli selezionati
			 */
			this.recuperaTotaleTitoli = function() {			
				var totaleTitoli = 0;
				
				if (self.dettPraticaSrvc.finanziamento.elencoPolizze && self.dettPraticaSrvc.finanziamento.elencoPolizze.length > 0) {
					for(var i = 0; i < self.dettPraticaSrvc.finanziamento.elencoPolizze.length; i++) {
						totaleTitoli += self.dettPraticaSrvc.finanziamento.elencoPolizze[i].datiPagamento.importoPremioLordo;
					}
				}
				
				return totaleTitoli;
			}
			
			/**
			 * @ngdoc method
			 * @name mostraTitoliSalvati
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRiepilogoPolizze
			 * @description Recupera i titoli salvati nella pratica e li mostra tra quelli selezionati
			 */
			this.mostraTitoliSalvati = function() {
				self.dettPraticaSrvc.finanziamento = self.dettPraticaSrvc.getFinanziamentoBozza();
				
				if (!self.dettPraticaSrvc.finanziamento) {
					return;
				}
				
				if (!self.dettPraticaSrvc.finanziamento.elencoPolizze) {
					return;
				}
				
				self.aggiornaTitoli();
			}
			
			this.mostraTitoliSalvati();
	
			
		};
	
		CreasRiepilogoPolizzeCtrl.$inject = [ '$http', '$scope', '$state', '$stateParams', '$window', '$q', '$httpParamSerializer', '$uibModal', 'CONSTANTS', 'LabelSrvc', 'CreasMessaggiFctr', 'CreasDettaglioPraticaSrvc' ];
	
		var TemplateUrl = function(CONSTANTS) {
			return CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + "creasDettaglioPratica/creasPraticaPagamento/creasRiepilogoPolizze/creasRiepilogoPolizze.html";
		}
	
		TemplateUrl.$inject = [ 'CONSTANTS' ];
	
		var CreasRiepilogoPolizzeComponent = {
			bindings : {},
			controller : CreasRiepilogoPolizzeCtrl,
			controllerAs : "creasRiepilogoPolizzeCtrl",
			templateUrl : TemplateUrl
		};
	
		angular.module("cbl.insuranceloanpmi.mf").component("creasRiepilogoPolizze", CreasRiepilogoPolizzeComponent);
	}());

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.insuranceloanpmi.mf.directive:creasPagamentoGestioneDocumenti
	 * @restrict E
	 * @description Componente che gestisce il quarto sotto-step "Gestione Documenti" dello step "Pagamento"
	 */
	(function () {
	  'use strict';
	  var CreasPagamentoGestioneDocumentiCtrl = function (
	    $http,
	    $scope,
	    $state,
	    $stateParams,
	    $window,
	    $q,
	    $httpParamSerializer,
	    $uibModal,
	    CONSTANTS,
	    labelSrvc,
	    messaggiFctr,
	    dettPraticaSrvc
	  ) {
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.$uibModal = $uibModal;
	    this.messaggiFctr = messaggiFctr;
	    this.dettPraticaSrvc = dettPraticaSrvc;
	    this.CONSTANTS = CONSTANTS;
	    $scope.msg = labelSrvc.getLabel;
	    // Workaround per bug widget fea
	    this.anagraficaFea = angular.copy(
	      this.dettPraticaSrvc.datiPratica.intestatario
	    );
	    this.anagraficaFea.naturaGiuridica = this.anagraficaFea.formaCostitutiva;
	
	    this.spinner = this.dettPraticaSrvc.spinner;
	    this.subSpinner = {
	      documenti: false
	    };
	
	    this.isCompletable = false;
	
	    this.generateDocumentLink =
	      window.location.origin +
	      '/MSF-PRACTICEMANAGER-MF/api/DocumentWorkflow/GeneraDocumentiGestionePolizzeCreditoPMI';
	
	    var self = this;
	
	    dettPraticaSrvc.isCompleteEnabled = function () {
	      if (
	        (dettPraticaSrvc.datiPratica.fidoNonOperativo.stato !== 'VALIDO' &&
	          dettPraticaSrvc.datiPratica.fidoNonOperativo.stato !==
	            'DA_EROGARE') ||
	        (dettPraticaSrvc.datiPratica.stato === 'GESTIONEPOLIZZE' &&
	          (dettPraticaSrvc.datiPratica.step === 5 ||
	            dettPraticaSrvc.datiPratica.step === 6))
	      ) {
	        return false;
	      }
	      return self.isCompletable;
	    };
	
	    // Configuro il comportamento del pulsante completa per lo step
	    dettPraticaSrvc.isCancelFinanziamentoVisible = function () {
	      return true;
	    };
	    dettPraticaSrvc.isCancelFinanziamentoEnabled = function () {
	      return true;
	    };
	    dettPraticaSrvc.completed = function () {
	      if (!self.dettPraticaSrvc.finanziamento) {
	        return;
	      }
	
	      self.spinner.pratica = true;
	
	      self.verificaDocumenti();
	    };
	
	    /**
	     * @ngdoc method
	     * @name verificaDocumenti
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasPagamentoGestioneDocumenti
	     * @description Esegue la verifica dei documenti per la pratica ed il finanziamento indicati
	     */
	    this.verificaDocumenti = function () {
	      $q.all({
	        verifica: self.dettPraticaSrvc.promiseCheckDocumenti(
	          self.dettPraticaSrvc.datiPratica.idPratica,
	          self.dettPraticaSrvc.finanziamento.idFinanziamentoPMI
	        )
	      }).then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response.verifica)) {
	            self.spinner.pratica = false;
	            return;
	          }
	
	          if (response.verifica.data.result !== true) {
	            self.spinner.pratica = false;
	            return;
	          }
	          self.messaggiFctr.addMessage({
	            type: 'I',
	            message: $scope.msg(
	              'label.dettagliopratica.step6.sub4.completafinanziamento.checkdocumenti'
	            )
	          });
	          self.eseguiAccettazioni();
	        },
	        function (reason) {
	          self.spinner.pratica = false;
	          self.messaggiFctr.processaResponse(reason.verifica);
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name firmaDocumenti
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasPagamentoGestioneDocumenti
	     * @description Esegue la firma dei documenti per la pratica ed il finanziamento indicati
	     */
	    this.firmaDocumenti = function () {
	      // rimuovo pulsante cancella finanziamento
	      self.dettPraticaSrvc.isCancelFinanziamentoVisible = null;
	      $q.all({
	        firma: self.dettPraticaSrvc.promiseFirmaDocumenti(
	          self.dettPraticaSrvc.datiPratica.idPratica,
	          self.dettPraticaSrvc.finanziamento.idFinanziamentoPMI
	        )
	      }).then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response.firma)) {
	            self.spinner.pratica = false;
	            return;
	          }
	
	          if (response.firma.data.result !== true) {
	            self.spinner.pratica = false;
	            return;
	          }
	
	          self.messaggiFctr.addMessage({
	            type: 'I',
	            message: $scope.msg(
	              'label.dettagliopratica.step6.sub4.completafinanziamento.firma'
	            )
	          });
	          self.completaPratica(1);
	        },
	        function (reason) {
	          self.spinner.pratica = false;
	          self.messaggiFctr.processaResponse(reason.firma);
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name completaPratica
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasPagamentoGestioneDocumenti
	     * @description Esegue la chiamata per completare la pratica
	     */
	    this.completaPratica = function (fase) {
	      self.messaggiFctr.addMessage({
	        type: 'I',
	        message: $scope.msg(
	          'label.dettagliopratica.step6.sub4.completafinanziamento.fase' + fase
	        )
	      });
	      $q.all({
	        completaPratica: self.dettPraticaSrvc.promiseCompletaFinanziamento(fase)
	      }).then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response.completaPratica)) {
	            self.spinner.pratica = false;
	            return;
	          }
	          self.dettPraticaSrvc.datiPratica =
	            response.completaPratica.data.result;
	          if (fase < 4) {
	            fase++;
	            self.completaPratica(fase);
	          } else {
	            self.dettPraticaSrvc.finanziamento = null;
	            self.spinner.pratica = false;
	            self.dettPraticaSrvc.generaTabs();
	          }
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason.completaPratica);
	          self.spinner.pratica = false;
	        }
	      );
	    };
	
	    this.eseguiAccettazioni = function () {
	      // Se nelle infoCerved ho richiestaAnagrafica a true, eseguo prima l'accettazione dei prospetti
	      if (
	        self.dettPraticaSrvc.datiPratica.infoCerved &&
	        self.dettPraticaSrvc.datiPratica.infoCerved.richiestaAnagrafica === true
	      ) {
	        // Verifico se le pratiche propedeutiche sono tutte evase correttamente
	        self.messaggiFctr.addMessage({
	          type: 'I',
	          message: $scope.msg('label.dettagliopratica.step5.checkpropedeutico')
	        });
	        $q.all({
	          checkPropedeutiche:
	            self.dettPraticaSrvc.promiseCheckPratichePropedeutiche(
	              self.dettPraticaSrvc.datiPratica.idPratica
	            )
	        }).then(
	          function (response) {
	            // Se ho degli errori, esco dalla procedura
	            if (
	              self.messaggiFctr.processaResponse(response.checkPropedeutiche)
	            ) {
	              self.spinner.pratica = false;
	              return;
	            }
	            // Richiedo i dettagli delle anagrafiche della pratica
	            $q.all({
	              datiAnagrafica:
	                self.dettPraticaSrvc.promiseDatiClienteIntegrazione()
	            }).then(
	              function (response) {
	                // Se ho degli errori, esco dalla procedura
	                if (
	                  self.messaggiFctr.processaResponse(response.datiAnagrafica)
	                ) {
	                  self.spinner.pratica = false;
	                  return;
	                }
	                self.messaggiFctr.addMessage({
	                  type: 'I',
	                  message: $scope.msg(
	                    'label.dettagliopratica.step5.avvioaccetta'
	                  )
	                });
	                // Elaboro i dati dei firmatari e richiamo l'accettazione per ognuno di essi
	                // Eseguo tutte le chiamate di accettazione
	                if (
	                  response.datiAnagrafica.data.result.firmatario &&
	                  response.datiAnagrafica.data.result.firmatario.anagrafica
	                ) {
	                  self.eseguiAccettazioneFirmatariPF(
	                    response.datiAnagrafica.data.result
	                  );
	                } else {
	                  self.eseguiAccettazioneFirmatariPG(
	                    response.datiAnagrafica.data.result
	                  );
	                }
	              },
	              function (reason) {
	                self.spinner.pratica = false;
	                self.messaggiFctr.processaResponse(reason.datiAnagrafica);
	              }
	            );
	          },
	          function (reason) {
	            self.spinner.pratica = false;
	            self.messaggiFctr.processaResponse(reason.checkPropedeutiche);
	          }
	        );
	
	        return;
	      } else {
	        // Altrimenti richiamo direttamente "firmaDocumenti"
	        self.firmaDocumenti();
	      }
	    };
	
	    this.eseguiAccettazioneFirmatariPF = function (datiAnagrafica) {
	      var firmatariCalls = {};
	      var prospetti = [];
	
	      if (
	        datiAnagrafica.firmatario === undefined ||
	        datiAnagrafica.firmatario === null
	      ) {
	        self.messaggiFctr.addMessage({
	          type: 'W',
	          message: $scope.msg(
	            'label.dettagliopratica.step5.firmatariononvalido'
	          )
	        });
	        self.spinner.pratica = false;
	        return;
	      } else if (
	        datiAnagrafica.firmatario.anagrafica.prospetto === true &&
	        (datiAnagrafica.firmatario.prospetto === undefined ||
	          datiAnagrafica.firmatario.prospetto === null)
	      ) {
	        self.messaggiFctr.addMessage({
	          type: 'W',
	          message: $scope.msg(
	            'label.dettagliopratica.step5.firmatariononvalido'
	          )
	        });
	        self.spinner.pratica = false;
	        return;
	      } else if (datiAnagrafica.firmatario.anagrafica.prospetto === true) {
	        var callPraticaFirmatarioProspetto =
	          self.dettPraticaSrvc.promiseAccettaPersonaFisica(
	            datiAnagrafica.firmatario.prospetto.idPratica
	          );
	        firmatariCalls[
	          'firmatario' + datiAnagrafica.firmatario.prospetto.idPratica
	        ] = callPraticaFirmatarioProspetto;
	        prospetti.push(datiAnagrafica.firmatario.prospetto.idPratica);
	      }
	
	      if (datiAnagrafica.titolari && datiAnagrafica.titolari.length > 0) {
	        for (var i = 0; i < datiAnagrafica.titolari.length; i++) {
	          if (
	            datiAnagrafica.titolari[i] === undefined ||
	            datiAnagrafica.titolari[i] === null
	          ) {
	            self.messaggiFctr.addMessage({
	              type: 'W',
	              message: $scope.msg(
	                'label.dettagliopratica.step5.firmatariononvalido'
	              )
	            });
	            self.spinner.pratica = false;
	            return;
	          } else if (
	            datiAnagrafica.titolari[i].anagrafica.prospetto === true &&
	            (datiAnagrafica.titolari[i].prospetto === undefined ||
	              datiAnagrafica.titolari[i].prospetto === null)
	          ) {
	            self.messaggiFctr.addMessage({
	              type: 'W',
	              message: $scope.msg(
	                'label.dettagliopratica.step5.firmatariononvalido'
	              )
	            });
	            self.spinner.pratica = false;
	            return;
	          } else if (datiAnagrafica.titolari[i].anagrafica.prospetto === true) {
	            var callPraticaProspetto =
	              self.dettPraticaSrvc.promiseAccettaPersonaFisica(
	                datiAnagrafica.titolari[i].prospetto.idPratica
	              );
	            firmatariCalls[
	              'firmatario' + datiAnagrafica.titolari[i].prospetto.idPratica
	            ] = callPraticaProspetto;
	            prospetti.push(datiAnagrafica.titolari[i].prospetto.idPratica);
	          }
	        }
	      }
	
	      // Se non ho prospetti, passo direttamente all'integrazione della persona giuridica
	      if (prospetti.length === 0) {
	        self.eseguiAccettazioneFirmatariPG(datiAnagrafica);
	        return;
	      }
	
	      $q.all(firmatariCalls).then(
	        function (firmatariResponse) {
	          // Elaboro le risposte di tutti i prospetti
	          // La chiamata ha esito positivo se la risposta è vuota
	          for (var i = 0; i < prospetti.length; i++) {
	            if (
	              self.messaggiFctr.processaResponse(
	                firmatariResponse['firmatario' + prospetti[i]]
	              )
	            ) {
	              self.spinner.pratica = false;
	              return;
	            }
	          }
	
	          // Se tutte sono andate a buon fine, procedo con l'accettazione della persona giuridica
	          self.messaggiFctr.addMessage({
	            type: 'I',
	            message: $scope.msg(
	              'label.dettagliopratica.step5.accettatofirmatario'
	            )
	          });
	          self.eseguiAccettazioneFirmatariPG(datiAnagrafica);
	        },
	        function (firmatariReason) {
	          if (Array.isArray(firmatariReason)) {
	            for (var i = 0; i < prospetti.length; i++) {
	              self.messaggiFctr.processaResponse(
	                firmatariReason['firmatario' + prospetti[i]]
	              );
	            }
	          } else {
	            self.messaggiFctr.processaResponse(firmatariReason);
	          }
	          self.spinner.pratica = false;
	
	          return;
	        }
	      );
	    };
	
	    this.eseguiAccettazioneFirmatariPG = function (datiAnagrafica) {
	      if (
	        datiAnagrafica.giuridica === undefined ||
	        datiAnagrafica.giuridica === null
	      ) {
	        self.spinner.pratica = false;
	        self.messaggiFctr.addMessage({
	          type: 'W',
	          message: $scope.msg('label.dettagliopratica.step5.pgnonvalida')
	        });
	        return;
	      } else if (
	        datiAnagrafica.giuridica.anagrafica.prospetto === true &&
	        (datiAnagrafica.giuridica.prospetto === undefined ||
	          datiAnagrafica.giuridica.prospetto === null)
	      ) {
	        self.spinner.pratica = false;
	        self.messaggiFctr.addMessage({
	          type: 'W',
	          message: $scope.msg('label.dettagliopratica.step5.pgnonvalida')
	        });
	        return;
	      } else if (datiAnagrafica.giuridica.anagrafica.prospetto === true) {
	        $q.all({
	          prospettoPG: self.dettPraticaSrvc.promiseAccettaPersonaGiuridica(
	            datiAnagrafica.giuridica.prospetto.idPratica,
	            datiAnagrafica.giuridica.anagrafica.formaCostitutiva
	          )
	        }).then(
	          function (prospettoPGResponse) {
	            // La chiamata ha esito positivo se la risposta è vuota
	            if (
	              self.messaggiFctr.processaResponse(
	                prospettoPGResponse.prospettoPG
	              )
	            ) {
	              self.spinner.pratica = false;
	              return;
	            }
	
	            // Se la chiamata è andata a buon fine, procedo col passaggio al firma documenti
	            self.messaggiFctr.addMessage({
	              type: 'I',
	              message: $scope.msg('label.dettagliopratica.step5.accettatapg')
	            });
	            self.firmaDocumenti();
	          },
	          function (pgReason) {
	            self.spinner.pratica = false;
	            var errorMsg = JSON.parse(pgReason.data);
	            if (prospettoPGResponse.status === 417) {
	              messaggiSrvc.pushErrorMessage(
	                labelSrvc
	                  .getLabel('errors.417')
	                  .replace(
	                    '[ID_PRATICA]',
	                    datiAnagrafica.giuridica.prospetto.idPratica
	                  )
	              );
	              self.spinner.pratica = false;
	              return;
	            } else if (errorMsg && errorMsg.Messages) {
	              for (var i = 0; i < errorMsg.Messages.length; i++) {
	                self.messaggiFctr.addMessage({
	                  type: 'E',
	                  message: errorMsg.Messages[i].Message
	                });
	              }
	            }
	
	            return;
	          }
	        );
	      } else {
	        self.firmaDocumenti();
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name generaDocumenti
	     * @methodOf cbl.insuranceloanpmi.mf.directive:creasPagamentoGestioneDocumenti
	     * @description Apre una finestra modale per l'inserimento di luogo e data da apporre sui documenti da generare
	     */
	    this.generaDocumenti = function () {
	      self.subSpinner.documenti = false;
	      self.isCompletable = true;
	    };
	
	    self.dettPraticaSrvc.finanziamento =
	      self.dettPraticaSrvc.getFinanziamentoBozza();
	    self.generaDocumenti();
	  };
	
	  CreasPagamentoGestioneDocumentiCtrl.$inject = [
	    '$http',
	    '$scope',
	    '$state',
	    '$stateParams',
	    '$window',
	    '$q',
	    '$httpParamSerializer',
	    '$uibModal',
	    'CONSTANTS',
	    'LabelSrvc',
	    'CreasMessaggiFctr',
	    'CreasDettaglioPraticaSrvc'
	  ];
	
	  var TemplateUrl = function (CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'creasDettaglioPratica/creasPraticaPagamento/creasPagamentoGestioneDocumenti/creasPagamentoGestioneDocumenti.html'
	    );
	  };
	
	  TemplateUrl.$inject = ['CONSTANTS'];
	
	  var CreasPagamentoGestioneDocumentiComponent = {
	    bindings: {},
	    controller: CreasPagamentoGestioneDocumentiCtrl,
	    controllerAs: 'creasPagamentoGestioneDocumentiCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.insuranceloanpmi.mf')
	    .component(
	      'creasPagamentoGestioneDocumenti',
	      CreasPagamentoGestioneDocumentiComponent
	    );
	})();


/***/ }),
/* 31 */
/***/ (function(module, exports) {

	/**
	 * 
	 */
	(function() {
		angular.module("cbl.insuranceloanpmi.mf").service("LabelSrvc", [ function() {
			this.labels = [];
			var self = this;
			this.develop = true;
			this.loading = true;
			this.labelsPronte;
	
			this.getLabel = function(label) {
				var res = self.labels[label];
				if (res === undefined || res === "") {
					res = "UNDEFINED LABEL";
					if (self.develop) {
						res += " [" + label + "]";
					}
				}
				return res;
			};
		} ]);
	}());


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	/**
	 * 
	 */
	(function() {
		angular.module("cbl.insuranceloanpmi.mf").service("MappingSrvc", [ function() {
			this.values = [];
			var self = this;
	
			this.getValue = function(key) {
				var res = self.values[key];
				if (res === undefined || res === "") {
					res = "UNDEFINED VALUE";
				}
				return res;
			};
			
		} ]);
	}());


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	/**
	 *
	 */
	(function() {
	    'use strict';
	    angular.module('cbl.insuranceloanpmi.mf').factory('CreasMessaggiFctr', [
	        'CblMessageSrvc',
	        'LabelSrvc',
	        'LoggerSrvc',
	        'CommonUtilitiesSrvc',
	        '$uibModal',
	        function(messaggiSrvc, labelSrvc, loggerSrvc, commonUtilities, $uibModal) {
	            var processaResponse = function(response) {
	                if (!response) {
	                    var message = {
	                        message: 'Nessuna risposta ricevuta dal servizio'
	                    };
	                    messaggiSrvc.pushErrorMessage(message.message);
	                    return true;
	                }
	                var hasError = false;
	                if (response.data && response.data.messageList) {
	                    if (response.data.messageList.errMessages) {
	                        for (var i in response.data.messageList.errMessages) {
	                            messaggiSrvc.pushErrorMessage(
	                                response.data.messageList.errMessages[i].message
	                            );
	                            console.error(response.data.messageList.errMessages[i].message);
	                        }
	                        hasError = response.data.messageList.errMessages.length > 0;
	                    }
	                    if (response.data.messageList.fatMessages) {
	                        for (var j in response.data.messageList.fatMessages) {
	                            messaggiSrvc.pushErrorMessage(
	                                response.data.messageList.fatMessages[j].message
	                            );
	                            console.error(response.data.messageList.fatMessages[i].message);
	                        }
	
	                        if (hasError === false) {
	                            hasError = response.data.messageList.fatMessages.length > 0;
	                        }
	                    }
	                    if (response.data.messageList.warMessages) {
	                        for (var k in response.data.messageList.warMessages) {
	                            messaggiSrvc.pushWarningMessage(
	                                response.data.messageList.warMessages[k].message
	                            );
	                        }
	                    }
	                    if (response.data.messageList.infMessages) {
	                        for (var z in response.data.messageList.infMessages) {
	                            messaggiSrvc.pushInfoMessage(
	                                response.data.messageList.infMessages[z].message
	                            );
	                        }
	                    }
	                }
	                if (response.status === 504) {
	                    messaggiSrvc.pushErrorMessage(
	                        labelSrvc.getLabel('errors.gatewaytimeout')
	                    );
	                    return true;
	                }
	                if (response.status > 399) {
	                    if (typeof response.data === 'string') {
	                        try {
	                            var businessParam = JSON.parse(response.data).Messages[0]
	                                .BusinessParam;
	                            var businessParamType = commonUtilities.isNullOrUndefined(
	                                    businessParam
	                                ) ?
	                                null :
	                                businessParam.Type;
	                            if (businessParamType == 'DOCUMENTI_INCOMPLETI_OBBLIGATORI') {
	                                commonUtilities.showPopupObligatoryDocumentsIncomplete({ $uibModal: $uibModal },
	                                    response,
	                                    null
	                                );
	                            } else if (businessParamType == 'CAMBIO_STATO_BLOCCATO') {
	                                commonUtilities.showPopupChangeStateBlocked({ $uibModal: $uibModal },
	                                    response,
	                                    null
	                                );
	                            } else {
	                                var errorMsg = JSON.parse(response.data);
	
	                                if (errorMsg && errorMsg.Messages) {
	                                    for (var i = 0; i < errorMsg.Messages.length; i++) {
	                                        messaggiSrvc.pushErrorMessage(errorMsg.Messages[i].Message);
	                                    }
	                                }
	                            }
	                        } catch (e) {}
	                    } else {
	                        var messageHttp = {
	                            message: 'Error ' + response.status + ' ' + response.statusText
	                        };
	                        messaggiSrvc.pushErrorMessage(messageHttp.message);
	                    }
	                    return true;
	                }
	                return hasError;
	            };
	
	            var addMessage = function(message) {
	                if (message.type === 'E' || message.type === 'F') {
	                    messaggiSrvc.pushErrorMessage(message.message);
	                } else if (message.type === 'W') {
	                    messaggiSrvc.pushWarningMessage(message.message);
	                } else {
	                    messaggiSrvc.pushInfoMessage(message.message);
	                }
	            };
	
	            var resetMessages = function() {
	                messaggiSrvc.reset();
	            };
	
	            var processaForm = function(form) {
	                if (form.$valid) {
	                    return true;
	                }
	                this.validaForm(form);
	                var message = null;
	                for (var label in form.$error.required) {
	                    message = {
	                        type: 'E',
	                        message: form.$error.required[label].$name +
	                            ': ' +
	                            labelSrvc.getLabel('validazione.obbligatorio')
	                    };
	                    this.addMessage(message);
	                }
	                for (var labelMax in form.$error.max) {
	                    message = {
	                        type: 'E',
	                        message: form.$error.max[labelMax].$name +
	                            ': ' +
	                            labelSrvc.getLabel('validazione.valore.massimo')
	                    };
	                    this.addMessage(message);
	                }
	                for (var labelNmb in form.$error.number) {
	                    message = {
	                        type: 'E',
	                        message: form.$error.number[labelNmb].$name +
	                            ': ' +
	                            labelSrvc.getLabel('validazione.numerico')
	                    };
	                    this.addMessage(message);
	                }
	                for (var labelMin in form.$error.min) {
	                    message = {
	                        type: 'E',
	                        message: form.$error.number[labelMin].$name +
	                            ': ' +
	                            labelSrvc.getLabel('validazione.valore.minimo')
	                    };
	                    this.addMessage(message);
	                }
	                return false;
	            };
	
	            var validaForm = function(form) {
	                this.resetMessages();
	                var valid = true;
	                var message = null;
	                var label = null;
	                for (label in form.$error.pattern) {
	                    valid = false;
	                    message = {
	                        type: 'E',
	                        message: form.$error.pattern[label].$name +
	                            ': ' +
	                            labelSrvc.getLabel('validazione.formato')
	                    };
	                    this.addMessage(message);
	                }
	                for (label in form.$error.cblMax) {
	                    valid = false;
	                    message = {
	                        type: 'E',
	                        message: form.$error.cblMax[label].$name +
	                            ': ' +
	                            labelSrvc.getLabel('validazione.massimo')
	                    };
	                    this.addMessage(message);
	                }
	                for (label in form.$error.cblMin) {
	                    valid = false;
	                    message = {
	                        type: 'E',
	                        message: form.$error.cblMin[label].$name +
	                            ': ' +
	                            labelSrvc.getLabel('validazione.minimo')
	                    };
	                    this.addMessage(message);
	                }
	                for (label in form.$error.cblPrecisione) {
	                    valid = false;
	                    message = {
	                        type: 'E',
	                        message: form.$error.cblPrecisione[label].$name +
	                            ': ' +
	                            labelSrvc.getLabel('validazione.precisione')
	                    };
	                    this.addMessage(message);
	                }
	                for (label in form.$error.maxlength) {
	                    valid = false;
	                    message = {
	                        type: 'E',
	                        message: form.$error.maxlength[label].$name +
	                            ': ' +
	                            labelSrvc.getLabel('validazione.maxlength')
	                    };
	                    this.addMessage(message);
	                }
	                for (label in form.$error.minlength) {
	                    valid = false;
	                    message = {
	                        type: 'E',
	                        message: form.$error.minlength[label].$name +
	                            ': ' +
	                            labelSrvc.getLabel('validazione.minlength')
	                    };
	                    this.addMessage(message);
	                }
	                for (label in form.$error.maxDate) {
	                    valid = false;
	                    message = {
	                        type: 'E',
	                        message: form.$error.maxDate[label].$name +
	                            ': ' +
	                            labelSrvc.getLabel('validazione.maxdate')
	                    };
	                    this.addMessage(message);
	                }
	                for (label in form.$error.minDate) {
	                    valid = false;
	                    message = {
	                        type: 'E',
	                        message: form.$error.minDate[label].$name +
	                            ': ' +
	                            labelSrvc.getLabel('validazione.mindate')
	                    };
	                    this.addMessage(message);
	                }
	                return valid;
	            };
	
	            var scroll = function(id) {
	                var headerMarg = parseInt(
	                    angular.element('.navbar-fixed-top').css('margin-top')
	                );
	                if (isNaN(headerMarg)) {
	                    headerMarg = 0;
	                }
	                var diffScroll =
	                    angular.element('.navbar-fixed-top').height() +
	                    headerMarg +
	                    angular.element('#prodConvBox').height();
	                var scrollPoint = angular.element(id).offset().top - diffScroll;
	                angular.element('body,html').animate({
	                        scrollTop: scrollPoint
	                    },
	                    500
	                );
	            };
	
	            return {
	                processaResponse: processaResponse,
	                addMessage: addMessage,
	                resetMessages: resetMessages,
	                processaForm: processaForm,
	                validaForm: validaForm,
	                scroll: scroll
	            };
	        }
	    ]);
	})();

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	/**
	 * 
	 */
	(function() {
		angular.module("cbl.insuranceloanpmi.mf").service("PaginatoreSrvc", [ function() {
	
			this.itemsPerPage = 10;
			this.pageNumber = 1;
			this.maxSize = 5;
	
			self = this;
	
			this.init = function() {
				self.itemsPerPage = 10;
				self.pageNumber = 1;
				self.maxSize = 5;
				self.listaFiltrata = null;
			}
	
		} ]);
	}());

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	/**
	 * 
	 */
	(function() {
		"use strict";
		angular.module("cbl.insuranceloanpmi.mf").service("DomainSrvc", [ '$http', '$q', 'CreasMessaggiFctr', 'CONSTANTS', function($http, $q, messaggiFctr, CONSTANTS) {
			this.domains = {};
	
			this.getDomain = function(domain, skipBlank) {
				if (this.domains === undefined) {
					this.domains = {};
				}
				if (this.domains[domain] === undefined || this.domains[domain].length === 0) {
					// chiamata Rest al servizio di recupero dominio in caso non sia
					// gia' memorizzato
					var self = this;
					$http({
						method : "GET",
						url : CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.DOMAIN,
						params : {
							table : domain.toUpperCase()
						}
					}).then(function(response) {
						if (messaggiFctr.processaResponse(response)) {
							return;
						}
						self.domains[domain] = [];
						if (!skipBlank) {
							self.domains[domain].push({
								cod : "",
								dsc : "Seleziona..."
							});
						}
						for ( var i in response.data.result) {
							self.domains[domain].push(response.data.result[i]);
						}
	
					}, function(reason) {
						messaggiFctr.processaResponse(reason);
					});
				}
				return this.domains[domain];
			};
	
			this.promiseDomain = function(domain) {
				var deferred = $q.defer();
	
				if (this.domains[domain] === undefined) {
					var self = this;
					$http({
						method : "GET",
						url : CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.DOMAIN,
						params : {
							table : domain.toUpperCase()
						}
					}).then(function(response) {
						if (messaggiFctr.processaResponse(response)) {
							return;
						}
						self.domains[domain] = [];
	
						for ( var j in response.data.result) {
							self.domains[domain].push(response.data.result[j]);
						}
	
						deferred.resolve(self.domains[domain]);
					}, function(reason) {
						deferred.reject(reason);
						messaggiFctr.processaResponse(reason);
					});
				} else {
					deferred.resolve(this.domains[domain]);
				}
	
				return deferred.promise;
			};
	
			this.promiseCascading = function(domain, cascading, skipBlank) {
				var deferred = $q.defer();
	
				var self = this;
				var cascadingDomain = [];
				$http({
					method : "GET",
					url : CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.DOMAIN,
					cache : true,
					params : {
						table : domain.toUpperCase(),
						params : cascading
					}
				}).then(function(response) {
					if (messaggiFctr.processaResponse(response)) {
						deferred.reject(response);
						return;
					}
					if (!skipBlank) {
						cascadingDomain.push({
							cod : "",
							dsc : "Seleziona..."
						});
					}
					for ( var i in response.data.result) {
						cascadingDomain.push(response.data.result[i]);
					}
					deferred.resolve(cascadingDomain);
				}, function(reason) {
					messaggiFctr.processaResponse(reason);
					deferred.reject(reason);
				});
	
				return deferred.promise;
			};
	
			this.promiseEccezioni = function(domain, cascading, skipBlank) {
				var deferred = $q.defer();
	
				var self = this;
				var cascadingDomain = [];
				$http({
					method : "GET",
					url : CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.DOMAIN,
					cache : true,
					params : {
						table : domain.toUpperCase(),
						params : cascading
					}
				}).then(function(response) {
					if (messaggiFctr.processaResponse(response)) {
						deferred.reject(response);
						return;
					}
					if (!skipBlank) {
						cascadingDomain.push({
							cod : "",
							dsc : "Seleziona..."
						});
					}
					for ( var i in response.data.result) {
						cascadingDomain.push(response.data.result[i]);
					}
					deferred.resolve({
						cod : cascading,
						ecz : cascadingDomain
					});
				}, function(reason) {
					messaggiFctr.processaResponse(reason);
					deferred.reject(reason);
				});
	
				return deferred.promise;
			};
	
			this.getLabel = function(domain, key) {
				if (!this.domains) {
					return "";
				}
				var array = this.domains[domain];
				if (!array) {
					return "";
				}
				for ( var i in array) {
					if (array[i].cod === key) {
						return array[i].dsc;
					}
				}
				return "";
			};
	
		} ]);
	}());

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	/**
	 * 
	 */
	(function(window, undefined) {
		"use strict";
		var UserSrvc = function() {
			this.user;
			this.abilitazioni;
			this.abilitazioniPronte;
			this.labelsPronte;
		};
	
		UserSrvc.$inject = [];
	
		angular.module("cbl.insuranceloanpmi.mf").service("UserSrvc", UserSrvc);
	}(window));

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	/**
	 * 
	 */
	(function() {
		"use strict";
		angular.module("cbl.insuranceloanpmi.mf").service("LoggerSrvc", [ "$http", "CONSTANTS", function($http, CONSTANTS) {
			/**
			 * Constants
			 */
			this.SEVERE = "SEVERE";
			this.WARNING = "WARNING";
			this.INFO = "INFO";
			this.CONFIG = "CONFIG";
			this.FINE = "FINE";
			this.FINER = "FINER";
			this.FINEST = "FINEST";
			var LEVELS = [ this.FINEST, this.FINER, this.FINE, this.CONFIG, this.INFO, this.WARNING, this.SEVERE ];
	
			/**
			 * Default value
			 */
			this.loggerLevelString = this.FINEST;
	
			this.loggerLevel = LEVELS.indexOf(this.loggerLevelString);
	
			this.setupLogger = function(baseLevel) {
				if (LEVELS.indexOf(baseLevel) !== -1) {
					this.loggerLevelString = baseLevel;
				}
				this.loggerLevel = LEVELS.indexOf(this.loggerLevelString);
			};
	
			this.levelEnabled = function(level) {
				return this.loggerLevel <= LEVELS.indexOf(level);
			}
	
			this.formattaMessaggio = function(logPayload) {
				var message = "";
				if (typeof logPayload !== 'string') {
					if (Object.prototype.toString.call(logPayload) === '[object Array]') {
						for ( var idx in logPayload) {
							if (typeof logPayload[idx] === 'string') {
								message += ' ' + logPayload[idx];
							} else {
								message += ' ' + JSON.stringify(logPayload[idx]);
							}
						}
					} else {
						message += JSON.stringify(logPayload);
					}
					return message;
				} else {
					return logPayload;
				}
			};
	
			this.log = function(controller, type, message) {
				message = this.formattaMessaggio(message);
	
				var level = LEVELS.indexOf(type);
	
				if (level < this.loggerLevel) {
					return;
				}
	
				$http({
					method : "POST",
					url : CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LOG,
					data : {
						level : type,
						msg : message,
						ctrl : controller
					}
				});
			};
		} ]);
	}());

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	/**
	 * 
	 */
	(function() {
	  'use strict';
	  angular.module('cbl.insuranceloanpmi.mf').factory('CreasModelFctr', function() {
	    var fidoNonOperativo = function() {
	      return {
	        idFidoNonOperativoPMI: null,
	        importoDisponibile: null,
	        importoErogato: null,
	        stato: null,
	        dataApertura: null,
	        dataRinnovo: null,
	        dataFineValidita: null,
	        numPraticaEffettiva: null,
	        contoAppoggio: null,
	        idPraticaFinanziamentoMultiPolizzaPMI: null,
	        fasciaFido: null
	      };
	    };
	
	    var prodotto = function() {
	      return {
	        idProdotto: null,
	        idProdottoCPT: null,
	        codiceProdottoCPT: null,
	        versioneProdottoCPT: null,
	        convenzione: null,
	        descrizione: null,
	        codiceProdottoEsterno: null
	      };
	    };
	
	    var intestatario = function() {
	      return {
	        formaCostitutiva: '',
	        intestazione: '',
	        ndg: '',
	        idAnagrafica: '',
	        relazioniAnagrafiche: []
	      };
	    };
	
	    var pratica = function() {
	      return {
	        idPraticaFinanziamentoMultiPolizzaPMI: null,
	        elencoFinanziamentoMultiPolizzaPMI: [],
	        fidoNonOperativo: fidoNonOperativo(),
	        prodotto: prodotto(),
	        intestatario: intestatario(),
	        idPratica: '',
	        inserimento: null,
	        ultimaModifica: null,
	        specializzazione: null,
	        stato: null,
	        tipo: null,
	        idMacropratica: null,
	        canale: null,
	        filiale: null,
	        codicePromotore: null,
	        incaricato: null,
	        dataPresaInCarico: null,
	        step: null,
	        hidden: null
	      };
	    };
	    return {
	      fidoNonOperativo: fidoNonOperativo,
	      prodotto: prodotto,
	      intestatario: intestatario,
	      pratica: pratica
	    };
	  });
	})();


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc service
	 * @name cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
	 * @restrict E
	 * @scope
	 * @description Servizio che gestisce il processo di creazione nuova pratica e
	 *              visualizzazione pratica esistente
	 */
	(function() {
	  angular
	    .module('cbl.insuranceloanpmi.mf')
	    .service('CreasDettaglioPraticaSrvc', [
	      '$http',
	      '$q',
	      'CreasMessaggiFctr',
	      'CONSTANTS',
	      'LabelSrvc',
	      function($http, $q, messaggiFctr, CONSTANTS, labelSrvc) {
	        this.$http = $http;
	        this.messaggiFctr = messaggiFctr;
	        this.labelSrvc = labelSrvc;
	
	        // Variabili generali pratica
	        this.datiPratica = null;
	        this.datiCliente = null;
	        this.datiClienteBanca = null;
	        this.datiClienteCerved = null;
	        this.firmatariCliente = [];
	
	        this.idPratica = null;
	        this.affidamento = {};
	
	        // Step 2 - Sottostep 1
	        this.firmatario = null;
	        this.fasciaAffidamento = null;
	
	        // Step 3 - Sottostep 1
	        this.firmatarioVerifica = null;
	
	        // Step 4
	        this.ibanAddebito = null;
	
	        // Step 6 - Sottostep 1
	        this.convenzione = null;
	
	        // Step 6 - Sottostep 2 e 3
	        this.titoliAggiunti = [];
	        this.finanziamento = null;
	
	        this.isCancelEnabled = null;
	        this.isCancelFinanziamentoEnabled = null;
	        this.isSaveEnabled = null;
	        this.isPrevEnabled = null;
	        this.isNextEnabled = null;
	        this.isCompleteEnabled = null;
	        this.nextStep = null;
	        this.salva = null;
	        this.completed = null;
	
	        var self = this;
	
	        // Spinner
	        this.spinner = {
	          pratica: false
	        };
	        /**
			 * @ngdoc method
			 * @name isClienteCerved
			 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
			 * @description Indica se l'anagrafica del cliente della pratica in
			 *              lavorazione proviene da Cerved
			 * @return {boolean} - True se i dati del cliente provengono da Cerved,
			 *         False se provengono dal DB Banca
			 */
	        this.isClienteCerved = function() {
	           return self.datiPratica.infoCerved.richiestaAnagrafica;
	        };
	
	        /**
			 * @ngdoc method
			 * @name getDatiCliente
			 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
			 * @description Restituisce i dati del cliente con una struttura
			 *              standard, valorizzata a seconda del tipo di dato
			 *              ottenuto (DB Banca o Cerved)
			 * @return {Object} - I dati del cliente assegnato alla pratica
			 */
	        this.getDatiCliente = function() {
	          if (self.datiCliente) {
	            return self.datiCliente;
	          }
	
	          // Dati cliente banca
	          if (self.datiClienteBanca) {
	            return {
	              idAnagrafica: self.datiClienteBanca.ndg,
	              intestazione: self.datiClienteBanca.intestazione,
	              indirizzoPrincipale: self.datiClienteBanca.indirizzoPrincipale,
	              codiceFiscale: self.datiClienteBanca.codiceFiscale,
	              cciaa: '',
	              naturaGiuridica: self.datiClienteBanca.naturaGiuridica,
	              situazione: '',
	              attivitaEconomica: '',
	              ateco: '',
	              datacost: self.datiClienteBanca.dataNascita
	            };
	          }
	
	          // Dati Cerved
	          if (self.datiClienteCerved) {
	            return {
	              idAnagrafica: null,
	              intestazione: self.datiClienteCerved.intestazione,
	              indirizzoPrincipale: self.datiClienteCerved.indirizzoPrincipale,
	              codiceFiscale: self.datiClienteCerved.codiceFiscale,
	              cciaa: self.datiClienteCerved.numeroCciaaRea,
	              naturaGiuridica: self.datiClienteCerved.formaCostitutiva,
	              situazione: null, // self.datiClienteCerved.statoImpresa,
	              attivitaEconomica:
	                self.datiClienteCerved.settoreAttivitaEconomica,
	              ateco: self.datiClienteCerved.ateco,
	              datacost: self.datiClienteCerved.dataNascita
	            };
	          }
	
	          return null;
	        };
	        
	        /**
			 * @ngdoc method
			 * @name getFinanziamentoBozza
			 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
			 * @description Restituisce il finanziamento in stato bozza per la pratica attiva
			 * @return {Object} - L'oggetto finanziamento in stato bozza presente nella pratica
			 */
	        this.getFinanziamentoBozza = function() {
	
	        	if (self.datiPratica.elencoFinanziamentoMultiPolizzaPMI) {
	        		for (var i=0; i<self.datiPratica.elencoFinanziamentoMultiPolizzaPMI.length; i++) {
	        			if (self.datiPratica.elencoFinanziamentoMultiPolizzaPMI[i].stato === 'BOZZA') {
	        				return self.datiPratica.elencoFinanziamentoMultiPolizzaPMI[i];
	        			}
	        		}
	        	}
	    		
	    		return null;
	        }
	        
	        /**
	    	 * @ngdoc method
	    	 * @name promiseDatiPratica
	    	 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
	    	 * @description Effettua una chiamata http per ricevere i dati della pratica
	    	 * @param {number}
	    	 *            idPratica - ID Della pratica della quale recuperare i dati
	    	 * @return {Promise} - Ritorna una promise contenente i dati della pratica
	    	 */
	        this.promiseDatiPratica = function(idPratica) {
	          return this.$http({
	            method: 'GET',
	            url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICHE.DETTAGLIO + idPratica
	          });
	        };
	       
	
	        /**
			 * @ngdoc method
			 * @name promiseFirmatariCliente
			 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
			 * @description Esegue la chiamata per ottenere i firmatari per il
			 *              cliente indicato
			 * @return {Promise} - Restituisce una promise contenente l'elenco dei
			 *         firmatari per il cliente
			 */
	        this.promiseFirmatariCliente = function() {
	          return this.$http({
	            method: 'GET',
	            url:
	              CONSTANTS.REST_ROOT +
	              CONSTANTS.REST.CLIENTI.DETTAGLIO +
	              self.datiPratica.idPratica +
	              '/firmatari'
	          });
	        };
	        
	        /**
			 * @ngdoc method
			 * @name promiseFirmatariVerificati
			 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
			 * @description Esegue la chiamata per ottenere i firmatari verificati per la pratica indicata
			 * @return {Promise} - Restituisce una promise contenente l'elenco dei firmatari verificati
			 */
	        this.promiseFirmatariVerificati = function() {
	          return this.$http({
	            method: 'GET',
	            url:
	              CONSTANTS.REST_ROOT +
	              CONSTANTS.REST.CLIENTI.DETTAGLIO +
	              self.datiPratica.idPratica +
	              '/firmatariVerificati'
	          });
	        };
	        
	        /**
			 * @ngdoc method
			 * @name promiseFirmatarioPratica
			 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
			 * @description Esegue la chiamata per ottenere il firmatario della pratica
			 * @return {Promise} - Restituisce una promise contenente il firmatario della pratica
			 */
	        this.promiseFirmatarioPratica = function() {
			  var queryParamsObj = {
		        idPratica: self.datiPratica.idPratica,
		        firmatario: true
		      };
	        	
	          return this.$http({
	            method: 'GET',
	            url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CLIENTI.DETTAGLIO_CERCA,
	            params: queryParamsObj
	          });
	        };
	
	        /**
			 * @ngdoc method
			 * @name getFirmatarioPratica
			 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
			 * @description Restituisce il firmatario per la pratica
			 * @return {Object} - I dati del firmatario assegnato alla pratica
			 */
	        this.getFirmatarioPratica = function() {
	          // Firmatario modificato in fase di verifica
	          if (self.firmatarioVerifica) {
	            return self.firmatarioVerifica;
	          }
	
	          // Firmatario originale
	          return self.firmatario;
	        };
	
	        /**
			 * @ngdoc method
			 * @name reset
			 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
			 * @description Ripristina a vuoti tutti i dati della pratica in
			 *              lavorazione
			 */
	        this.reset = function() {
	          self.datiPratica = null;
	          self.datiClienteBanca = null;
	          self.datiClienteCerved = null;
	          self.firmatariCliente = [];
	
	          self.idPratica = null;
	          self.affidamento = {};
	
	          self.firmatario = null;
	          self.fasciaAffidamento = null;
	
	          self.firmatarioVerifica = null;
	
	          self.ibanAddebito = null;
	
	          self.convenzione = null;
	
	          self.titoliAggiunti = [];
	          self.finanziamento = null;
	
	          self.isCancelVisible = null;
	          self.isCancelEnabled = null;
	          self.isCancelFinanziamentoVisible = null;
	          self.isCancelFinanziamentoEnabled = null;
	          self.isSaveEnabled = null;
	          self.isPrevEnabled = null;
	          self.isNextEnabled = null;
	          self.isCompleteEnabled = null;
	          self.nextStep = null;
	          self.salva = null;
	          self.completed = null;
	        };
	        
	        /**
			 * @ngdoc method
			 * @name verificaImportiPolizze
			 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
			 * @description Esegue il controllo di verifica degli importi delle polizze aggiunte alla pratica
			 * @param {number} importoNuovaPolizza - Facoltativo, importo della polizza che si sta aggiungendo
			 * @return {Boolean} - Restituisce true se la somma delle polizze aggiunte rispetta i criteri per il salvataggio, false se vi sono state eccezioni
			 */
	        this.verificaImportiPolizze = function(importoNuovaPolizza) {
	        	var sommaPolizze = self.calcolaImportoPolizze(importoNuovaPolizza);
				
				if (
					self.datiPratica.elencoFinanziamentoMultiPolizzaPMI && self.datiPratica.elencoFinanziamentoMultiPolizzaPMI.length === 1
					&& sommaPolizze < 1000
				) {
					self.messaggiFctr.addMessage({ type: 'W', message: self.labelSrvc.getLabel('label.dettagliopratica.step6.sub3.importominimo') });
					return;
				}
				
				//Se il fido è in stato diverso da "DA_EROGARE" verifico importo disponibile, altrimenti l'importo massimo della fascia fido
				if ((self.datiPratica.fidoNonOperativo.stato !== 'DA_EROGARE' && sommaPolizze > self.datiPratica.fidoNonOperativo.importoDisponibile) || 
						(self.datiPratica.fidoNonOperativo.stato === 'DA_EROGARE' && sommaPolizze > self.datiPratica.fidoNonOperativo.fasciaFido.importoMassimo )) {
					self.messaggiFctr.addMessage({ type: 'W', message: self.labelSrvc.getLabel('label.dettagliopratica.step6.sub3.superatadisponibilita') });
					return;
				}
	        	
	        	return true;
	        }
	        
	        /**
			 * @ngdoc method
			 * @name calcolaImportoPolizze
			 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
			 * @description Restituisce la somma delle polizze selezionate
			 * @param {number} importoNuovaPolizza - Facoltativo, importo della polizza che si sta aggiungendo
			 * @return {number} - La somma delle polizze selezionate
			 */
	        this.calcolaImportoPolizze = function(importoNuovaPolizza) {
	        	var sommaPolizze = 0;
	        	
	        	if (importoNuovaPolizza && importoNuovaPolizza > 0) {
	        		sommaPolizze = importoNuovaPolizza;
	        	}
	        	
	        	if (self.finanziamento && self.finanziamento.elencoPolizze) {        		
	        		for(var i=0; i < self.finanziamento.elencoPolizze.length; i++) {
	        			sommaPolizze = sommaPolizze + self.finanziamento.elencoPolizze[i].importoPremio;
	        		}
	        	}
	        	
	        	return sommaPolizze;
	        }
	        
	        /**
	    	 * @ngdoc method
	    	 * @name isPraticaNavigabile
	    	 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
	    	 * @description Verifica se la pratica è in stato AFFIDATA, e quindi navigabile
	    	 * @return {Boolean} - True se la pratica è navigabile, false in caso contrario
	    	 */
	        this.isPraticaNavigabile = function() {
	          if (!self.datiPratica) {
	        	  return false;
	          }
	          
	          return self.datiPratica.stato && (self.datiPratica.stato === 'AFFIDATA' || self.datiPratica.stato === 'CONCLUSA');
	        };
	
	        /**
			 * @ngdoc method
			 * @name salvaFido
			 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
			 * @description Esegue la chiamata per salvare la richiesta fido
		     * @param {string} pathstring - Facoltativo, stringa da aggiungere al path per invocare il servizio
			 * @return {Promise} - Restituisce una promise contenente la pratica aggiornata
			 */
	        this.promiseSalvaFido = function(pathString) {
	          var path = '';
	          if (pathString) {
	            path = pathString;
	          }
	          return this.$http({
	            method: 'PUT',
	            url:
	              CONSTANTS.REST_ROOT +
	              CONSTANTS.REST.AFFIDAMENTI.FIDO +
	              this.datiPratica.fidoNonOperativo.idFidoNonOperativoPMI +
	              path,
	            data: this.datiPratica
	          });
	        };
	
	        /**
			 * @ngdoc method
			 * @name avanzaStep
			 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
			 * @description Esegue la chiamata per far avanzare allo step successivo
		     * @param {string} stepString - stringa che indica a quale step avanzare
			 * @return {Promise} - Restituisce una promise contenente la pratica aggiornata
			 */
	        //per muoversi dentro i micro step si passa come stepString rispettivamente /avantiStep e /indietroStep
	        this.promiseCambiaStep = function(stepString) {
	          return this.$http({
	            method: 'PUT',
	            url:
	              CONSTANTS.REST_ROOT +
	              CONSTANTS.REST.PRATICHE.DETTAGLIO +
	              this.datiPratica.idPratica +
	              stepString
	          });
	        };
	
	        /**
			 * @ngdoc method
			 * @name promiseConvenzioni
			 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
			 * @description Effettua una chiamata http per recuperare le convenzioni
			 * @return {Promise} - Ritorna una promise contenente le convenzioni
			 */
	        this.promiseConvenzioni = function() {
	          return this.$http({
	            method: 'GET',
	            url:
	              CONSTANTS.REST_ROOT +
	              CONSTANTS.REST.CONVENZIONI +
	              '/' +
	              this.datiPratica.idPratica
	          });
	        };
	
	        /**
			 * @ngdoc method
			 * @name promiseSalvataggioIban
			 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
			 * @description Effettua una chiamata http per eseguire il salvataggio del codice IBAN per la pratica
			 * @return {Promise} - Ritorna una promise contenente l'oggetto contoAppoggio da aggiungere nella pratica
			 */
	        this.promiseSalvataggioIban = function(iban) {
	          this.spinner.conto = true;
	          return this.$http({
	            method: 'GET',
	            url: CONSTANTS.REST_ROOT + CONSTANTS.REST.DETTAGLIO_CONTO,
	            params: {codiceIban: iban}
	          });
	        };
	
	        /**
			 * @ngdoc method
			 * @name promiseSalvaConvenzione
			 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
			 * @description Effettua una chiamata http per eseguire il salvataggio della convenzione selezionata
			 * @return {Promise} - Ritorna una promise contenente la pratica aggiornata
			 */
	        this.promiseSalvaConvenzione = function() {
	          return this.$http({
	            method: 'PUT',
	            url:
	              CONSTANTS.REST_ROOT +
	              CONSTANTS.REST.PRATICHE.DETTAGLIO +
	              this.datiPratica.idPratica +
	              '/convenzione',
	            data: this.convenzione
	          });
	        };
	        
	        /**
			 * @ngdoc method
			 * @name promiseSalvaPolizze
			 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
			 * @description Effettua una chiamata http per eseguire il salvataggio delle polizze assegnate alla pratica
			 * @return {Promise} - Ritorna una promise contenente il finanziamento aggiornato
			 */
	        this.promiseSalvaPolizze = function() {
	        	
	          return this.$http({
	            method: 'PUT',
	            url:
	              CONSTANTS.REST_ROOT +
	              CONSTANTS.REST.FINANZIAMENTI + '/' +
	              this.finanziamento.idFinanziamentoPMI,
	            data: this.finanziamento
	          });
	        };
	        
	               
	        /**
			 * @ngdoc method
			 * @name promiseCompletaFinanziamento
			 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
			 * @description Effettua una chiamata http per eseguire il completamento del finanziamento
			 * @return {Promise} - Ritorna una promise contenente il finanziamento aggiornato
			 */
	        this.promiseCompletaFinanziamento = function(fase) {
	          return this.$http({
	            method: 'PUT',
	            url:
	              CONSTANTS.REST_ROOT +
	              CONSTANTS.REST.PRATICHE.DETTAGLIO +
	              this.datiPratica.idPratica + 
	              '/completaFinanziamento/fase'+fase+'/',
	            data: this.finanziamento
	          });
	        };
	        
	              
	        /**
			 * @ngdoc method
			 * @name promiseCheckDocumenti
			 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
			 * @description Effettua una chiamata http per verificare che i documenti della pratica siano tutti validi
			 * @param {number} idPratica - l'ID della pratica da verificare
			 * @param {number} idFinanziamento - Opzionale, l'ID del finanziamento da verificare
			 * @return {Promise} - Ritorna una promise contenente l'esito della validazione (true/false)
			 */
	        this.promiseCheckDocumenti = function(idPratica, idFinanziamento) {
	        	var qryParams = {
	          		  idPratica: idPratica
	            };
	            
	            if (idFinanziamento) {
	          	  qryParams['idFinanziamento'] = idFinanziamento;
	            }
	          	
	            return this.$http({
	              method: 'GET',
	              url:
	                CONSTANTS.REST_ROOT +
	                CONSTANTS.REST.PRATICHE.DETTAGLIO +
	                'checkDocumenti',
	              params: qryParams
	            });
	        };
	        
	        /**
			 * @ngdoc method
			 * @name promiseCheckDocumenti
			 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
			 * @description Effettua una chiamata http per verificare che i documenti della pratica siano tutti validi
			 * @param {number} idPratica - l'ID della pratica da verificare
			 * @param {number} idFinanziamento - Opzionale, l'ID del finanziamento da verificare
			 * @return {Promise} - Ritorna una promise contenente l'esito della validazione (true/false)
			 */
	        this.promiseCheckPratichePropedeutiche = function(idPratica) {
	        	var qryParams = {
	          		  idPratica: idPratica
	            };
	            
	            return this.$http({
	              method: 'GET',
	              url:
	                CONSTANTS.REST_ROOT +
	                CONSTANTS.REST.PRATICHE.DETTAGLIO +
	                'checkPratichePropedeutiche',
	              params: qryParams
	            });
	        };
	        
	        /**
			 * @ngdoc method
			 * @name promiseFirmaDocumenti
			 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
			 * @description Effettua una chiamata http per firmare i documenti della pratica indicata
			 * @param {number} idPratica - l'ID della pratica per la quale firmare i documenti
			 * @param {number} idFinanziamento - Opzionale, l'ID del finanziamento per il quale firmare i documenti
			 * @return {Promise} - Ritorna una promise contenente l'esito della validazione (true/false)
			 */
	        this.promiseFirmaDocumenti = function(idPratica, idFinanziamento) {
	        	var qryParams = {
	          		  idPratica: idPratica
	            };
	            
	            if (idFinanziamento) {
	          	  qryParams['idFinanziamento'] = idFinanziamento;
	            }
	          	
	            return this.$http({
	              method: 'GET',
	              url:
	                CONSTANTS.REST_ROOT +
	                CONSTANTS.REST.PRATICHE.DETTAGLIO +
	                'firmaDocumenti',
	              params: qryParams
	            });
	        };
	        
	        
	        /**
	    	 * @ngdoc method
	    	 * @name promiseDatiClienteIntegrazione
	    	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasAffidamentoDocumenti
	    	 * @description Effettua una chiamata http per recuperare i dati del cliente
	    	 *              e dei firmatari
	    	 * @return {Promise} - Ritorna una promise contenente i dati del cliente e
	    	 *         dei firmatari
	    	 */
	        this.promiseDatiClienteIntegrazione = function() {
	          var queryParamsObj = {
	            idPratica: this.datiPratica.idPratica
	          };
	
	          return this.$http({
	            method: 'GET',
	            url:
	              CONSTANTS.REST_ROOT + CONSTANTS.REST.CLIENTI.DETTAGLIO_INTEGRAZIONE,
	              params: queryParamsObj
	          });
	        };
	        
	        /**
	    	 * @ngdoc method
	    	 * @name promiseAccettaPersonaFisica
	    	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasAffidamentoDocumenti
	    	 * @description Effettua una chiamata http che conferma la trasformazione da prospetto a cliente della persona fisica
	    	 * @return {Promise} - Ritorna una promise per eseguire la conferma della persona fisica
	    	 */
	    	this.promiseAccettaPersonaFisica = function(idPraticaAnagrafica) {
	    		var dataObj = {
	    			idPratica: idPraticaAnagrafica,
	    			nota: ''
	    		};
	    		
	    		return this.$http({
	    			method: 'POST',
	    			url: CONSTANTS.REST_CLIENTI_ROOT + CONSTANTS.REST.PERSONAFISICA.ACCETTASENZAWCL,
	    			data: dataObj
	    		});
	    	}
	    	
	    	/**
	    	 * @ngdoc method
	    	 * @name promiseAccettaPersonaGiuridica
	    	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasAffidamentoDocumenti
	    	 * @description Effettua una chiamata http che conferma la trasformazione da prospetto a cliente della persona giuridica
	    	 * @return {Promise} - Ritorna una promise per eseguire la conferma della persona giuridica
	    	 */
	    	this.promiseAccettaPersonaGiuridica = function(idPraticaAnagrafica, formaCostitutiva) {
	    		var dataObj = {
	    			idPratica: idPraticaAnagrafica,
	    			nota: ''
	    		};
	    		
	    		switch(formaCostitutiva) {
	    			case "IND":
	    				return this.$http({
	    					method: 'POST',
	    					url: CONSTANTS.REST_CLIENTI_ROOT + CONSTANTS.REST.PERSONAFISICA.ACCETTASENZAWCL,
	    					data: dataObj
	    				});
	    			default:
	    				return this.$http({
	    					method: 'POST',
	    					url: CONSTANTS.REST_CLIENTI_ROOT + CONSTANTS.REST.PERSONAGIURIDICA.ACCETTASENZAWCL,
	    					data: dataObj
	    				});				
	    		}
	    	}
	      }
	    ]);
	})();


/***/ }),
/* 40 */
/***/ (function(module, exports) {

	/**
	 * 
	 */
	(function() {
		angular.module("cbl.insuranceloanpmi.mf").service("CreasRicercaClienteSrvc", [ function() {
			/* Valore del campo partita iva/codice fiscale nei filtri di ricerca */
		    this.pivacfisc = null;
		    /* Flag che visualizza il messaggio di nessun record trovato */
		    this.noResultsFlag = false;
		    /* Flag che indica l'abilitazione della ricerca su cerved */
		    this.ricercaCerved = false;
		    /* Tabella Clienti Banca */
		    this.clientiBancaTableData = null;
		    /* Tabella Clienti Cerved */
		    this.clientiCervedTableData = null;
			/* Variabile per determinare se preservare la ricerca in caso di cambio rotta */
		    this.preserveSearch = false;
		} ]);
	}());


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	/**
	 *
	 */
	(function (window, undefined) {
	  'use strict';
	  var Run = function (
	    $http,
	    $q,
	    userSrvc,
	    messaggiFctr,
	    labelSrvc,
	    loggerSrvc,
	    CONSTANTS,
	    ssocoreServices
	  ) {
	    var userSrvcDefer = $q.defer();
	    var labelSrvcDefer = $q.defer();
	    userSrvc.abilitazioniPronte = userSrvcDefer.promise;
	    labelSrvc.labelsPronte = labelSrvcDefer.promise;
	
	    ssocoreServices.caricaContesto(
	      function (response) {
	        if (
	          ssocoreServices.caricaFunzionalita(
	            response,
	            'CreditoAssicurativoPMIAbilitato'
	          )
	        ) {
	          startAbilitazioniPromise();
	          startLabelsPromise();
	          startLoggerPromise();
	        }
	      },
	      function (reason) {}
	    );
	
	    var startAbilitazioniPromise = function () {
	      $http({
	        method: 'GET',
	        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.USER,
	      }).then(
	        function (response) {
	          if (messaggiFctr.processaResponse(response)) {
	            userSrvcDefer.reject(response);
	            return;
	          }
	          userSrvc.user = response.data.profile;
	          userSrvc.abilitazioni = response.data.abilitazioni;
	          if (window.CblBrioLoader) {
	            CblBrioLoader.hideLoader();
	          }
	          userSrvcDefer.resolve(true);
	        },
	        function (reason) {
	          messaggiFctr.processaResponse(reason);
	          userSrvcDefer.reject(reason);
	        }
	      );
	    };
	
	    var startLabelsPromise = function () {
	      $http({
	        method: 'GET',
	        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LABEL,
	      }).then(
	        function (response) {
	          if (messaggiFctr.processaResponse(response)) {
	            labelSrvcDefer.reject(response);
	            return;
	          }
	          labelSrvc.labels = response.data.result;
	          labelSrvcDefer.resolve(true);
	        },
	        function (reason) {
	          messaggiFctr.processaResponse(reason);
	          labelSrvcDefer.reject(reason);
	        }
	      );
	    };
	
	    var startLoggerPromise = function () {
	      $http({
	        method: 'GET',
	        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LOG,
	      }).then(
	        function (response) {
	          if (messaggiFctr.processaResponse(response)) {
	            return;
	          }
	          loggerSrvc.setupLogger(response.data.result);
	          // FIXME: riabilitare per gestire correttamente i permessi
	          labelSrvc.develop = loggerSrvc.levelEnabled(loggerSrvc.FINE);
	        },
	        function (reason) {
	          messaggiFctr.processaResponse(reason);
	        }
	      );
	    };
	  };
	
	  Run.$inject = [
	    '$http',
	    '$q',
	    'UserSrvc',
	    'CreasMessaggiFctr',
	    'LabelSrvc',
	    'LoggerSrvc',
	    'CONSTANTS',
	    'ssocoreServices',
	  ];
	  angular.module('cbl.insuranceloanpmi.mf').run(Run);
	})(window);


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	/**
	 * 
	 */
	
	(function(window, undefined) {
		"use strict";
		var Route = function($stateProvider, $urlRouterProvider) {
			var onEnter = [ 'CblMessageSrvc', function(messaggiSrvc) {
				messaggiSrvc.reset();
			} ];
	
			$stateProvider
					.state(
						"creas-ricerca-pratiche",
						{
							url : "/creas-ricerca-pratiche?intestazione&stato&dataDa&dataA",
							template : "<creas-ricerca-pratiche " +
									"class=\"wrapper\"></creas-ricerca-pratiche>",
							onEnter : onEnter,
							ncyBreadcrumb : {
								label : "Ricerca Pratiche",
								parent : "home"
							},
							params: {
								intestazione : {
									value: '',
									squash: true
								},
								stato : {
									value: '',
									squash: true
								},
								dataDa : {
									value: null,
									squash: true
								},
								dataA : {
									value: null,
									squash: true
								}
							}
						})
					.state(
						"creas-ricerca-cliente",
						{
							url : "/creas-ricerca-cliente",
							template : "<creas-ricerca-cliente " +
									"class=\"wrapper\"></creas-ricerca-cliente>",
							onEnter : onEnter,
							ncyBreadcrumb : {
								label : "Ricerca Cliente",
								parent : "creas-ricerca-pratiche"
							}
						})
					.state(
						"creas-nuova-pratica",
						{
							url : "/creas-nuova-pratica/:ndg/:codProdotto",
							template : "<creas-dettaglio-pratica " +
									"class=\"wrapper\"></creas-dettaglio-pratica>",
							onEnter : onEnter,
							ncyBreadcrumb : {
								label : "Nuova Pratica",
								parent : "home"
							}
						})
					.state(
						"creas-dettaglio-pratica",
						{
								url : "/creas-dettaglio-pratica/:ndg/:idPratica",
							template : "<creas-dettaglio-pratica " +
									"class=\"wrapper\"></creas-dettaglio-pratica>",
							onEnter : onEnter,
							ncyBreadcrumb : {
								label : "Dettaglio Pratica",
								parent : "home"
							}
						})
					.state(
						"creas-dettaglio-affidamento",
						{
							url : "/creas-dettaglio-affidamento/:ndg",
							template : "<creas-affidamento class=\"wrapper\"></creas-affidamento>",
							onEnter : onEnter,
							parentState: 'schedaCliente',
							ncyBreadcrumb : {
								label : "Dettaglio Affidamento",
								parent : "schedaCliente"
							}
						});
		};
	
		Route.$inject = [ "$stateProvider", "$urlRouterProvider" ];
	
		angular.module("cbl.insuranceloanpmi.mf").config(Route);
	}(window));


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// brio.bundle.min.js